/* eslint-disable prettier/prettier */
module.exports = {
  app: "App",
  news: "News",
  component: "Component",
  download: "Download",
  downloading: "Downloading",
  unableToDownload: "Unable to download",
  features: "Features",
  applications: "Applications",
  dashboard: "Dashboard",
  customers: "Customers",
  warehouses: "Warehouses",
  management: "Management",
  carriers: "Carriers",
  operations: "Operations",
  warehousing: "Warehousing",
  quote: "Quote",
  business: "Business",
  invoices: "Invoices",
  prepayments: "Prepayments",
  billsToPay: "Bills to Pay",
  modules: "Modules",
  agency: "Agency",
  pages: "Pages",
  page: "page",
  gallery: "Gallery",
  pricing: "Pricing",
  privacyPolicy: "Privacy Policy",
  feedback: "Feedback",
  report: "Report",
  faqS: "Faq(s)",
  advanceComponent: "Advance Component",
  blank: "Blank",
  session: "Session",
  login: "Login",
  reset: "Reset",
  register: "Register",
  lockScreen: "Lock Screen",
  forgotPassword: "Forgot Password",
  forgotYourPassword: "Forgot your password?",
  letsGetYouBackIn: "Let's get you back in",
  recoverPassword: "Recover Password",
  dontWorryJustEnterYourEmailAddressBelowAndWellAssistYou:
    "Don't worry! Just enter your email address below, and we'll assist you.",
  withInstructionsToResetYourPassword: "with instructions to reset your password",
  checkYourEmail: "Check your email",
  emailNotReceived: "Email not received?",
  resend: "Resend",
  uiComponents: "UI Components",
  alerts: "Alerts",
  appBar: "App Bar",
  avatars: "Avatars",
  buttons: "Buttons",
  bottomNavigations: "Bottom Navigations",
  badges: "Badges",
  cards: "Cards",
  cardsMasonry: "Cards Masonry",
  chip: "Chip",
  dialog: "Dialog",
  dividers: "Dividers",
  drawers: "Drawers",
  draft: "Draft",
  totalQuotes: "Total Quotes",
  inspect: "Inspect",
  expansionPanel: "Expansion Panel",
  gridList: "Grid List",
  list: "List",
  menu: "Menu",
  popOverTooltip: "Pop Over & ToolTip",
  progress: "Progress",
  snackbar: "Snackbar",
  selectionControls: "Selection Controls",
  dateTimePicker: "Date & Time Picker",
  tabs: "Tabs",
  stepper: "Stepper",
  notification: "Notification",
  notifications: "Notifications",
  sweetAlert: "Sweet Alert",
  autoComplete: "Auto Complete",
  aboutUs: "About Us",
  widgets: "Widgets",
  forms: "Forms",
  formElements: "Form Elements",
  textField: "Text Field",
  selectList: "Select List",
  charts: "Charts",
  reCharts: "Re Charts",
  reactChartjs2: "React Chartjs 2",
  icons: "Icons",
  themifyIcons: "Themify Icons",
  simpleLineIcons: "Simple Line Icons",
  materialIcons: "Material Icons",
  tables: "Tables",
  basic: "Basic",
  dataTable: "Data Table",
  responsive: "Responsive",
  maps: "Maps",
  googleMaps: "Google Maps",
  leafletMaps: "Leaflet Maps",
  inbox: "Inbox",
  users: "Users",
  userProfile1: "User Profile 1",
  userProfile2: "User Profile 2",
  userManagement: "User Management",
  userList: "User List",
  calendar: "Calendar",
  cultures: "Cultures",
  selectable: "Selectable",
  customRendering: "Custom Rendering",
  chat: "Chat",
  todo: "ToDo",
  editor: "Editor",
  wysiwygEditor: "WYSIWYG Editor",
  quillEditor: "Quill Editor",
  dragAndDrop: "Drag And Drop",
  reactDragula: "React Dragula",
  reactDnd: "React Dnd",
  ecommerce: "Ecommerce",
  shopList: "Shop List",
  shopGrid: "Shop Grid",
  invoice: "Invoice",
  crm: "CRM",
  ratings: "Ratings",
  number: "Number",
  welcomeBack: "Welcome back!",
  pleaseCreateANewPasswordForYourAccount: "Please create a new password for your account",
  emailOrUsername: "Email or username",
  rememberMe: "Remember me",
  notRegisteredYet: "Not registered yet?",
  clickToResend: "Click to resend",
  clickHere: "click here.",
  youWillBeRedirectedToTheSignInPageIfYouAreNotRedirectedAutomatically:
    "You will be redirected to the sign in page. If you are not redirected automatically, ",
  createAnAccount: "Create an account",
  web: "Web",
  done: "Done",
  inProgress: "In Progress",
  waiting: "Waiting",
  subscribed: "Subscribed",
  searchItem: "Search Item",
  startDate: "Start Date",
  endDate: "End Date",
  password: "Password",
  newPassword: "New password",
  createNewPassword: "Create new password",
  filters: "Filters",
  private: "Private",
  corporate: "Corporate",
  name: "Name",
  volume: "Volume",
  sidebarOverlay: "Sidebar Overlay",
  appSettings: "App Settings",
  sidebarImage: "Sidebar Image",
  miniSidebar: "Mini Sidebar",
  boxLayout: "Box Layout",
  rtlLayout: "Rtl Layout",
  darkMode: "Dark Mode",
  light: "Light",
  dark: "Dark",
  refresh: "Refresh",
  refreshing: "Refreshing",
  record: "Record",
  play: "Play",
  start: "Start",
  cancel: "Cancel",
  copy: "Copy",
  send: "Send",
  add: "Add",
  update: "Update",
  confirm: "Confirm",
  delete: "Delete",
  yes: "Yes",
  no: "No",
  addNewContact: "Add new contact",
  editAContact: "Edit a contact",
  addNewLocation: "Add new location",
  editALocation: "Edit a location",
  summary: "Summary",
  week: "Week",
  weekday: "Weekday",
  month: "Month",
  firstName: "First name",
  lastName: "Last name",
  address: "Address",
  description: "Description",
  total: "Total",
  selectRoom: "Select Room",
  selectDescription: "Select Description",
  addNew: "Add new",
  revoke: "Revoke",
  assign: "Assign",
  save: "Save",
  saveComment: "Save Comment",
  create: "Create",
  savePublishTask: "Save & Publish Task",
  accept: "Accept",
  accepted: "Accepted",
  complete: "Complete",
  back: "Back",
  ok: "Ok",
  next: "Next",
  saveChanges: "Save Changes",
  cancelChanges: "Cancel Changes",
  more: "More",
  remove: "Remove",
  changePhoto: "Change photo",
  booking: "Booking",
  enterBooking: "Enter booking",
  user: "User",
  promo: "Promo",
  themeColor: "Theme Color",
  selectProject: "Select Project",
  shop: "Shop",
  cart: "Cart",
  checkout: "Checkout",
  product: "Product",
  removeProduct: "Remove Product",
  noItemFound: "No Item Found",
  saas: "SAAS",
  multilevel: "MultiLevel",
  level1: "Level 1",
  level2: "Level 2",
  imageCropper: "Image Cropper",
  videoPlayer: "Video Player",
  dropzone: "Dropzone",
  cropImage: "Crop Image",
  preview: "Preview",
  projects: "Projects",
  projectDetail: "Project Detail",
  clients: "clients",
  shipments: "Shipments",
  editShipment: "Edit Shipment",
  viewShipment: "View Shipment",
  newShipment: "New Shipment",
  loadBy: "Load by",
  createShipment: "Create Shipment",
  products: "Products",
  latestScan: "Latest Scan",
  dateOfLoading: "Date of loading",
  editProduct: "Edit Product",
  newProduct: "New Product",
  noProductsToShow: "No Products to show",
  theProductWasRemovedSuccesfully: "The product was removed succesfully",
  containers: "Containers",
  settings: "Settings",
  cartonQuantity: "Carton Quantity",
  palletQuantity: "Pallet Quantity",
  despatches: "Despatches",
  edit: "Edit",
  details: "Details",
  detail: "Detail",
  locations: "Locations",
  comments: "Comments",
  estimatedDates: "Estimated dates",
  destinationWh: "Destination WH",
  vessel: "Vessel",
  vesselName: "Vessel Name",
  travel: "Travel",
  container: "Container",
  containerType: "Container Type",
  selectContainerType: "Select Container Type",
  shipmentType: "Shipment Type",
  containerNumbers: "Container Numbers",
  grossWeight: "Gross weight",
  inputWeight: "Input Weight",
  project: "Project",
  totalQuantity: "Total Quantity",
  totalPallets: "Total Pallets",
  eta: "ETA",
  etaFinalPort: "ETA Final Port",
  etaWarehouse: "ETA Warehouse",
  pickUpDate: "Pick up Date",
  scanDate: "Scan Date",
  departureDate: "Date of Departure",
  arrivalAtDestination: "Date of Delivery",
  hawb: "HAWB",
  flightNumber: "Flight Number",
  airline: "Airline",
  etaUnpackData: "ETA Unpack Data",
  actualDates: "Actual dates",
  agent: "Agent",
  agentId: "Agent ID",
  agentParentCode: "Agent parent ID",
  email: "Email",
  businessAddress: "Business Address",
  businessContacts: "Business Contacts",
  businessName: "Business Name",
  businessNumber: "Business number",
  businessRegistration: "Business Registration",
  businessRegistrationNumber: "Business Registration Number",
  mainEmailAddress: "Main email address",
  website: "Website",
  bodyType: "Body Type",
  fuelType: "Fuel Type",
  condition: "Condition",
  engine: "Engine",
  ownership: "Ownership",
  branch: "Branch",
  fleetStatus: "Fleet Status",
  dryStandard: "Dry Standard",
  dryHigh: "Dry High",
  tank: "Tank",
  open: "Open",
  openTop: "Open Top",
  openTopHigh: "Open Top High",
  flat: "Flat",
  flatStandard: "Flat Standard",
  flatHigh: "Flat High",
  reeferStandard: "Reefer Standard",
  reeferHigh: "Reefer High",
  po: "PO #",
  sku: "SKU",
  itemRemovedSuccessfully: "Item removed successfully!",
  import: "Import",
  export: "Export",
  importCsvFile: "Import CSV file",
  printDeliveryDocket: "Print Delivery Docket",
  despatch: "Despatch",
  qtyOfCartonsDespatched: "Qty of Cartons Despatched",
  qtyOfPalletsDespatched: "Qty of Pallets Despatched",
  ofDespatches: "# of Despatches",
  ofOrdersDespatched: "# of Orders Despatched",
  stockOnHand: "Stock on hand",
  stockOnHandDetailed: "Stock on hand - Detailed",
  crossDockStatus: "Cross-Dock Status",
  packing: "Packing",
  addMaterial: "Add Material",
  fillAllFieldsToSave: "Fill all fields to save",
  addItem: "Add item",
  instructionStatus: "Instruction status",
  selectWhen: "Select When",
  addInstruction: "Add Instruction",
  availableInstructions: "Available Instructions",
  remark: "Remark",
  inputYourRemarkAndPressEnter: "Input your remark and press enter",
  uplift: "Uplift",
  coordinator: "Coordinator",
  selectedInstructions: "selected instructions",
  selectAStatus: "Select a status",
  applyChooseLocations: "Apply & choose locations",
  filterConditions: "Filter Conditions",
  filterLocations: "Filter Locations",
  conditions: "Conditions",
  typeOfPacking: "Type of Packing",
  itemStatus: "Item Status",
  itemNumber: "Item Number",
  width: "Width",
  length: "Length",
  leader: "Leader",
  searchLeader: "Search Leader",
  staffs: "Staffs",
  searchForStaff: "Search for staff",
  fleets: "Fleets",
  searchForFleet: "Search for fleet",
  height: "Height",
  cartonPerPallet: "Carton per Pallet",
  palletHeight: "Pallet Height",
  heightWithPallet: "Height with Pallet",
  heightIncPallet: "Height inc Pallet",
  ti: "Ti",
  hi: "Hi",
  selectProductsBelowToAddThem: "Select products below to add them",
  productSkuSearch: "Product (SKU) Search",
  productName: "Product Name",
  originCriterion: "Origin Criterion",
  originCriterionMustBeWOrP: "Origin Criterion must be either 'W' or 'P'",
  shippingItem: "Shipping Item",
  truckTransport: "Truck/Transport",
  customerName: "Customer name",
  addNewProject: "Add New Project",
  projectName: "Project Name",
  projectCustomer: "Project Customer",
  importFiles: "Import Files",
  fileHistory: "File History",
  projectCreatedWithSuccess: "Project created with success!",
  uploadNewFile: "Upload New File",
  imapHost: "IMAP Host",
  imapPort: "IMAP Port",
  emailUser: "Email User",
  emailPassword: "Email Password",
  useTls: "Use TLS",
  addNewComment: "Add new comment",
  typeYourCommentHere: "Type your comment here",
  order: "Order",
  origin: "Origin",
  originCriterion: "Origin Criterion",
  originCriterionMustBeWOrP: "Origin Criterion must be 'W' or 'P'",
  destination: "Destination",
  type: "Type",
  dateCreated: "Date created",
  dateUpdated: "Date updated",
  buyerName: "Buyer name",
  shipVia: "Ship via",
  shipTo: "Ship to",
  incoterm: "Incoterm",
  createNewSupplier: "Create new supplier",
  fulfilled: "Fulfilled",
  quantityOrdered: "Quantity ordered",
  quantityRequested: "Quantity requested",
  quantityFullfilled: "Quantity fullfilled",
  variation: "Variation",
  switchToActualInventory: "Switch to Actual Inventory",
  switchToQuotedInventory: "Switch to Quoted Inventory",
  switchToEstimatedInventory: "Switch to Estimated Inventory",
  searchByNameOrEmail: "Search by name or email",
  supplierDetails: "Supplier Details",
  supplier: "Supplier",
  supplierName: "Supplier name",
  supplierCode: "Supplier Code",
  address1: "Address 1",
  address2: "Address 2",
  suburbTown: "Suburb/Town",
  streetNumber: "Street Number",
  postalCode: "Postal Code",
  state: "State",
  country: "Country",
  contactName: "Contact Name",
  locationStatus: "Location status",
  filterByShipment: "Filter by Shipment #",
  noInformationToBeShown: "No information to be shown.",
  loadingShipments: "Loading Shipments",
  loadingDispatches: "Loading Dispatches",
  loadingSuppliers: "Loading Suppliers...",
  loadingNotifications: "Loading Notifications",
  task: "Task",
  usedBy: "Used by",
  fleetNumber: "Fleet number",
  make: "Make",
  model: "Model",
  body: "Body",
  position: "Position",
  username: "Username",
  location: "Location",
  mainContact: "Main Contact",
  role: "Role",
  rooms: "Rooms",
  fullName: "Full name",
  symbol: "Symbol",
  decimalPoints: "Decimal Points",
  lastUpdate: "Last Update",
  lastModified: "Last Modified",
  flatFee: "Flat Fee",
  hourlyFee: "Hourly Fee",
  halfHourFee: "Half Hour Fee",
  triggers: "Triggers",
  tasksType: "Tasks Type",
  jobsType: "Jobs Type",
  branches: "Branches",
  updated: "Updated",
  color: "Color",
  icon: "Icon",
  packaging: "Packaging",
  configuration: "Configuration",
  currency: "Currency",
  currencies: "Currencies",
  measurements: "Measurements",
  addCustomCurrency: "Add custom currency",
  displayUnit: "Display unit",
  languages: "Languages",
  prefix: "Prefix",
  language: "Language",
  room: "Room",
  types: "Types",
  descriptiveSymbol: "Descriptive Symbol",
  descriptiveSymbols: "Descriptive Symbols",
  exceptionSymbol: "EXCEPTION SYMBOL",
  exceptionSymbols: "Exception Symbols",
  locationSymbol: "LOCATION SYMBOL",
  locationSymbols: "Location Symbols",
  photoIsMandatory: "Photo is mandatory",
  selectTheRoom: "Select the room",
  editRoom: "Edit room",
  addNewType: "Add new type",
  editType: "Edit type",
  addNewDescriptiveSymbol: "Add new descriptive symbol",
  selectSymbol: "Select Symbol",
  editDescriptiveSymbol: "Edit descriptive symbol",
  addNewExceptionSymbol: "Add new exception symbol",
  editExceptionSymbol: "Edit exception symbol",
  addNewLocationSymbol: "Add new location symbol",
  editLocationSymbol: "Edit location symbol",
  addNewOne: "Add new one",
  createFleet: "Create Fleet",
  editFleet: "Edit Fleet",
  viewFleet: "View Fleet",
  editThisFleet: "Edit this fleet",
  addANewFleet: "Add a new fleet",
  viewThisFleet: "View this fleet",
  vinNumber: "Vin Number",
  year: "Year",
  engineType: "Engine type",
  plateNumber: "Plate number",
  addCondition: "Add Condition",
  typeMode: "Type Mode",
  warehouse: "Warehouse",
  searchForWarehouse: "Search for warehouse",
  searchForBranch: "Search for branch",
  capacity: "Capacity",
  capacityOfEachLiftvan: "Capacity of each Liftvan",
  volumeCapacityM3: "Volume Capacity (m³)",
  weightCapacityKG: "Weight Capacity (Kg)",
  outOfService: "Out of service",
  serialNumber: "Serial Number",
  inputSerialNumber: "Input Serial Number",
  mechanicalElectricalChecklist: "Mechanical & Electrical Checklist",
  hasTheMEChecklistBeenDoneOnThisItem: "Has the M&E Checklist been done on this item?",
  isItWorking: "Is it Working?",
  userDetails: "User Details",
  permissions: "Permissions",
  placeName: "Place name",
  local: "Local",
  companyId: "Company id",
  suppliers: "Suppliers",
  newSupplier: "New Supplier",
  viewSupplier: "View Supplier",
  editSupplier: "Edit Supplier",
  printSupplier: "Print Supplier",
  editPlace: "Edit Place",
  newPlace: "New Place",
  newUser: "New User",
  createdAt: "Created At",
  voyage: "Voyage",
  voyageNumber: "Voyage Number",
  voyageStatus: "Voyage Status",
  voyageInformation: "Voyage Information",
  containerNumber: "Container Number",
  inputContainer: "Input Container",
  inputShipment: "Input Shipment",
  internalReference: "Internal Reference",
  exportShipment: "Export Shipment",
  eventProductUpdate: "Event Product Update",
  importProductsEvents: "Import Products Events",
  view: "View",
  close: "Close",
  closed: "Closed",
  closedForInvoicing: "Closed for Invoicing",
  closedForReceiving: "Closed for Receiving",
  createNetwork: "Create network",
  createCustomer: "Create customer",
  createAgent: "Create agent",
  createSupplier: "Create supplier",
  linkAccounts: "Link accounts",
  understood: "Understood",
  productEvents: "Product Events",
  birthDate: "Birth Date",
  emergencyName: "Emergency Name",
  emergencyPhone: "Emergency Phone",
  emergencyRelationship: "Emergency Relationship",
  gender: "Gender",
  skills: "Skills",
  residencyStatus: "Residency Status",
  certificates: "Certificates",
  addressLine1: "Address Line 1",
  addressLine2: "Address Line 2",
  suburb: "Suburb",
  staffStatus: "Staff status",
  staffMnt: "Staff - MNT",
  editStaff: "Edit Staff",
  newStaff: "New Staff",
  saveAsUser: "Save as User",
  yourPasswordMustBeAtLeast12CharactersLong: "Your password must be at least 12 characters long",
  yourPasswordMustContainAtLeastOneSpecialCharacter:
    "Your password must contain at least one special character",
  pleaseEnterYourPassword: "Please enter your password",
  yourPasswordMustBeAtMaximumOf30CharactersLong:
    "Your password must be at maximum of 30 characters long",
  pleaseEnterAValidPhoneNumber: "Please enter a valid phone number",
  phoneNumber: "Phone number",
  pleaseEnterALastName: "Please enter a Last Name",
  yourLastNameMustBeAtLeast4CharactersLong: "Your Last Name must be at least 4 characters long",
  pleaseEnterAFirstName: "Please enter a First Name",
  yourFirstNameMustBeAtLeast4CharactersLong: "Your First Name must be at least 4 characters long",
  pleaseEnterAName: "Please enter a Name",
  yourNameMustBeAtLeast4CharactersLong: "Your Name must be at least 4 characters long",
  yourRegistrationNumberMustBeAtLeast4CharactersLong:
    "Your Registration Number must be at least 4 characters long",
  pleaseEnterAPhoneNumber: "Please enter a Phone Number",
  yourPhoneMustBeAtLeast6CharactersLong: "Your phone must be at least 6 characters long",
  yourWebMustBeAtLeast4CharactersLong: "Your Web must be at least 4 characters long",
  pleaseEnterAAddressLine: "Please enter a Address Line",
  yourAddressLineMustBeAtLeast4CharactersLong:
    "Your Address Line must be at least 4 characters long",
  pleaseEnterASuburb: "Please enter a Suburb",
  yourSuburbMustBeAtLeast4CharactersLong: "Your Suburb must be at least 4 characters long",
  pleaseEnterAStateNumber: "Please enter a State Number",
  yourStateMustBeAtLeast3CharactersLong: "Your State must be at least 3 characters long",
  pleaseEnterAPostalCodeNumber: "Please enter a Postal Code Number",
  yourPostalCodeMustBeAtLeast4CharactersLong: "Your Postal Code must be at least 4 characters long",
  pleaseEnterACountry: "Please enter a Country",
  yourCountryMustBeAtLeast4CharactersLong: "Your Country must be at least 4 characters long",
  newItemSType: "New item's type",
  editItemSType: "Edit item's type",
  newItemSDescription: "New item's description",
  editItemSDescription: "Edit item's description",
  network: "Network",
  anErrorOccurredTryAgain: "An error occurred, try again",
  operationPerformedSuccessfully: "Operation performed successfully",
  resendWelcomeEmail: "Resend welcome email",
  resendWelcomeEmailConfirmation: "Send a welcome email to [name]?",
  welcomeEmailSentSuccessfully: "Welcome email sent successfully",
  labelCreated: "Label Created",
  sunday: "Sunday",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December",
  customerSTimeZone: "Customer’s time zone",
  startTime: "Start Time",
  endTime: "End Time",
  whatsapp: "Whatsapp",
  sms: "SMS",
  originAddress: "Origin Address",
  destinationAddress: "Destination Address",
  active: "Active",
  Active: "Active",
  disabled: "Disabled",
  sendToAmos: "Send to AMOS",
  printReports: "Print reports",
  cancelOrder: "Cancel order",
  cancelQuote: "Cancel quote",
  inactive: "Inactive",
  Inactive: "Inactive",
  invertStatuses: "Invert statuses",
  filterByStatus: "Filter by Status",
  activeInactive: "Active / Inactive",
  selectType: "Select type",
  selectStatus: "Select status",
  userCode: "User code",
  enterUserCode: "Enter user code",
  emailAddress: "Email Address",
  mobileNumber: "Mobile number",
  contactType: "Contact type",
  enterHere: "Enter here",
  dateOfBirth: "Date of birth",
  typeOfUser: "Type of user",
  thisUserIsALeader: "This user is a leader",
  checkThisBoxIfTheUserAboveIsAlsoALeader: "Check this box if the user above is also a leader",
  useEmailAddress: "Use email address",
  citySuburb: "City / Suburb",
  postcode: "Postcode",
  countryOrRegion: "Country or Region",
  timezone: "Timezone",
  enterFirstName: "Enter first name",
  enterLastName: "Enter last name",
  dateNumberFormat: "Date / number format",
  defaultCurrency: "Default currency",
  userInactive: "User Inactive",
  roles: "Roles",
  communications: "Communications",
  communicationSubscriptions: "Communication Subscriptions",
  searchByEnter: "Search by enter",
  approve: "Approve",
  decline: "Decline",
  activeNetwork: "Active Network",
  invites: "Invites",
  reject: "Reject",
  approved: "Approved",
  waitingForApproval: "Waiting for approval",
  sendToReview: "Send to review",
  automaticallyInvitationSentBy: "Automatically invitation sent by",
  importerExporter: "Importer & Exporter",
  newRole: "New Role",
  editRole: "Edit Role",
  continue: "Continue",
  saveWithoutAssigning: "Save without assigning",
  saveAndAssign: "Save and assign",
  createRole: "Create role",
  createRoom: "Create room",
  updateRole: "Update role",
  assignUser: "Assign user",
  productSIsRequired: "Product(s) is required!",
  roleName: "Role name",
  roleDescriptionOptional: "Role description (optional)",
  quoteAssignedTo: "Quote assigned to",
  manager: "Manager",
  searchForManager: "Search for manager",
  youMustEnterAnEntityName: "*You must enter an Entity Name",
  youMustEnterAnAddress: "*You must enter an Address",
  youMustEnterASuburbTown: "*You must enter a Suburb/Town",
  youMustEnterAState: "*You must enter a State",
  youMustEnterACountry: "*You must enter a Country",
  youMustEnterAPostalcode: "*You must enter a Postalcode",
  youMustEnterARegistrationNumber: "*You must enter a Registration number",
  youMustEnterABillingEmail: "*You must enter a Billing Email",
  youMustEnterAMobile: "*You must enter a Mobile",
  youMustEnterATimezone: "*You must enter a Timezone",
  youMustEnterAConsultant: "*You must enter a Consultant",
  youMustEnterAContactPerson: "*You must enter a Contact person",
  youMustEnterAFirstName: "*You must enter a First Name",
  youMustEnterALastName: "*You must enter a Last Name",
  youMustEnterAnEmail: "*You must enter an Email",
  youMustEnterAName: "*You must enter a Name",
  youMustEnterAPhoneNumber: "*You must enter a Phone number",
  youMustEnterAParentCode: "*You must enter a Parent ID number",
  youMustEnterALocationName: "*You must enter a Location name",
  youMustEnterAStatus: "*You must enter a Status",
  youMustEnterAnEstablishedYear: "*You must enter an Established Year",
  youMustEnterASince: "*You must enter a Since",
  youMustEnterAnEntityLegalName: "*You must enter an Entity legal name",
  youMustEnterAWebsite: "*You must enter a Website",
  youMustEnterAContactName: "*You must enter a Contact Name",
  youMustEnterAContactType: "*You must enter a Contact Type",
  startTypingToSearchDots: "Start typing to search...",
  established: "Established",
  establishedYear: "Established Year",
  since: "Since",
  entity: "Entity",
  entityLegalName: "Entity legal name",
  mobile: "Mobile",
  customerDetails: "Customer Details",
  editCustomer: "Edit customer",
  useTheSameAddressForPostalAddress: "Use the same address for Postal Address?",
  registrationNumber: "Registration number",
  addAnotherContact: "Add another contact",
  includeInEmail: "Include in email",
  consultant: "Consultant",
  searchConsultant: "Search Consultant",
  searchWarehouse: "Search Warehouse",
  searchTimezone: "Search Timezone",
  billingEmail: "Billing Email",
  postalAddress: "Postal Address",
  contact: "Contact",
  contactPerson: "Contact person",
  invalidLink: "Invalid link",
  closeWindow: "Close window",
  youHaventAcceptedTheInvitation: "You haven’t accepted the invitation",
  thisLinkIsNotValidPleaseCheckIfYouHaveAccessedTheCorrectLink:
    "This link is not valid. Please check if you have accessed the correct link.",
  youCanSafelyCloseThisWindowNowIfYouNeedAnyFurtherAssistanceFeelFreeToReachOutHaveAGreatDay:
    "You can safely close this window now. If you need any further assistance, feel free to reach out. Have a great day!",
  enterLocationName: "Enter location name",
  enterWebsite: "Enter website",
  enterRegistrationNumber: "Enter registration number",
  primaryContact: "Primary Contact",
  createLocation: "Create Location",
  viewLocation: "View Location",
  editLocation: "Edit Location",
  jobType: "Job type",
  warehouseOrigin: "Warehouse Origin",
  warehouseDestination: "Warehouse Destination",
  tag: "Tag",
  billingAs: "Billing as:",
  leadSourceFrom: "Lead source from",
  moveCoordinator: "Move coordinator",
  inventoryQuoted: "Inventory quoted",
  inventoryLeader: "Inventory leader",
  inventoryActual: "Inventory actual",
  myDetails: "My details",
  orderDetails: "Order details",
  actualAsQuoted: "Actual as Quoted",
  movingFrom: "Moving from",
  movingTo: "Moving to",
  itemQuantity: "Item quantity",
  inventories: "Inventories",
  originContact: "Origin contact",
  destinationContact: "Destination contact",
  seeAccessChecklist: "See Access Checklist",
  pickupAccessDetails: "Pickup Access Details",
  deliveryAccessDetails: "Delivery Access Details",
  noContactsAdded: "No contacts added",
  complement: "Complement",
  street: "Street",
  typeOfBuilding: "Type of building",
  loadingDockHeight: "Loading dock height",
  liftAvailable: "Lift available",
  accessInstructions: "Access instructions",
  navigationNotes: "Navigation notes",
  createYourShipeeziAccount: "Create your Shipeezi account",
  createAccount: "Create account",
  haveAnAccountSignIn: "Have an account? Sign in",
  mode: "Mode",
  service: "Service",
  editOrder: "Edit Order",
  newOrder: "New Order",
  weight: "Weight",
  truckType: "Truck type",
  carrier: "Carrier",
  truckBookingNumber: "Truck Booking Number",
  trackingNumber: "Tracking number",
  palletsPerTruck: "Pallets per Truck",
  deliveryDate: "Delivery Date",
  proposedDeliveryDate: "Proposed Delivery Date",
  bookingDetails: "Booking Details",
  deliveryAddress: "Delivery Address",
  deliveryAddressLine: "Delivery Address Line",
  deliveryAddressSuburb: "Delivery Address Suburb",
  receiver: "Receiver",
  senderAddress: "Sender Address",
  senderAddressLine: "Sender Address Line",
  senderAddressSuburb: "Sender Address Suburb",
  palletsQty: "Pallets Qty",
  cartonQty: "Carton Qty",
  despatchDate: "Despatch Date",
  pleaseEnterAYourFirstName: "*Please, enter a your First name.",
  pleaseEnterAYourLastName: "*Please, enter a your Last name.",
  pleaseEnterAYourEmailAddress: "*Please, enter a your email address.",
  pleaseEnterAPassword: "*Please, enter a password.",
  pleaseConfirmAPassword: "*Please, confirm a password.",
  pleaseEnterAUsername: "*Please, enter a username.",
  pleaseEnterAMobilePhone: "*Please, enter a mobile phone.",
  atLeastOnePhotoIsRequired: "*At least one photo is required",
  atLeastOneProductIsRequired: "At least one product is required",
  thisEmailIsInvalid: "*This email is invalid",
  thisFieldIsRequired: "This field is required",
  selectAnAccessRule: "Select an access rule",
  youNeedToSelectAtLeastOneBranch: "*You need to select at least one branch",
  youNeedToSelectAtLeastOneSection: "*You need to select at least one section",
  youNeedToSelectAtLeastOneContact: "*You need to select at least one contact",
  youMustEnterACustomer: "*You must enter a customer",
  youMustEnterAEmail: "*You must enter a email",
  youMustEnterAnMobile: "*You must enter an mobile",
  youMustHaveAtLeastOneLocation: "*You must have at least one location",
  youMustHaveAtLeastOnePrimaryLocation: "*You must have at least one primary location",
  pleaseEnterAValidEmail: "*Please enter a valid email",
  quoted: "Quoted",
  actual: "Actual",
  totalItems: "Total items",
  registered: "Registered",
  loaded: "Loaded",
  taken: "Taken",
  delivered: "Delivered",
  void: "Void",
  disposal: "Disposal",
  missing: "Missing",
  missingShipment: "Missing Shipment",
  shipped: "Shipped",
  packed: "Packed",
  uplifted: "Uplifted",
  bol: "BoL",
  selectNewStatusForItem: "Select new status for item",
  item: "Item",
  items: "Items",
  packer: "Packer",
  selectPacker: "Select Packer",
  selectNewStatusForItems: "Select new status for items",
  newStatus: "New status",
  changeItemsStatus: "Change items status",
  addNewItem: "Add new item",
  createNewItem: "Create new item",
  uploadPDF: "Upload PDF",
  addManualItems: "Add manual items",
  editManualItems: "Edit manual items",
  editInventory: "Edit inventory",
  describeEachBingoItem:
    "Enter a description for each item below. Use pagination when you add many items.",
  createInventory: "Create inventory",
  editInventoryManualTitle: "Edit inventory (manual items)",
  addNewRoom: "Add New Room",
  editItem: "Edit Item",
  viewItem: "View Item",
  createNewOne: "Create + New One",
  comment: "Comment",
  createNewComment: "Create new comment",
  newComment: "New comment",
  commentBy: "Comment By",
  hideCommentHistory: "Hide comment history",
  seeCommentHistory: "See comment history",
  copyInfoFromPickup: "Copy info from Pickup",
  copyInfoFromDelivery: "Copy info from Delivery",
  pickup: "pickup",
  pickUp: "Pick up",
  delivery: "Delivery",
  switchToManual: "Switch to Manual Address entry",
  switchToGoogle: "Switch to Google Maps entry",
  addAnotherAddress: "Add another address",
  selectATask: "Select a task",
  enterADateInField: "Enter a date in field",
  theSurveyDateMustBeGreaterThanTheCurrentDate:
    "The survey date must be greater than the current date",
  time: "Time",
  date: "Date",
  addATask: "Add a task",
  enterOnTheVideoSurvey: "Enter on the video survey",
  startVideoSurvey: "Start Video Survey",
  scheduleAVideoSurvey: "Schedule a Video Survey",
  thisDateIsInvalid: "This date is invalid",
  notAvailable: "Not available",
  addATaskHomeSurveyOrVideoSurveyToCreateAQuote:
    "Add a task Home Survey or Video Survey to create a quote",
  pickupAccess: "Pickup Access",
  deliveryAccess: "Delivery Access",
  switchToPickupAccess: "Switch to pickup access",
  switchToDeliveryAccess: "Switch to delivery access",
  duplicate: "Duplicate",
  willTheEntryOfTheHouseBeObstructed: "Will the entry of the house be obstructed?",
  driveway: "Driveway",
  steep: "Steep",
  long: "Long",
  whatIsTheLengthM: "What is the Length(m)?",
  residence: "Residence",
  residenceType: "Residence type",
  house: "House",
  apartment: "Apartment",
  level: "Level",
  howManyLevels: "How many levels?",
  groundFloor: "Ground Floor",
  split: "Split",
  multiStorey: "Multi Storey",
  steps: "Steps",
  notAuthorizedByCustomer: "Not authorized by customer",
  photos: "Photos",
  addPhoto: "Add photo",
  hasLift: "Has lift?",
  lift: "Lift",
  internal: "Internal",
  external: "External",
  streetAccess: "Street Access",
  wide: "Wide",
  narrow: "Narrow",
  step: "Step",
  normal: "Normal",
  permitRequired: "Permit required",
  oneWay: "One way",
  culDeSac: "Cul de sac",
  roundabout: "Roundabout",
  speedHumps: "Speed humps",
  noThroughRoad: "No through road",
  road: "Road",
  sea: "Sea",
  air: "Air",
  ferry: "Ferry",
  storage: "Storage",
  other: "Other",
  parking: "Parking",
  parkingType: "Parking type",
  carry: "Carry",
  carryM: "Carry(m)",
  treesPowerline: "Trees/Powerline",
  overhanging: "Overhanging",
  low: "Low",
  action: "Action",
  vehicleSize: "Vehicle size",
  vehicleTrailer: "Vehicle/Trailer",
  small: "Small",
  rigid: "Rigid",
  semi: "Semi",
  isFerryRequired: "Is ferry required?",
  saveAComment: "Save a comment",
  createComment: "Create comment",
  saveABookmark: "Save a bookmark",
  takeAScreenshot: "Take a screenshot",
  accessDetailsDescribedAboveAreAccurateToTheBestOfMyKnowledge:
    "Access details described above are accurate to the best of my knowledge.",
  specialInstructions: "Special Instructions",
  itemInstructionStatus: "Item instruction status",
  deleteAddress: "Delete address",
  thereAreItemsOrMaterialsRegisteredWithThisAddressIfYouDeleteThisAddressNowAllItemsWillBeRegisteredWithTheMainDeliveryAddressWouldYouLikeToDoThat:
    "There are items or materials registered with this address. If you delete this address now, all items will be registered with the main delivery address. Would you like to do that?",
  inventory: "Inventory",
  itemDetails: "Item details",
  materialDetails: "Material - Details",
  addAnother: "Add Another",
  fileIsTooBigMax2Mb: "File is too big (Max 2MB)",
  thisFileExtensionIsNotAllowed: "This file extension is not allowed",
  fileIsTooBigMax8Mb: "File is too big (Max 8MB)",
  fileAlreadyExistsInThisFolder: "File already exists in this folder",
  anotherFolderWithThisNameAlreadyExists: "Another folder with this name already exists",
  newFolder: "New Folder",
  upload: "Upload",
  uploading: "Uploading",
  uploadingYourContent: "Uploading your content",
  share: "Share",
  shared: "Shared",
  unshare: "Unshare",
  notBeingShared: "Not being shared",
  stopSharing: "Stop sharing",
  cancelRequest: "Cancel request",
  requestDocument: "Request document",
  empty: "Empty",
  file: "File",
  files: "Files",
  folder: "Folder",
  rename: "Rename",
  currentStock: "Current Stock",
  theFolderNameIsRequired: "The folder name is required",
  theFileNameIsRequired: "The file name is required",
  accessChecklistSummary: "Access Checklist Summary",
  selectAnOption: "Select an option",
  searchTask: "Search Task",
  anErrorOccuredTryAgain: "An error occured, try again.",
  secondContact: "Second Contact",
  pleaseSelectAQuoteType: "Please, select a Quote type",
  pleaseFillAReference: "Please, fill a reference",
  pleaseSelectAStatus: "Please, select a status",
  pleaseSelectAConsultant: "Please, select a Consultant",
  pleaseSelectAManager: "Please, select a Manager",
  pleaseSelectAMode: "Please, select a Mode",
  pleaseFillPickUpCustomerFields: "Please, fill Pick up customer fields",
  pleaseFillPickUpAddressFields: "Please, fill Pick up address fields",
  pleaseFillDeliveryCustomerFields: "Please, fill Delivery customer fields",
  pleaseFillDeliveryAddressFields: "Please, fill Delivery address fields",
  pleaseCheckTheAccessDetailsDescribedOnPickupAccess:
    "Please, check the access details described on pickup access",
  customRange: "Custom Range",
  summaryFromSales: "Summary from Sales",
  toAddAnOrderClickOnTheButtonBelow: "To add an order, click on the button below.",
  addOrderToAShipment: "Add order to a shipment",
  addOrder: "Add Order",
  addOrders: "Add Orders",
  changeOrderToAShipment: "Change order to a shipment",
  selectShipmentsBelowToAddThem: "Select shipments below to add them.",
  matchOrigin: "Match Origin",
  matchDestination: "Match Destination",
  notSent: "Not Sent",
  shipmentOrigin: "Shipment Origin",
  shipmentDestination: "Shipment Destination",
  portName: "Port Name",
  airportName: "Airport Name",
  recordDeleted: "Record deleted",
  noVideoRecorded: "No video recorded",
  noCommentsRegistered: "No comments registered",
  noScreenshotsRegistered: "No screenshots registered",
  noBookmarksRegistered: "No bookmarks registered",
  videoSurvey: "Video Survey",
  videos: "Videos",
  communication: "Communication",
  document: "Document",
  documents: "Documents",
  documentSharing: "Document Sharing",
  documentsForThisBooking: "Documents for this booking",
  map: "Map",
  costing: "Costing",
  addProduct: "Add Product",
  addProducts: "Add Products",
  addProductToCarton: "Add Product to Carton",
  sendEmail: "Send Email",
  sendSMS: "Send SMS",
  attachmentFailedPleaseTryAgainLater: "Attachment Failed. Please try again later!",
  clickToViewJson: "Click to view JSON",
  closeJsonFile: "Close JSON File",
  invalidEmailFormat: "Invalid Email Format",
  emailSuccessfullySent: "Email successfully sent!",
  somethingWentWrongPleaseTryAgain: "Something went wrong. Please try again!",
  typeTheEmailAddressEnter: "Type the email address + enter",
  addGroupCosting: "Add Group Costing",
  deleteConfirmation: "Delete Confirmation",
  areYouSureYouWantToRemoveThisItem: "Are you sure you want to remove this item?",
  selectAtLeastOneItemToChangeStatus: "Select at least one item to change status",
  anItemWasAddToTheSelectedRoom: "An item was add to the selected room",
  aRoomHasBeenAddedToTheInventory: "A room has been added to the inventory",
  anItemWasUpdatedAtTheSelectedRoom: "An item was updated at the selected room",
  anItemWasRemovedFromTheSelectedRoom: "An item was removed from the selected room",
  couldNotFindItemToDuplicate: "Could not find item to duplicate",
  emailSentSuccesfuly: "Email sent successfully!",
  smsSentSuccesfuly: "SMS sent successfully!",
  couldNotSendEmail: "Could not send Email",
  ifAMatchingAccountWasFoundAnEmailWasSentTo:
    "If a matching account was found, an email was sent to",
  toAllowYouToResetYourPassword: "to allow you to reset your password.",
  isAnUser: "Is an user",
  isNotAnUser: "Is not an user",
  allContacts: "All contacts",
  seeAllOfYourBusinessContacts: "See all of your business contacts",
  editContact: "Edit contact",
  addContact: "Add contact",
  addLocation: "Add location",
  addContactUser: "Add contact user",
  editContactUser: "Edit contact user",
  viewAllContacts: "View all contacts",
  registerAsAnUser: "Register as an user",
  editThisBusinessContact: "Edit this business contact",
  contactDetails: "Contact details",
  pleaseEnterARegistrationNumber: "Please enter a Registration Number",
  otherDetails: "Other details",
  shipeeziNetwork: "Shipeezi Network",
  agentIsConnectedToTheShipeezisNetwork: "Agent is connected to the Shipeezi's network",
  inviteToNetwork: "Invite to network",
  actions: "Actions",
  sortBy: "Sort by",
  inactiveCompany: "Inactive company",
  billing: "Billing",
  primary: "Primary",
  secondary: "Secondary",
  general: "General",
  generalPhoto: "General Photo",
  overview: "Overview",
  manageUsers: "Manage users",
  monthlyPayment: "Monthly payment",
  addSeats: "Add seats",
  currentPlan: "Current plan",
  changePlan: "Change plan",
  lastPaidInvoice: "Last paid invoice",
  billingDetails: "Billing details",
  editPaymentDetails: "Edit payment details",
  cardHolder: "Card holder",
  creditCardNumber: "Credit card number",
  cvv: "CVV",
  expDate: "Exp date",
  billingAddress: "Billing address",
  people: "People",
  resources: "Resources",
  configurations: "Configurations",
  preferences: "Preferences",
  orderType: "Order Type",
  leadSource: "Lead source",
  statuses: "Statuses",
  integrations: "Integrations",
  apiAllied: "API Allied",
  history: "History",
  checklistForms: "Checklist & Forms",
  fleet: "Fleet",
  equimpent: "Equipment",
  staff: "Staff",
  itemList: "Item List",
  packagingType: "Packaging type",
  modeType: "Mode type",
  exceptionCodes: "Exception codes",
  exceptionLocationCode: "Exception location code",
  materials: "Materials",
  instructions: "Instructions",
  itemDestination: "Item destination",
  automation: "Automation",
  access: "Access",
  iso174511: "ISO17451-1:2016 - Certificate",
  createNewUser: "Create new user",
  createNewRole: "Create new role",
  createNewCustomer: "Create new customer",
  deleteCustomer: "Delete customer",
  deleteAgent: "Delete agent",
  deleteSelected: "Delete selected",
  typePressEnter: "Type + Press enter",
  createUser: "Create user",
  viewUser: "View user",
  viewUsers: "View users",
  editUser: "Edit user",
  useCompanyAddress: "Use company address",
  timezoneIsUpdatedAutomaticallyToMatchYourComputerTimezone:
    "Time zone is updated automatically to match your computer time zone",
  inactiveUser: "Inactive user",
  activeUser: "Active user",
  logUserOut: "Log user out",
  searchAndSelectTheRoleTo: "Search and select the role to",
  assignUsers: "Assign users",
  searchAndSelectUsersTo: "Search and select users to",
  viewRole: "View role",
  editThisRole: "Edit this role",
  viewThisRole: "View this role",
  setPermissions: "Set permissions",
  addANewItem: "Add a new item",
  viewAnItem: "View an item",
  editAnItem: "Edit an item",
  editLocationForCustomer: "Edit location for customer",
  createNewLocationForCustomer: "Create new location for customer",
  viewLocationForCustomer: "View location for customer",
  editOrderType: "Edit order type",
  createNewOrderType: "Create new order type",
  editLeadSource: "Edit lead source",
  createNewLeadSource: "Create new lead source",
  leadSourceStatus: "Lead source status",
  editStatus: "Edit status",
  createNewStatus: "Create new status",
  itemName: "Item Name",
  itemCode: "Item Code",
  itemVolume: "Item Volume",
  itemWeight: "Item Weight",
  photosAreMandatory: "Photos are mandatory",
  brandIsMandatory: "Brand is mandatory",
  commentIsMandatory: "Comment is mandatory",
  mEChecklistIsMandatory: "M&E Checklist is mandatory",
  inactiveItem: "Inactive item",
  roomName: "Room Name",
  roomCode: "Room Code",
  inactiveLocation: "Inactive Location",
  editPackagingType: "Edit Packaging Type",
  createPackagingType: "Create Packaging Type",
  packagingTypeName: "Packaging type name",
  packagingTypeCode: "Packaging type code",
  yourComment: "Your comment",
  packagingTypeStatus: "Packaging Type status",
  reason: "Reason",
  code: "Code",
  enterTypeOfContact: "Enter type of contact",
  dimensions: "Dimensions",
  couldnTSubscribeShipment: "Couldn't subscribe shipment",
  couldnTRetrieveShipmentStatus: "Couldn't retrieve shipment status",
  voyageStatusUpdated: "Voyage Status updated",
  pod: "Pod",
  pressEnterToAdd: "Press enter to add",
  inputYourComments: "Input your comments",
  portOfDestination: "Port of Discharge (PoD)",
  placeOfDestination: "Place of destination",
  containerGateInAtPol: "Container gate in at POL",
  containerGateInPort: "Container gate in port",
  nextPort: "Next Port",
  containerLoadedAtFirstPolPortOfLoad: "Container loaded at first POL (Port of Load)",
  containerGateOutAtPodPortOfDischarge: "Container gate out at POD (Port of Discharge)",
  originPort: "Origin Port",
  finalDestinationPort: "Final Destination Port",
  estimatedArrival: "Estimated Arrival",
  actualArrival: "Actual Arrival",
  carrierEstimatedArrival: "Carrier Estimated Arrival",
  carrierActualArrival: "Carrier Actual Arrival",
  arrivalAtPort: "Arrival at Port",
  departureAtPort: "Departure at Port",
  predictiveArrivalAt: "Predictive arrival at",
  arrivalAt: "Arrival at",
  editCurrency: "Edit Currency",
  createCurrency: "Create Currency",
  editItemInstruction: "Edit Item Instruction",
  createItemInstruction: "Create Item Instruction",
  addANewCurrency: "Add a new currency",
  australianDollar: "Australian dollar",
  a: "A$",
  currencyView: "Currency View",
  currencyStatus: "Currency status",
  editLanguage: "Edit Language",
  actualStatus: "Actual Status",
  createNewLanguage: "Create new language",
  baseLanguage: "Base language",
  en: "EN",
  measurementStatus: "Measurement status",
  flag: "Flag",
  where: "Where",
  usage: "Usage",
  filteringBy: "Filtering by ",
  editModeType: "Edit Mode Type",
  createModeType: "Create Mode Type",
  editThisModeType: "Edit this mode type",
  addNewModeType: "Add new mode type",
  modeTypeStatus: "Mode type status",
  needAddAHomeOrVideoSurvey: "Need add a Home or Video survey",
  quotedInventory: "Quoted inventory",
  chooseADestination: "Choose a destination",
  aMaterialWasAddToTheSelectedRoom: "A material was add to the selected room",
  pressEnterToSaveOrEscToCancel: "Press enter to save or ESC to cancel",
  youHaveToChooseAQuoteModeToAddAnItem: "You have to choose a quote mode to add an item",
  youHaveToChooseAQuoteModeToAddAMaterial: "You have to choose a quote mode to add a material",
  youHaveToSelectARoomBeforeAddAMaterial: "You have to select a room before add a material",
  aRoomWithThisNameAlreadyExists: "A room with this name already exists",
  youHaveToSelectARoomBeforeAddAnItem: "You have to select a room before add an item",
  generateToken: "Generate token",
  copyToken: "Copy token",
  copiedSuccessfully: "Copied successfully",
  unitQty: "Unit Qty",
  productQty: "Product Qty",
  qtyStock: "Qty (Stock)",
  qtyShipping: "Qty (Shipping)",
  latitude: "Latitude",
  longitude: "Longitude",
  vesselType: "Vessel Type",
  vesselPosition: "Vessel position",
  speedKnots: "Speed (Knots)",
  editMeasurement: "Edit Measurement",
  createMeasurement: "Create Measurement",
  createNewStaff: "Create new staff",
  viewStaff: "View staff",
  male: "Male",
  female: "Female",
  createService: "Create Service",
  editService: "Edit service",
  viewService: "View service",
  serviceStatus: "Service status",
  sellDescription: "Sell description",
  serviceDescription: "Service description",
  sellType: "Sell type",
  m3Fee: "M3 Fee",
  defaultPrice: "Default price",
  serviceGroup: "Service group",
  inputMessage: "Input Message",
  viewChecklist: "View Checklist",
  editChecklist: "Edit Checklist",
  createChecklist: "Create Checklist",
  emptyList: "Empty List",
  addAll: "Add all",
  addType: "Add Type",
  addBranch: "Add branch",
  jobTypeAlreadyExistInTheList: "Job type already exist in the list",
  branchAlreadyExistInTheList: "Branch already exist in the list",
  riskAssessment: "Risk Assessment",
  customerSurvey: "Customer Survey (Outbound)",
  statementOfAsp: "Statement Of Accessorial Services Performed",
  required: "Required",
  title: "Title",
  needAction: "Need Action",
  answerAction: "Answer Action",
  addNewQuestion: "Add new question",
  trigger: "Trigger",
  addNewTrigger: "Add new trigger",
  notes: "Notes",
  taskTypeAlreadyExistInTheList: "Task type already exist in the list",
  taskType: "Task Type",
  questions: "Questions",
  appTriggers: "App Triggers",
  beforeStartTask: "Before start task",
  beforeContinueTask: "Before continue task",
  beforeFinishTask: "Before finish task",
  beforeAcceptTask: "Before accept task",
  text: "Text",
  checkbox: "Checkbox",
  decimal: "Decimal",
  integer: "Integer",
  signature: "Signature",
  photo: "Photo",
  checkboxText: "Checkbox & Text",
  radioButton: "Radio Button",
  textarea: "Textarea",
  radioButtonText: "Radio Button & Text",
  johnny: "Johnny",
  bravo: "Bravo",
  john: "John",
  sampleEmailCom: "sample@email.com",
  emergency: "Emergency",
  pendingCustomerUpload: "Pending customer upload",
  sharedWithCustomer: "Shared with customer",
  resendRequest: "Resend request",
  uploadedByCustomer: "Uploaded by customer",
  noDocumentsRequestedYet: "No documents requested yet",
  donTWorryIfAnyDocumentsAreRequestedByUsYouWillBeNotifiedAndWillBeAbleToManageThem:
    "Don't worry, if any documents are requested by us, you will be notified and will be able to manage them.",
  oneOrMoreRequiredFieldsAreEmpty: "One or more required fields are empty",
  noChangeHasBeenDetected: "No change has been detected",
  noCommentsBeTheFirstToComment: "No comments! Be the first to comment...",
  mainAddress: "Main Address",
  createANewBusinessContact: "Create a new business contact",
  editABusinessContact: "Edit a business contact",
  includeInCommunications: "Include in communications",
  thisUserNeedsToHaveSomeProjectSelected: "This user needs to have some project selected",
  thisUserNeedsToHaveSomeRoleSelected: "This user needs to have some role selected",
  thePasswordDoesNotMatch: "The password does not match",
  selectPerformancePrediction: "Select Performance Prediction",
  performancePrediction: "Performance Prediction",
  passwordAndConfirmPasswordMustBeTheSame: "Password and Confirm Password must be the same",
  newPasswordAndConfirmPasswordMustBeTheSame: "New Password and Confirm Password must be the same",
  hiThere: "Hi there!",
  pleaseFindTheJsonFileAttachedForShipmentS: "Please find the json file attached for shipment(s)",
  best: "Best, ",
  discard: "Discard",
  discardChanges: "Discard changes",
  areYouSureYouWantToDiscardAllChanges: "Are you sure you want to discard all changes?",
  thisActionIsPermanentAndCannotBeUndone: "This action is permanent and cannot be undone!",
  shipeeziAustralia: "Shipeezi  Australia",
  supportShipeeziCom: "support@shipeezi.com",
  wwwShipeeziCom: "www.shipeezi.com",
  shipeeziKey: "Shipeezi Key",
  termsOfUsePrivacyPolicySecurityPolicy: "Terms of use, Privacy policy, Security policy",
  andSaasAgreement: " and Saas agreement ",
  agreed: "agreed",
  thisCurrencyIsAlreadyRelatedToACompanyThereforeYouCannotChangeHisStatus:
    "This currency is already related to a company, therefore you cannot change his status.",
  select: "Select",
  hello: "Hello,",
  dateRange: "Date Range",
  viewToday: "View Today",
  activeQuotes: "Active Quotes",
  quotedVolume: "Quoted Volume",
  videoSurveys: "Video Surveys",
  activeOrders: "Active Orders",
  orderVolume: "Order Volume",
  branchOrigin: "Branch origin",
  branchDestination: "Branch destination",
  material: "Material",
  accessStatus: "Access status",
  instruction: "Instruction",
  scheduleCreateSuccessfully: "Schedule create successfully",
  sendAutomaticalyASmsEmailInvite: "Send automaticaly a SMS/Email invite",
  theEmailOrPhoneIsAlreadyInUseByAnotherCustomer:
    "The email or phone is already in use by another customer",
  wouldYouLikeToSendTheDetailsOfTheCallToYourCustomerBy:
    "Would you like to send the details of the call to your customer by",
  assignRole: "Assign Role",
  duplicateRole: "Duplicate Role",
  accessRule: "Access Rule",
  accessRules: "Access Rules",
  membersInGroup: "Members in this group",
  showAll: "Show All",
  enterNameForThisGroup: "Enter name for this group",
  describeThisGroupInFewWords: "Describe this group in few words",
  groupCreatedSuccessfully: "Group '{{groupName}}' created successfully",
  groupUpdatedSuccessfully: "Group '{{groupName}}' updated successfully",
  anErrorOccurredWhileUpdatingGroup:
    "An error occurred while updating group '{{groupName}}'. Please contact Shipeezi support for assistance",
  thisIsADefaultSystemGroupThatCannotBeModifiedButYouCanAddOrRemoveMembersFromIt:
    "This is a default system group that cannot be modified, but you can add or remove members from it",
  kindlyResolveTheFormErrorsBeforeProceeding:
    "Kindly resolve the form errors before proceeding ...",
  theGroupNameAlreadyExistsPleaseChooseADifferentName:
    "The group name '{{groupName}}' already exists. Please choose a different name.",
  changeStatus: "Change Status",
  purchase: "Purchase",
  purchaseOrder: "Purchase Order",
  salesOrder: "Sales Order",
  asPlanned: "As planned",
  potentialDelay: "Potential Delay",
  delayed: "Delayed",
  selectAVideoSurveyOfToday: "Select a video survey of today",
  openVideoSurvey: "Open Video Survey",
  searchOrAddAReference: "Search or add a reference",
  searchOriginAddress: "Search Origin Address",
  searchDestinationAddress: "Search Destination Address",
  searchOrAddACustomer: "Search or add a customer",
  jobAlreadyExists: "Job already exists",
  associateCustomer: "Associate Customer",
  thereIsAlreadyACustomerWithThisEmailOrPhoneNumberDoYouWantToAssociateTheTask:
    "There is already a customer with this email or phone number, do you want to associate the task?",
  associate: "Associate",
  phone: "Phone",
  translation: "Translation",
  viewActivity: "View Activity",
  seeActivity: "See Activity",
  activity: "Activity",
  createItem: "Create Item",
  folders: "folders",
  shipment: "Shipment",
  quotes: "Quotes",
  estimate: "Estimate",
  loadingQuotes: "Loading Quotes",
  quotesWonVsLost: "Quotes won vs lost",
  quotesWon: "quotes won",
  quotesLost: "quotes lost",
  won: "Won",
  lost: "Lost",
  lastUpdatedOn: "Last Updated On",
  instructionsNotFound: "Instructions not found",
  quotesPerformed: "Quotes Performed",
  ordersByType: "Orders by type",
  orders: "Orders",
  loadingOrders: "Loading Orders",
  itFeelsABitEmpty: "It feels a bit empty",
  videoName: "Video Name",
  fetchingVideo: "Fetching Video",
  fetchDetails: "Fetch Details",
  videoUploadInProgress: "Video upload in progress",
  noVideoAvailable: "No video available",
  screenshots: "Screenshots",
  imageOfAScreenshot: "Image of a screenshot",
  fetchingScreenshots: "Fetching Screenshots",
  seeMore: "See more",
  noScreenshotAvailable: "No screenshot available",
  fetchingComments: "Fetching Comments",
  noCommentsAvailable: "No comments available",
  screenSharing: "Screen sharing",
  bookmarks: "Bookmarks",
  fetchingBookmarks: "Fetching Bookmarks",
  noBookmarksAvailable: "No bookmarks available",
  bookmarkSavedSuccessfully: "Bookmark saved successfully.",
  couldNotSaveBookmark: "Could not save bookmark",
  searchByCustomerNamePhoneNumberOrEmailAddress:
    "Search by customer name, phone number or email address",
  searchManager: "Search manager",
  totalQty: "Total Qty",
  totalVolume: "Total Volume",
  totalWeight: "Total Weight",
  contacts: "Contacts",
  createANewWarehouse: "Create a new warehouse",
  editWarehouse: "Edit warehouse",
  createANewBranch: "Create a new branch",
  editBranch: "Edit branch",
  viewBranch: "View branch",
  viewWarehouse: "View warehouse",
  closeAllPanels: "Close all panels",
  collapseAllPanels: "Collapse all panels",
  expandAllPanels: "Expand all panels",
  expandAll: "Expand all",
  collapseAll: "Collapse all",
  tba: "TBA",
  editMaterial: "Edit material",
  createANewMaterial: "Create a new material",
  materialStatus: "Material status",
  isAnItem: "Is an item?",
  editInstruction: "Edit instruction",
  createInstruction: "Create instruction",
  when: "When",
  editTaskType: "Edit task type",
  createTaskType: "Create task type",
  taskTypeStatus: "Task type status",
  isBookable: "Is bookable?",
  isItBookable: "Is it bookable?",
  viewDestination: "View destination",
  editDestination: "Edit destination",
  createDestination: "Create destination",
  destinationStatus: "Destination status",
  colorValueMustStartWithAndCannotBeAWhiteColor:
    "Color value must start with # and cannot be a white color",
  automaticSequencing: "Automatic Sequencing",
  nextNumber: "Next number",
  changeStatuses: "Change statuses",
  changeAllSelectedStatusesTo: "Change all selected statuses to",
  changeItemStatuses: "Change item statuses",
  changeAllSelectedItemsStatusesTo: "Change all selected items statuses to",
  visibilityControlAndTransparencyOfYourShipments:
    "Visibility, control and transparency of your shipments.",
  yourRequestHasExpiredMakeANewRecovery: "Your request has expired. Make a new recovery",
  pleaseEnterAEmail: "Please, enter a Email.",
  resetPassword: "Reset password",
  pleaseCheckYourEmail: "Please check your email.",
  yourPasswordHasBeenUpdated: "Your password has been updated.",
  returnToLogin: "Return to login",
  backToLogin: "Back to login",
  didnTReceiveTheEmail: "Didn’t receive the email? ",
  aPasswordResetMessageWasSentToYourEmailAddress:
    "A password reset message was sent to your email address.",
  enterTheEmailAddressAssociatedWithYourAccountAndWeLlSendYouALinkToResetYourPassword:
    "Enter the email address associated with your account and we'll send you a link to reset your password.",
  createAccessOption: "Create access option",
  editAccessOption: "Edit access option",
  drivewayLength: "Driveway Length",
  carryDistance: "Carry Distance",
  switchTo: "Switch to",
  questionFieldsAreRequired: "Question fields are required.",
  triggerFieldTypeIsRequired: "Trigger field type is required.",
  valueOfEntryIsAlreadyInUsed: "Value of entry is already in used",
  aRoleOfTypeSystemIsSelectedAndCannotBeChanged:
    "A role of type system is selected and cannot be changed",
  theDateIsWrong: "The date is wrong",
  theUserMustBeAtLeast18YearsOldAndUnder100YearsOld:
    "The user must be at least 18 years old and under 100 years old",
  approveQuote: "Approve quote",
  doYouReallyWantToApproveTheQuote: "Do you really want to approve the quote?",
  areYouSureYouWantToDeliverThisOrder: "Are you sure you want to deliver this order?",
  areYouSureYouWantToCancelTheOrder: "Are you sure you want to cancel the order",
  yesCancelOrder: "Yes, cancel order",
  areYouSureYouWantToCancelTheQuote: "Are you sure you want to cancel the quote",
  yesCancelQuote: "Yes, cancel quote",
  oops: "Oops!",
  youShouldCancelTheseTasksInYourAppBeforeContinue:
    "You should cancel these tasks in your app before continue.",
  itLooksLikeSomeTasksOfThisOrderAreInProgress:
    "It looks like some tasks of this order are in progress.",
  declineQuote: "Decline quote",
  doYouReallyWantToDeclineTheQuote: "Do you really want to decline the quote?",
  viewInCalendarMode: "View in calendar mode",
  viewInGridMode: "View in grid mode",
  removeAll: "Remove all",
  roleNotFound: "Role not found",
  userNotFound: "User not found",
  searchForRole: "Search for role...",
  searchForUser: "Search for user...",
  inbound: "Inbound",
  atPort: "At port",
  atDc: "At dc",
  ofTotalContainers: "Of total containers",
  containerDistributionByDestination: "Container Distribution By Destination",
  shareLink: "Share Link",
  cameraOff: "Camera off",
  video: "Video",
  microphone: "Microphone",
  joinNow: "Join now",
  youDidnTAddAnyItemsYet: "You didn't add any items yet",
  copied: "Copied",
  shareViaApp: "Share via App",
  shareViaLink: "Share via link",
  shareViaSms: "Share via SMS",
  shareViaWhatsapp: "Share via Whatsapp",
  openWhatsappToShare: "Open Whatsapp to share",
  shareViaEMail: "Share via E-mail",
  shareTheVideoSurveyWithTheCustomer: "Share the video survey with the customer",
  shareTheInventoryWithTheCustomer: "Share the inventory with the customer",
  shareTheEstimateWithTheCustomer: "Share the estimate with the customer",
  shareInventory: "Share inventory",
  shareEstimate: "Share estimate",
  shareVideoSurvey: "Share video survey",
  inventoryUpdated: "Inventory Updated",
  youAreAboutToLeaveVideoSurveyAreYouSure: "You are about to leave video survey. Are you sure?",
  theCustomerWillBeForcedToLeaveToo: "The customer will be forced to leave too.",
  youHaveUnsavedChangesInTheInventory: "You have unsaved changes in the inventory.",
  audioDeviceTest: "Audio device test",
  recording: "Recording...",
  playing: "Playing...",
  leave: "Leave",
  noIssuesDetected: "No issues detected",
  inputDevice: "Input device",
  inputLevel: "Input level",
  speaker: "Speaker",
  outputDevice: "Output device",
  outputLevel: "Output level",
  connectivityAndBandwidthTest: "Connectivity and bandwidth test",
  taskTypeIsRequired: "Task Type is required.",
  orderTypeIsRequired: "Order Type is required.",
  orderTypeStatus: "Order type status",
  sequence: "Sequence",
  poNumber: "PO Number",
  despatchedQuantity: "Despatched Quantity",
  destinationDcCmlDc: "Destination DC(CML DC)",
  estimateClearedForPickUp: "Estimate Cleared for Pick Up",
  estimateUnpackDate: "Estimate Unpack Date",
  actualArriveWh: "Actual Arrive WH",
  bookedFor: "Booked for",
  at: "at",
  contactEmailCom: "contact@email.com",
  expectedCallQuality: "Expected Call Quality:",
  deliverOrder: "Deliver Order",
  generateReport: "Generate report",
  generatePDFreports: "Generate PDF Reports",
  hideSection: "Hide Section",
  showSection: "Show Section",
  online: "Online",
  offline: "Offline",
  collapse: "Collapse",
  allow: "Allow",
  notAllow: "Not Allow",
  allowCustomer: "Allow Customer",
  screenshotSavedSuccessfully: "Screenshot saved successfully",
  couldNotSaveScreenshot: "Could not save screenshot",
  couldNotRetrieveScreenshots: "Could not retrieve screenshots",
  loadingDespatches: "Loading Despatches",
  checklistStatus: "Checklist status",
  warehouseStatus: "Warehouse status",
  branchStatus: "Branch status",
  someRequiredInformationAreMissing: "Some required information are missing ",
  addAnExistentContact: "Add an existent contact",
  selectAContact: "Select a contact",
  hideInput: "Hide input",
  hideForm: "Hide form",
  createNewContact: "Create new contact",
  loadingData: "Loading Data...",
  qty: "Qty",
  isThisMaterialAnItem: "Is this material an item?",
  automationAndControlForIncreasedSupplyChainVisibility:
    "Automation and control for increased supply chain visibility.",
  youHavenTAddedAnyItemsYet: "You haven't added any items yet",
  youHavenTAddedAnyMaterialYet: "You haven't added any material yet",
  prices: "Prices",
  createNewPrice: "Create new price",
  price: "Price",
  addNewGroup: "Add new group",
  DimensionFee: "{dimension} Fee",
  searchAgent: "Search agent",
  preferredUplift: "Preferred Uplift",
  accessRuleName: "Access rule name",
  addAccessRule: "Add Access Rule",
  groupName: "Group name",
  newGroup: "New group",
  subTotal: "Subtotal",
  deleteThisLine: "Delete this line",
  thereMustBeAtLeastOneServiceInAGroup: "There must be at least one service in a group",
  deleteThisGroup: "Delete this group",
  thereMustBeAtLeastOneGroupInAPrice: "There must be at least one group in a price",
  editGroupName: "Edit group name",
  searchCurrency: "Search currency",
  searchService: "Search service",
  priceCreatedSuccessfully: "Price created successfully",
  groupAddedSuccessfully: "Group added successfully",
  serviceAddedSuccessfully: "Service added successfully",
  pressToConfirmGroupNameChange: "Press to confirm group name change",
  pressToCancelGroupNameChange: "Press to cancel group name change",
  fillNameAndPressSaveOrEnter: "Fill name and press save or enter",
  addNewLine: "Add new line",
  originCosts: "Origin costs",
  destinationCosts: "Destination costs",
  extras: "Extras",
  deleteThisPrice: "Delete this price",
  agentSelected: "Agent selected",
  pricingListUpdatedOn: "Pricing list updated on",
  noneAgentSelected: "None Agent selected",
  totalCosts: "Total costs",
  manageNeverBeenEasier: "Manage never been easier",
  visibilityAtItsBest: "Visibility at its best",
  shipeeziIsTheEssentialToolForCompaniesOfAllSizesToConsolidateAutomateAndUncomplicateInformationAndShipmentFlowAcrossTheGlobe:
    "Shipeezi is the essential tool for companies of all sizes to consolidate, automate and uncomplicate information and shipment flow across the globe.",
  saveTimeAndMoney: "Save time and money",
  withShipeeziVisibilityAndIncreasedControlIsDeliveredSavingMoreThan30InLogisticsCostsAnd60InTimeReporting:
    "With Shipeezi, visibility and increased control is delivered, saving more than 30% in logistics costs and 60% in time reporting.",
  createYourAccount: "Create your account",
  youAreJustMomentsAwayOfHavingFullVisibilityAndControlOverYourShipments:
    "You are just moments away of having full visibility and control over your shipments!",
  confirmPassword: "Confirm password",
  haveAnAccount: "Have an account?",
  signIn: "Sign in",
  shipeezi: "© Shipeezi",
  termsOfUse: "Terms of Use",
  passwordsDonTMatch: "*Passwords don't match",
  companyName: "Company name",
  companyType: "Company type",
  selectCompanyType: "Select company type",
  spShipper: "SP - Shipper",
  fmFreightManager: "FM - Freight Manager",
  mvMoving: "MV - Moving",
  getEmailsFromShipeeziAboutProductUpdatesIndustryNewsAndEventsIfYouChangeYourMindYouCanUnsubscribeAtAnyTime:
    "Get emails from Shipeezi about product updates, industry news, and events. If you change your mind, you can unsubscribe at any time.",
  byContinuingYouReAgreeingToShipeeziS: "By continuing, you're agreeing to Shipeezi's",
  requestAccount: "Request account",
  ourTeamWillGetInTouchWithYouAsSoonAsPossible:
    "Our team will get in touch with you as soon as possible.",
  thankYouForSignUpYouCanCheckYourEmailToProceed:
    "Thank you for sign up. You can check your email to proceed.",
  youWillReceiveAnEmailTo: "You will receive an email to",
  toConfirmYourSignUp: "to confirm your sign up.",
  thereWasAnErrorCreatingTheAccount: "There was an error creating the account",
  captcha: "Captcha",
  captchaExpired: "Captcha expired",
  and: "and",
  leaveVideoSurvey: "Leave video survey",
  wellDoneOnTheMeetingWith: "Well done on the meeting with",
  donTForgetWhatYouHaveAvailableFromThisMeeting:
    "Don’t forget what you have available from this meeting.",
  didYouLeaveTheMeetingByMistake: "Did you leave the meeting by mistake? ",
  rejoinTheMeetingHere: "Rejoin the meeting here",
  packingMaterial: "Packing Material",
  estimateQuote: "Estimate quote",
  agents: "Agents",
  editEstimate: "Edit estimate",
  charge: "Charge",
  quantity: "Quantity",
  rate: "Rate",
  margin: "Margin",
  markUp: "Mark up",
  discount: "Discount",
  totalCost: "Total cost",
  paymentMethod: "Payment Method",
  creditCard: "Credit Card",
  credit_card: "Credit Card",
  account: "Account",
  cash: "Cash",
  goBackToApp: "Go back to app",
  closeTab: "Close tab",
  openCommunication: "Open communication",
  enableMicrophone: "Enable microphone",
  disableMicrophone: "Disable microphone",
  enableCamera: "Enable camera",
  disableCamera: "Disable camera",
  shareScreen: "Share screen",
  stopSharingScreen: "Stop Sharing Screen",
  cannotShareScreenWhenAnotherUserIsSharing: "Cannot share screen when another user is sharing",
  screenSharingIsNotSupportedWithThisBrowser: "Screen sharing is not supported with this browser",
  emailConfirmationTimeHasExpired: "Email confirmation time has expired",
  thereWasAnErrorConfirmingTheEmail: "There was an error confirming the email",
  emailSuccessfullyConfirmed: "Email successfully confirmed",
  backToLoginPage: "Back to login page",
  goToShipeeziBlog: "Go to Shipeezi blog",
  isNowVerified: "is now verified!",
  chooseAPassword: "Choose a password",
  useLettersNumbersAndSymbolsForSafety: "Use letters, numbers and symbols for safety",
  confirmYourPassword: "Confirm your password",
  theSameOneFromAbove: "The same one from above",
  youJustNeedToCreateAPasswordForYourAccount:
    "You just need to create a password for your account.",
  predictiveDeparture: "Predictive departure:",
  departure: "Date of departure",
  arrival: "Arrival",
  nextPortArrival: "Next port arrival:",
  decimalSeparator: "Decimal separator",
  thousandSeparator: "Thousand separator",
  usePoint: "Use point (.)",
  useComma: "Use comma (,)",
  newService: "New service",
  createANewServiceOrGroup: "Create a new service or group",
  createNewGroup: "Create new group",
  inventoryList: "Inventory list",
  openLegacyVersion: "Open legacy version",
  closeThisScreen: "Close this screen",
  changeGroupStatus: "Change group status",
  noAssociatedService: "No associated service.",
  viewGroups: "View groups",
  groups: "Groups",
  seemsLikeYouDidnTCreateAnyGroup: "Seems like you didn't create any group :(",
  searchGroups: "Search groups",
  groupCosting: "Group costing",
  totalOfPrice: "Total of Price ",
  sent: "Sent",
  group: "Group",
  changeStatusTo: "Change status to",
  totalOf: "Total of",
  lastUpdated: "Last updated",
  thisServiceCannotBeActivatedBecauseIsUnavailable:
    "This service cannot be activated because is unavailable",
  thisServiceCannotBeEditedBecauseIsUnavailable:
    "This service cannot be edited because is unavailable",
  loadingPrices: "Loading prices",
  updatePrices: "Update prices",
  reviewPrices: "Review prices",
  editFile: "Edit file",
  uploadCsv: "Upload CSV",
  uploadCsvFile: "Upload csv file",
  downloadTemplate: "Download template",
  clickToDownloadThePriceTemplateAndFillPrices:
    "Click to download the price template and fill prices",
  noFilesUploaded: "No files uploaded",
  noneDataHasFilled: "None data has filled",
  fee: "Fee",
  thisServiceDoesNotExist: "This service does not exist",
  thereIsNoRelationshipBetweenThisServiceAndTheGroup:
    "There is no relationship between this service and the group",
  thisGroupDoesNotExist: "This group does not exist",
  thereIsNoRelationshipBetweenThisGroupAndTheService:
    "There is no relationship between this group and the service",
  theValueOfThisFieldIsInvalid: "The value of this field is invalid",
  thisCurrencyDoesNotExist: "This currency does not exist",
  nonGrouped: "Non grouped",
  wasEditedSuccessfully: "was edited successfully!",
  thisRecordCannotBeEditedBecauseThereIsAnErrorInTheServiceOrGroup:
    "This record cannot be edited because there is an error in the service or group",
  theseServicesWillNotBeUpdatedIfYouWouldLikeToCorrectThemYouShouldEditFile:
    "These services will not be updated. If you would like to correct them, you should edit file.",
  thisCanBeCorrectedIfYouClickIn: "This can be corrected if you click in ",
  latestUpload: "Latest upload",
  youCanOnlyContinueAfterAllWarningsHaveBeenResolved:
    "You can only continue after all warnings have been resolved",
  timeControl: "Time control",
  arrivedAtTheResidence: "Arrived at the residence",
  breakFrom: "Break from",
  to: "To",
  leavingTheResidence: "Leaving the residence",
  arrivedBackToTheWarehouse: "Arrived back to warehouse",
  timeSummary: "Time Summary",
  transitTime: "Transit time",
  breakTime: "Break time",
  workTime: "Work time",
  totalTime: "Total time",
  extraStaff: "Extra Staff",
  deleteSubscriber: "Delete subscriber",
  whenYouDeleteANotification:
    "When you delete a notification, the associated contact will receive no further alerts.",
  wouldYouLikeToProceed: "Would you like to proceed?",
  pricesUpdatedSuccessfully: "Prices updated successfully",
  weWillUpdateAllPricesDisregardingThoseMarkedWith:
    "We will update all prices, disregarding those marked with",
  ifYouWantToUpdateThesePricesYouShouldEditFile:
    "If you want to update these prices, you should edit file",
  newMessage: "New Message!",
  oopsIncorrectCredentials: "Oops! Incorrect credentials.",
  leaveWithoutSave: "Leave without save",
  youHaveUnsavedChangesAreYouSureYouWantToLeave:
    "You have unsaved changes. Are you sure you want to leave?",
  youShouldSaveYourWorkBeforeLeaving: "You should save your work before leaving.",
  doYouReallyWantToDeleteThisAgent: "Do you really want to delete this agent",
  agentDetails: "Agent details",
  toAllowYourPasswordReset: "to allow your password reset.",
  sorryTheLinkHasExpired: "Sorry, the link has expired.",
  theResetPasswordLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow:
    "The reset password link has expired. You can request a new one by clicking on the button below.",
  resetPasswordLink: "Reset password link",
  emailSuccessfullyResent: "Email successfully resent",
  anUnknownErrorHasOccurred: "An unknown error has occurred",
  emailOrUsernameIsRequired: "Email or Username is required",
  passwordIsRequired: "Password is required",
  userLoggedIn: "User Logged In",
  thereWasAnErrorCapturingYourEmailToResend: "There was an error capturing your email to resend",
  theEmailConfirmationLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow:
    "The email confirmation link has expired. You can request a new one by clicking on the button below.",
  resendConfirmationLink: "Resend confirmation link",
  thankYouForRequestingAnAccountWithShipeezi: "Thank you for requesting an account with Shipeezi.",
  ourTeamWillBeInContactWithYouPriorToActivatingYourAccount:
    "Our team will be in contact with you prior to activating your account.",
  companyDetails: "Company Details",
  uploadCentre: "Upload Centre",
  goBackToHomePage: "Go back to home page",
  goBackToLogin: "Go back to login",
  goBackToLoginPage: "Go back to login page",
  previous: "Previous",
  skip: "Skip",
  downloadOurCsvTemplateHere: "Download our CSV template here",
  addAdditionalUsers: "Add additional users",
  theContactDetailsUsedToRegisterHasBecomeAnAdminUserAlready:
    "The contact details used to register has become an admin user already.",
  registeredUsers: "Registered users",
  addUser: "Add user",
  aud: "AUD",
  youCanSelectToUploadYourOwnFilesInformationNowOrLaterIfYouPreferYouCanUseOurDefaultInformationTheseInformationIsInRegardsToYourInventoryItemsServicesFleetStaffAndSoOn:
    "You can select to upload your own files (information) now or later. If you prefer, you can use our default information.These information is in regards to your inventory items, services, fleet, staff and so on.",
  uploadOwnList: "Upload own list",
  useShipeeziSDefaultList: "Use Shipeezi's default list",
  inventoryListIso174511: "Inventory list ISO17451-1:2016 Certified",
  usingShipeeziSDefault: "Using Shipeezi's default",
  itemsRoomsPackagingTypeMethodOfPreparationModeTypeExceptionCodesExceptionLocationCodeItemInstructionsAndItemDestination:
    "Items, Rooms, Packaging type, Method of preparation, Mode type, Exception codes, Exception location code, Item instructions and Item destination.",
  checklistForm: "Checklist & Form",
  riskAssessmentTemplate: "Risk assessment template",
  usingShipeeziSSampleData: "Using Shipeezi's sample data",
  listOfMaterials: "List of Materials",
  aFewCommonTypesOfPackingMaterialsWillBeLoaded:
    "A few common types of packing materials will be loaded",
  services: "Services",
  oneServiceTypeWillBeCreated: "One service type will be created",
  oneStaffWillBeCreated: "One staff will be created",
  oneVehicleWillBeCreated: "One vehicle will be created",
  theseInstructionsCanBeUsedInTheSalesAndOperationsAppForUpliftDeliveryOrMoveCoordinator:
    "These instructions can be used in the Sales and Operations app for uplift, delivery or move coordinator",
  usualAccessQuestionsWillBeCreatedHere: "Usual access questions will be created here",
  iso174511CertifiedItems:
    "ISO17451-1:2016 Certified: Items, Rooms, Packaging type, Method of preparation, Mode type, Exception codes, Exception location code, Item instructions and Item destination.",
  csvUploaded: "CSV Uploaded",
  asPerYourSelectionWeAreGoingToUploadTheStandardContentForTheFollowingSections:
    "As per your selection, we are going to upload the standard content for the following sections:",
  youCanChooseFromTheListBelowWhichItemsYouWantToUploadAndWhichYouWantToUseShipeeziSDefault:
    "You can choose from the list below which items you want to upload and which you want to use shipeezi's default:",
  weAreLoadingTheUploadedContentPleaseWait: "We are loading the uploaded content, please wait",
  thisMightTakeAWhile: "This might take a while",
  ifThisIsTakingTooMuchLonger: "If this is taking too much longer,",
  tryAgainHere: "try again here",
  thankYouForCompleteThisProcess: "Thank you for completing the quick setup process.",
  readyToStartUsingShipeezi: "Ready to start using Shipeezi?",
  getStarted: "Get started",
  confirmationEmailHasBeenSucessfullyResent: "Confirmation email has been sucessfully resent!",
  confirmationEmailCouldNotBeenResent: "Confirmation email could not been resent!",
  resetUserPassword: "Reset user password",
  businessLogo: "Business Logo",
  businessIcon: "Business Icon",
  addLogo: "Add Logo",
  choosePicture: "Choose picture",
  maxSize: "Max size",
  formats: "Formats",
  crop: "Crop",
  version: "Version",
  profile: "Profile",
  emailToResetPasswordSent: "Email to reset password sent",
  "2Mb": "2 MB",
  maxFileSize: "Max file size:",
  fileTypes: "File types:",
  accountDetails: "Account details",
  csvTemplateIsInvalid: "CSV template is invalid",
  line: "Line",
  isRequired: "is required",
  mustBeOneOfTheValidOptions: "must be one of the valid options",
  mustBeFilledInWithXOrLeftEmpty: 'must be filled in with "x" or left empty',
  mustBeANumber: "must be a number",
  mustBeADateWithTheFormatDdMmYyyy: "must be a date with the format dd/mm/yyyy",
  errorsFound: "Errors found",
  errorsFoundInYourFile: "Errors found in your file",
  on: "On",
  csvWeHaveFoundSomeErrorsYouShouldAdjustThoseLinesToProceed:
    "csv, we have found some errors. You should adjust those lines to proceed:",
  donTKnowWhatSWrong: "Don't know what's wrong?",
  downloadOurTemplateHere: "Download our template here",
  downloadOurTemplate: "Download our template",
  logout: "Logout",
  logOut: "Log out",
  userProfile: "User profile",
  helpCenter: "Help center",
  dispatchFilters: "Dispatch filters",
  allTasks: "All tasks",
  allTeams: "All teams",
  unpublishedTasks: "Unpublished tasks",
  publishedTasks: "Published tasks",
  teamsWithUnpublishedTasks: "Teams with unpublished tasks",
  teamsWithPublishedTasks: "Teams with published tasks",
  someChangesMayTakeSomeTimeToBeAppliedOnThisScreen:
    "Some changes may take some time to be applied on this screen",
  thisFleetIsUnavailableOnThisDate: "This fleet is unavailable on this date",
  thisMemberIsUnavailableOnThisDate: "This member is unavailable on this date",
  theFilteredDataAffectsWhatYouSeeOnDispatch:
    "The filtered data affects what you see on ‘Dispatch’",
  termsAndConditions: "Terms and Conditions",
  currentlyViewing: "Currently viewing",
  changeTo: "Change to",
  switchingAccounts: "Switching accounts.",
  unknown: "Unknown",
  messageHasBeenSentSuccessfully: "Message has been sent successfully!",
  avatar: "Avatar",
  approvingCompany: "Approving company...",
  theCompanyHasBeenApproved: "The company has been approved!",
  nowIsReadyToRockAndRoll: "now is ready to rock and roll.",
  quoteType: "Quote Type",
  allProjects: "All Projects",
  typeMobile: "Type Mobile",
  searchForTimezone: "Search for time zone",
  inviteUser: "Invite user",
  userEmail: "User email",
  userAddedSuccessfully: "User added successfully",
  unableToRegisterAdditionalUser: "Unable to register additional user",
  inviteSentSuccessfully: "Invite sent successfully!",
  saveAndInvite: "Save and invite",
  createAndInvite: "Create and invite",
  anEmailWasSentToUsernameWithYourRequest: "An email was sent to *username* with your request",
  companyInvitation: "Company invitation",
  inviteDeclined: "Invite declined",
  youHaveBeenInvitedToBePartOf: "You have been invited to be part of ",
  youHaveBeenInvitedToBePartOfCompany: "You have been invited to be part of company",
  youCanAcceptOrDeclineTheInvitationAndWeWillNotifyTheCompanyAdministrator:
    "You can accept or decline the invitation and we will notify the company administrator.",
  weWillNotifyTheAdministrator: "We will notify the Administrator.",
  weWillNotifyTheAdministratorFor: "We will notify the Administrator for",
  youCanCloseThisWindow: "You can close this window",
  ifYouRejectedThisInvitationByMistakePleaseRequestANewInvite:
    "If you rejected this invitation by mistake, please request a new invite",
  here: "here",
  yourInvitationExpired: "Your invitation expired",
  companyUpdatedSuccessfully: "Company updated successfully",
  termsAcceptedSuccessfully: "Terms accepted successfully",
  by: "by",
  entityName: "Entity name",
  sorryTheLinkIsBroken: "Sorry, the link is broken",
  theInviteLinkIsBroken: "The invite link is broken.",
  theInviteLinkIsBrokenYouCanRequestANewOneByClickingOnTheButtonBelow:
    "The invite link is broken. You can request a new one by clicking on the button below.",
  resendInviteLink: "Resend invite link",
  goBack: "Go back",
  theInviteLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow:
    "The invite link has expired. You can request a new one by clicking on the button below.",
  thisFieldIsAnInvalidUrl: "This field is an invalid url",
  thisFieldShouldHaveDigitsOnly: "This field should have digits only",
  validFormats: "Valid Formats",
  typeOfInstruction: "Type of instruction",
  inputYourInstruction: "Input your instruction",
  asYouAddedAnItemThatDoesNotBelongToTheIso174511:
    "As you added 'an item' that does not belong to the ISO17451-1:2016, your inventory list does not comply.",
  requestingNewInvite: "Requesting new invite",
  youHaveAlreadyAcceptedThisInvitation: "You have already accepted this invitation!",
  loadingInvitation: "Loading invitation...",
  userHasNotBeenInvited: "User has not been invited",
  navigation: "Navigation",
  someOfTheseEmailsProvidedIsInvalid: "Some of these emails provided is invalid",
  isThisAnItemDestination: "Is this an item destination?",
  ssccQty: "SSCC Qty",
  etdAtOrigin: "ETD at Origin",
  etaAtDestination: "ETA at Destination",
  subjects: "Subjects",
  favorites: "Favorites",
  reports: "Reports",
  company: "Company",
  itFeelsEmptyRightNow: "It feels empty right now.",
  status: "Status",
  filter: "Filter",
  reference: "Reference",
  referenceNumber: "Reference number",
  customer: "Customer",
  pdf: "PDF",
  csv: "CSV",
  exportAs: "Export as",
  tags: "Tags",
  nothingToShowHereYet: "Nothing to show here yet.",
  thisWarehouseDoesNotAllowStorageOfLooseItemsSelectAStorageBoxInstead:
    "This warehouse does not allow storage of loose items. Select a storage  box instead.",
  iConfirmThatAllTheDetailsAboveAreTrue: "I confirm that all the details above are true",
  notInformed: "Not informed",
  signHere: "Sign here",
  expandAllTasks: "Expand all tasks",
  hideAllTasks: "Hide all tasks",
  checkIfAnyOfTheTasksEligibleForReportGenerationUpliftDeliveryLocalHasBeenCompletedAndHasADate:
    "Check if any of the tasks eligible for report generation (Uplift, Delivery, Local) has been completed and has a date",
  asn: "ASN",
  containerSize: "Container size",
  selectOne: "Select one",
  seal: "Seal",
  consignee: "Consignee",
  consigneeCode: "Consignee code",
  deliverToWarehouse: "Deliver to Warehouse",
  serviceType: "Service type",
  shipTerms: "Ship terms",
  mbl: "MBL",
  hbl: "HBL",
  loadingPort: "Loading Port",
  destinationPort: "Destination Port",
  dischargePort: "Discharge Port",
  searchAddress: "Search address",
  shipperOriginAirport: "Shipper Origin Airport",
  receiverDestinationAirport: "Receiver Destination Airport",
  airports: "Airports",
  ports: "Ports",
  roads: "Roads",
  scannedDate: "Scanned date",
  pickUpFromOrigin: "Pick up from Origin",
  ataAtOrigin: "ATA at Origin",
  ataAtDestination: "ATA at Destination",
  actualDeliveryDate: "Actual Delivery Date",
  senderOriginRoad: "Sender Origin Road",
  receiverDestinationRoad: "Receiver Destination Road",
  roadName: "Road Name",
  estimatedDeliveryDate: "Estimated Delivery Date",
  noReportsAddedToFavorites: "No reports added to favorites",
  go: "Go",
  itemInstructions: "Item instructions",
  chooseAnItemInstruction: "Choose an item instruction",
  notHaveDatesYet: "Not have dates yet",
  videoSurveyRecordDeleted: "Video survey record deleted",
  theVideoRecordedForThisSurveyWasDeletedAsTheStatusHasChangedTo:
    "The video recorded for this survey was deleted as the status has changed to",
  youDoNotHaveAccessToThisRecordAnymore: "You do not have access to this record anymore.",
  diary: "Diary",
  day: "Day",
  days: "Days",
  see: "See",
  moreTasks: "more tasks",
  sequenceMustBeAValidNumber: "*Sequence must be a valid number",
  sequenceMustBeAIntegerNumber: "*Sequence must be a integer number",
  sequenceMustBeGreaterThan0: "*Sequence must be greater than 0",
  sequenceMustBeSmallerThan1000: "*Sequence must be smaller than 1000",
  noTasksRegisteredForTheDay: "No tasks registered for the day",
  startsAt: "Starts at: ",
  search: "Search",
  seeTaskOnOrder: "See task on order",
  taskDetails: "Task details",
  storageBoxes: "Storage boxes",
  storageBoxTypes: "Storage box types",
  prepayment: "Prepayment",
  noneInformationToShow: "None information to show",
  tasks: "Tasks",
  assignTask: "Assign task",
  printJob: "Print job",
  cancelTask: "Cancel task",
  yesCancelTask: "Yes, cancel task",
  areYouSureYouWantToCancelThisTask: "Are you sure you want to cancel this task?",
  searchByFleet: "Search by fleet",
  searchByStaff: "Search by staff",
  searchByLeader: "Search by leader",
  searchByStorageBox: "Search by Storage Box",
  orderReference: "Order Reference",
  taskStartsAt: "Task starts at",
  languageName: "Language name",
  australianEnglishSystem: "Australian English (System)",
  thisIsTheName: "This is the name",
  term: "Term",
  createdBy: "Created by",
  lengthM: "Length(m)",
  taskList: "Task List",
  exception: "Exception codes",
  cancelled: "Cancelled",
  labelTooltipRecording: "Recording",
  labelTooltipNotRecording: "Not recording",
  youAreNotAllowedToEditThisQuote: "You are not allowed to edit this Quote",
  youAreNotAllowedToEditThisOrder: "You are not allowed to edit this Order",
  fileDownloadComplete: "File download complete",
  scheduleNow: "Schedule now",
  videoSurveyUnavailable: "Video survey unavailable",
  thisVideoSurveyHasBeenClosed: "This video survey has been closed",
  pleaseScheduleAnotherSurveyToContinue: "Please schedule another survey to continue",
  youCanScheduleAnotherVideoSurveyNowOrLater: "You can schedule another video survey now or later",
  theCustomerHasRemovedTheCallRecordingPermission:
    "The customer has removed the call recording permission",
  theCustomerAllowedTheRecordThisCallIsBeingRecordedFromNowOn:
    "The customer allowed the record. This call is being recorded from now on.",
  recordingVS: "Recording",
  notRecording: "Not recording",
  readyToShip: "Ready to ship",
  port: "Port",
  deliverTo: "Deliver to",
  plane: "Plane",
  journey: "Journey",
  airwayBill: "Airway Bill",
  cfs: "CFS",
  addNewContainer: "Add new container",
  acmeClothing: "Acme clothing",
  purchasingOrganisation: "Purchasing Organisation",
  orderNumber: "Order Number",
  amosToken: "AMOS Token",
  token: "Token",
  australia: "Australia",
  sistrs: "SISTRS",
  pleaseEnterAValidToken: "Please enter a valid token",
  revokeConnection: "Revoke connection",
  areYouSureYouWantToRevokeTheConnection: "Are you sure you want to revoke the connection?",
  amos: "AMOS",
  copyKey: "Copy key",
  inviteSISTR: "Invite SISTR",
  editSISTR: "Edit SISTR",
  SISTRemail: "SISTR email",
  emailAlreadyExists: "Email already exists",
  waybills: "Waybills",
  moreOrders: "More orders",
  etd: "ETD",
  print: "Print",
  seeReport: "See report",
  reportType: "Report type",
  uploaded: "Uploaded",
  uploadFile: "Upload file",
  documentsUploaded: "Documents uploaded",
  dragOrClickToUploadYourFile: "Drag or click to upload your file",
  waybill: "Waybill",
  estimateDates: "Estimate Dates",
  aircraftDestination: "Aircraft Destination",
  aircraftOrigin: "Aircraft Origin",
  aircraft: "Aircraft",
  unpackDate: "Unpack Date",
  pickDate: "Pick Date",
  arrivalOfDestination: "Date of Delivery",
  cancelShipment: "Cancel Shipment",
  image: "Image",
  billOfLanding: "Bill of Lading",
  enterBillOfLanding: "Enter Bill of Lading",
  billOfLandingMustBeAtLeast7CharactersLong: "Bill of Lading must be at least 7 characters long",
  billOfLandingMustBeAtMax20CharactersLong: "Bill of Lading must be at max 20 characters long",
  tradingName: "Trading name",
  youCanGetStartedTrackingShipmentsFromHereRegardlessOfHowManyForwardersOrRoutes:
    "You can get started tracking shipments from here, regardless of how many forwarders or routes.",
  eitherUploadACsvFileUsingTheTemplateOrClickNextToEnterAContainerNumber:
    "Either upload a csv file using the template or click next to enter a container number.",
  uploadYourShipmentDetails: "Upload your shipment details",
  due: "Due",
  notDefined: "Not defined",
  viewFile: "View file",
  downloadCsv: "Download CSV",
  thisFileIsRequired: "This file is required",
  tryAgain: "try again",
  tryAgain2: "Try again",
  ifThisIsTakingTooLong: "If this is taking too long,",
  uploadMade: "Upload made",
  theFileMustBeLessThan2mbInSize: "The file must be less than 2 MB in size",
  invite: "Invite",
  inviteSupplier: "Invite supplier",
  inviteSuppliers: "Invite suppliers",
  doYouWantToInvite: "Do you want to invite",
  toShipeezi: "to Shipeezi?",
  anInvitationWillBeSendTo: "An invitation will be send to",
  activeContainers: "Active Containers",
  avgContainerPerWeek: "Avg Containers per Week",
  containersDelayed: "Containers Delayed",
  containersWaitingAtGate: "Containers Waiting at gate",
  totalContainers: "Total Containers",
  containersTracked: "Containers Tracked",
  averageDelay: "Average delay",
  shipmentsTracked: "Shipments Tracked",
  currentVesselsWithShipmentsBeingTracked: "Current vessels with shipments being tracked",
  ctaDate: "CTA Date",
  teu: "TEU",
  atd: "ATD",
  actualTimeOfDeparture: "Actual Time of Departure",
  etaDate: "ETA Date",
  arrivalDate: "Arrival Date",
  via: "Via",
  customerEmail: "Customer email",
  estimatedDate: "Estimated date",
  estimatedTimeOfPortArrival: "Estimated Time of Port Arrival",
  estimatedTimeOfAirportArrival: "Estimated Time of Airport Arrival",
  companyLogo: "Company Logo",
  yourShipmentIsExpectedToArriveAt: "Your shipment is expected to arrive at",
  poweredBy: "Powered by",
  localTime: "Local time",
  booked: "Booked",
  collectedFromShipper: "Collected from shipper",
  notArrivedAtPortOfLoad: "Not arrived at port of load",
  waitingAtPortOfLoad: "Waiting at port of load",
  shippedOnBoard: "Shipped on board",
  underway: "Underway",
  underwayToATranshipmentPort: "Underway to a transhipment port",
  arrivalAtTranshipmentPort: "Arrival at transhipment port",
  waitingAtTranshipmentPort: "Waiting at transhipment port",
  shippedOnBoardAtTranshipmentPort: "Shipped on board at Transhipment Port",
  arrivedAtPortOrDischarge: "Arrived at Port or Discharge",
  waitingAtDestinationPort: "Waiting at Destination Port",
  leftTheDestinationPort: "Left the destination port",
  shipmentCompleted: "Shipment completed",
  maerskCode: "Maersk Code",
  maerskBeCode: "Maersk BE Code",
  clientCode: "Client Code",
  addressCode: "Address Code",
  divisionCode: "Division Code",
  divisionDescription: "Division Description",
  departmentCode: "Department Code",
  departmentDescription: "Department Description",
  sscc: "SSCC",
  ssccQuantity: "SSCC Quantity",
  quantityUnit: "Quantity Unit",
  purchasePrice: "Purchase Price",
  style: "Style",
  colour: "Colour",
  size: "Size",
  expand: "Expand",
  deleteThisSsccAndYourProducts: "Delete this SSCC and your products",
  purchaseOrders: "Purchase Orders",
  addNewOrder: "Add new order",
  orderDate: "Order date",
  shipper: "Shipper",
  readyForBooking: "Ready for booking",
  selectOrdersBelowToAddThem: "Select orders below to add them",
  expectedStartDate: "Expected Start Date",
  expectedEndDate: "Expected End Date",
  assigned: "Assigned",
  bookByDate: "Book by Date",
  createBooking: "Create Booking",
  confirmed: "Confirmed",
  underReview: "Under Review",
  received: "Received",
  pending: "Pending",
  loadingBookings: "Loading Bookings",
  scanned: "Scanned",
  noThanks: "No, thanks",
  cancelBooking: "Cancel booking",
  areYouSureYouWantToCancelTheBooking: "Are you sure you want to cancel the booking",
  scannedItems: "Scanned items",
  thisOrderIsCancelled: "This order is cancelled",
  packingType: "Packing Type",
  conditionAtOrigin: "Condition at Origin",
  conditionAtDestination: "Condition at Destination",
  conditionsAtOrigin: "Conditions at origin",
  conditionsAtDestination: "Conditions at destination",
  conditionAt: "Condition at",
  upgradeVersionToDoThis: "Upgrade version to do this",
  viewProduct: "View Product",
  hscode: "HSCODE",
  unitPrice: "Unit Price",
  totalPrice: "Total Price",
  shipDate: "Ship Date",
  fobPrice: "FOB Price",
  createSSCC: "Create SSCC",
  newSSCCwasCreated: "A new SSCC was created!",
  finish: "Finish",
  closeSSCC: "Close SSCC",
  noInformations: "No informations",
  itsCurrentlyLocatedAt: "is currently located at",
  atPosition: "at position",
  asReportedByMarineTrafficTerrestrialAutomaticIdentificationSystem:
    "as reported by MarineTraffic Terrestrial Automatic Identification System on",
  theVesselIsCurrentlyAtPort: "The vessel is currently at port",
  afterAVoyageOriginatingFromPort: "after a voyage originating from port",
  currentLocation: "Current location",
  delayTime: "Delay time",
  newETA: "New ETA",
  sendTrackingLinkToACustomer: "Send tracking link to a customer or someone else",
  areYouSureYouWantToCloseThisSSCC: "Are you sure you want to close this SSCC?",
  thisActionCannotBeUndoneAndIfYouWantToModifyThisSSCCYouMustDeleteItAndCreateANewOne:
    "This action cannot be undone and if you want to modify this SSCC, you must delete it and create a new one",
  selectProductsBelowToAddThemToSSCC: "Select products below to add them to SSCC",
  printLabel: "Print label",
  allSelectedSsccMustBeClosedToBePrinted: "All selected sscc must be closed to be printed",
  moreContainers: "More containers",
  portOfOrigin: "Port of Loading (PoL)",
  consignmentInfo: "Consignment Info",
  originAgent: "Origin Agent",
  destinationAgent: "Destination Agent",
  estimateTimeOfDeparture: "Time of Departure",
  estimateTimeOfArrival: "Time of Arrival",
  atDepartureDock: "At departure dock",
  inactivateWaybill: "Inactivate Waybill",
  inactiveWaybill: "Inactive Waybill",
  pleaseAddAValidContainerNumber: "Please, add a valid container number",
  waitingForUpdate: "Waiting for update",
  generated: "Generated",
  containerNumberIsInvalid: "Container number is invalid",
  itemConditions: "Item conditions",
  addAPhoto: "Add a photo",
  conditionsAdded: "Conditions added",
  noConditions: "No conditions",
  noPhotosAdded: "No photos added",
  itemDescription: "Item description",
  pleaseSelectADescriptiveSymbol: "Please, select a descriptive symbol",
  cbm: "CBM",
  submitted: "Submitted",
  rejected: "Rejected",
  partiallyDelivered: "Partially Delivered",
  bookingMustBeConfirmed: "Booking must be confirmed",
  notificationCentre: "Notification Centre",
  notificationCenter: "Notification Center",
  addEmailTemplate: "Add Email Template",
  from: "From",
  subject: "Subject",
  bcc: "Bcc",
  createNewTemplate: "Create new template",
  templateName: "Template name",
  newTemplate: "New template",
  emailDetails: "Email Details",
  emailContent: "Email Content",
  editEmailTemplate: "Edit Email Template",
  viewEmailTemplate: "View Email Template",
  smsDetails: "SMS Details",
  smsContent: "SMS Content",
  pushNotificationDetails: "Push Notification Details",
  pushNotificationContent: "Push Notification Content",
  use178CharactersOrLessForBestDisplay: "Use 178 characters or less for best display",
  smsCharacterLimitHint: "SMS messages over 168 characters will be split into multiple messages.",
  selectATemplate: "Select a Template",
  addSMSTemplate: "Add SMS Template",
  editSMSTemplate: "Edit SMS Template",
  viewSMSTemplate: "View SMS Template",
  quoteCreation: "Quote Creation",
  quoteApproval: "Quote Approval",
  quoteDecline: "Quote Decline",
  ordersCreation: "Orders Creation",
  orderDelivered: "Order Delivered",
  orderCancelled: "Order Cancelled",
  createNewDocument: "Create new document",
  documentGenerated: "Document generated",
  resendInvite: "Resend Invite",
  downloadBookingFile: "Download booking file",
  createAndBook: "Create and book",
  saveAndBook: "Save and book",
  editBooking: "Edit Booking",
  viewBooking: "View Booking",
  liveAnimalsAndFish: "Live animals and fish",
  cerealGrains: "Cereal grains",
  otherAgriculturalProducts: "Other agricultural products",
  feedAndProductsOfAnimalOrigin: "Feed and products of animal origin",
  meatAndSeafood: "Meat and seafood",
  milledGrainProducts: "Milled grain products",
  otherPreparedFoodstuffs: "Other prepared foodstuffs",
  alcoholicBeverages: "Alcoholic beverages",
  tobaccoProducts: "Tobacco products",
  buildingStone: "Building stone",
  naturalSands: "Natural sands",
  gravelAndCrushedStone: "Gravel and crushed stone",
  otherNonmetallicMinerals: "Other nonmetallic minerals",
  metallicOres: "Metallic ores",
  coal: "Coal",
  crudePetroleum: "Crude petroleum",
  gasolineKeroseneAndEthanol: "Gasoline, kerosene, and ethanol",
  dieselAndOtherFuelOils: "Diesel and other fuel oils",
  otherFossilFuelProducts: "Other fossil fuel products",
  basicChemicals: "Basic chemicals",
  pharmaceuticalProducts: "Pharmaceutical products",
  fertilizers: "Fertilizers",
  chemicalProductsAndPreparations: "Chemical products and preparations",
  plasticsAndRubber: "Plastics and rubber",
  logsAndWoodInTheRough: "Logs and wood in the rough",
  woodProducts: "Wood products",
  pulpPaperAndPaperboard: "Pulp, paper, and paperboard",
  paperOrPaperboardArticles: "Paper or paperboard articles",
  printedProducts: "Printed products",
  textilesAndLeather: "Textiles and leather",
  nonmetallicMineralProducts: "Nonmetallic mineral products",
  metalInBasicShapes: "Metal in basic shapes",
  articlesOfMetal: "Articles of metal",
  machinery: "Machinery",
  electronics: "Electronics",
  motorizedAndOtherVehicles: "Motorized and other vehicles",
  otherTransportationEquipment: "Other transportation equipment",
  precisionInstruments: "Precision instruments",
  furniture: "Furniture",
  miscellaneousManufacturedProducts: "Miscellaneous manufactured products",
  wasteAndScrap: "Waste and scrap",
  mixedFreight: "Mixed freight",
  commodity: "Commodity",
  fillThisFieldBeforeAddingAnotherContainer: "Fill this field before adding another container",
  youShouldHaveAtLeastOneProductInsideAnSSCCToCloseIt:
    "You should have at least one product inside an SSCC to close it",
  thisSupplierIsPartOfShipeezi: "This supplier is part of shipeezi",
  supplierNotFound: "Supplier not found",
  thisSupplierNotHaveNameToSendInvitation: "This supplier not have name to send invitation",
  thisSupplierDoesNotHaveAnEmailToSendInvitation:
    "This supplier does not have an email to send invitation",
  emails: "emails",
  youCannotInviteInactiveSuppliers: "You cannot invite inactive suppliers",
  financials: "Financials",
  communicationCentre: "Communication Centre",
  communication_centre: "Communication Centre",
  notificationTemplates: "Notification Templates",
  communicationCentreDescription:
    "Manage your communication templates, notifications, and settings in one central location.",
  templateCreatedSuccessfully: "Template created successfully",
  templateUpdatedSuccessfully: "Template updated successfully",
  templateDuplicatedSuccessfully: "Template duplicated successfully",
  errorCreatingTemplate: "Error creating template",
  duplicateTemplate: "Duplicate Template",
  editTemplate: "Edit Template",
  preFilled: "Pre-filled",
  emailTemplates: "Email Templates",
  emailTemplate: "Email template",
  manageEmailTemplatesDescription:
    "Create and manage email templates for various communication needs.",
  smsTemplates: "SMS Templates",
  smsTemplate: "SMS template",
  pushContentCannotExceed: "Push notification content cannot exceed 178 characters",
  smsContentCannotExceed: "SMS content cannot exceed 168 characters",
  manageSmsTemplatesDescription: "Create and manage SMS templates for quick notifications.",
  manageNotificationsDescription: "Configure notification preferences and settings.",
  communicationSettings: "Communication Settings",
  configureCommunicationSettingsDescription:
    "Set up communication preferences and delivery options.",
  clickToManage: "Click to manage",
  searchTemplates: "Search templates...",
  noTemplatesFound: "No templates found",
  content: "Content",
  availableIn: "Available in",
  areYouSureYouWantToChangeTheStatus: "Are you sure you want to change the status?",
  beneficiaryDetails: "Beneficiary details",
  beneficiaryBank: "Beneficiary bank",
  accountNumber: "Account number",
  invoiceNumber: "Invoice number",
  invoiceNo: "Invoice No",
  ciDate: "CI Date",
  financialsUpdatedSuccessfully: "Financials updated succesfully",
  yourShipmentInformationIsLoading: "Your shipment information is loading",
  conditionAddedSuccessfully: "Condition added successfully",
  atDestination: "At destination",
  someSelectedSupplierHasNoName: "Some selected supplier has no name",
  someSelectedSupplierDoesNotHaveAnEmail: "Some selected supplier does not have an email",
  allSelectedSuppliersMustHaveNameEmailAndNotYetBelongToShipeezi:
    "All selected suppliers must have name, email and not yet belong to Shipeezi",
  photoAddedSuccessfully: "Photo added successfully",
  generalSettings: "General Settings",
  invalidTag: "Invalid tag",
  removeOrder: "Remove order",
  houseAirWaybill: "House air waybill",
  removeSelected: "Remove Selected",
  createWarehouse: "Create Warehouse",
  noWarehousesToShow: "No warehouses to show",
  statusUpdatedSuccessfully: "Status updated successfully",
  supplierPortal: "Supplier Portal",
  youreReadyToGo: "You’re ready to go!",
  goToLoginPage: "Go to login page",
  onUploadedCsvWeHaveFoundSomeErrors: "On uploaded csv, we have found some errors",
  youShouldAdjustThoseLinesToproceed: "You should adjust those lines to proceed",
  youreNowPartOfOurPortal: "You’re now part of our portal!",
  ssccGeneration: "SSCC Generation",
  mustHave: "Must have",
  digit: "digit",
  digits: "digits",
  extensionDigit: "Extension Digit",
  gs1CompanyCode: "GS1 Company Code",
  checkDigit: "Check Digit",
  columnMustBeFilled: "column must be filled",
  notFound: "not found",
  isNotValid: "is not valid",
  carton: "Carton",
  alreadyHasTheLimitOfProductsInside: "already has the limit of products inside",
  thereAreNoRecordsInThisFile: "There are no records in this file",
  importance: "Importance",
  important: "Important",
  notImportant: "Not important",
  markAsUnread: "Mark as unread",
  markAsRead: "Mark as read",
  markAsImportant: "Mark as important",
  unmarkAsImportant: "Unmark as important",
  importantNotifications: "Important notifications",
  markAllAsRead: "Mark all as read",
  seeAllNotifications: "See all notifications",
  ssccOpen: "SSCC open",
  contactVia: "Contact via",
  orderedQuantity: "Ordered Quantity",
  percentage: "Percentage",
  areYouSureYouWantToConfirmThisBooking: "Are you sure you want to confirm this booking",
  onceConfirmedThisWillBeSentTo: "Once confirmed this will be sent to",
  youAreNotAbleToMakeAnyAdditionalChanges: "you are not able to make any additional changes",
  valueShouldBeBetween: "Value should be between",
  valueShouldBe: "Value should be",
  someQuantitiesFulilledAreWrongPleaseReviewAndChangeValues:
    "Some quantities fulfilled are wrong. Please, review and change values.",
  areYouSureYouWantToDeleteThisShipment: "Are you sure you want to cancel this shipment?",
  yesDeleteShipment: "Yes, cancel this shipment",
  deleteShipment: "Delete Shipment",
  editWaybill: "Edit Waybill",
  createWaybill: "Create Waybill",
  youCannotAddTheSameAgent: "You cannot add the same agent",
  saveAndSubscribe: "Save and subscribe",
  theProductsMustBelongToTheSameOrder: "The products must belong to the same order",
  youShouldSelectTheProducts: "You should select the products",
  haveProductsFromMultipleOrders: "Have the products from multiple orders",
  portOfLoading: "Port of Loading",
  portOfDischarge: "Port of Discharge",
  placeOfReceipt: "Place of Receipt",
  shipperDischargeAirport: "Shipper Discharge Airport",
  shipperReceiptAirport: "Shipper Receipt Airport",
  cargoReadyDate: "Cargo Ready Date",
  hasAlreadyBeenAssigned: "has already been assigned",
  isMissingShipByDate: "is missing Ship by Date",
  shipByDateIsToEarlyForBooking: "Ship by Date is too early for booking",
  shipByDateIsToLateForBooking: "Ship by Date is too late for booking",
  office: "Office",
  offices: "Offices",
  notifyParty: "Notify Party",
  youMustSelectABookingModeFirst: "You must select a booking mode first",
  isDifferentFromBooking: "is different from booking",
  youMustSelectABookingLoadingPortFirst: "You must select a booking loading port first",
  youMustSelectABookingDestinationPortFirst: "You must select a booking destination port first",
  orderAssociated: "Order associated",
  selectOrder: "Select order",
  youMustSelectABookingDischargePortFirst: "You must select a booking discharge port first",
  youMustSelectedABookingCargoReadyDateFirst: "You must select a booking cargo ready date first",
  mustHaveFourteenDifferenceAtMaxFromCargoReadyDate:
    "must have 14 days difference at max from cargo ready date",
  theLimitOfProductsInsideACartonIs: "The limit of products inside a carton is",
  tolerancePercentage: "Tolerance Percentage",
  activatingThisWillControlTheTolerancePercentageOfProductsInsideABookingToTheDefinedValue:
    "Activating this will control the tolerance percentage of products inside a booking to the defined value.",
  theInputValueWillBeConvertedIntoAPercentage:
    "The input value will be converted into a percentage",
  youNeedToMatchTheToleranceOfTheRequestedQuantities:
    "You need to match the tolerance of the requested quantities",
  atLeastOneCartonIsRequiredToCarryOutTheBooking:
    "At least one carton is required to carry out the booking",
  allCartonsMustContainAtLeastOneProduct: "All cartons must contain at least one product",
  valueMustBeGreaterThanZero: "*Value must be greater than zero",
  allSelectedProductsMustMeetTheCriteria: "All selected products must meet the criteria",
  thisValueMustBeAnInteger: "*This value must be an integer",
  shipByDate: "Ship by Date",
  bookedVolume: "Booked Volume",
  receivedVolume: "Received Volume",
  bookedWeight: "Booked Weight",
  receivedWeight: "Received Weight",
  ssccQuantityBooked: "SSCC Quantity Booked",
  ssccQuantityReceived: "SSCC Quantity Received",
  theValuesWereTheSame: "The values were the same",
  lessThanBooked: "less than booked",
  moreThanBooked: "more than booked",
  volumeAndWeight: "Volume & Weight",
  insertTotalValue: "Insert total value",
  insertValuesOf: "Insert values of",
  defineTotalValueOfSSCCs: "Define total value of SSCC's",
  defineValuesOfOneSSCC: "Define values of one SSCC",
  SSCCCBM: "SSCC CBM",
  SSCCWeight: "SSCC Weight",
  valueMustBeWithin10OfSupplierValue: "* Oops! Value must be within -/+ 10% of Supplier value.",
  notReceived: "Not received",
  receiveSSCC: "Receive SSCC",
  changeIt: "Change it",
  theBookingWillBeSentBackToTheSupplier: "The booking will be sent back to the supplier",
  areYouSureYouWantToChangeThisBookingStatusTo:
    "Are you sure you want to change this booking status to",
  receiveAllSSCC: "Receive all SSCC",
  closeIt: "Close it",
  areYouSureYouWantToMarkThisSSCCAsReceived: "Are you sure you want to mark this SSCC as received",
  youAreAboutMarkAllSSCCAsReceived: "You are about mark all SSCC as received",
  areYouSure: "Are you sure",
  thisActionCannotbeUndone: "This action cannot be undone",
  yesReceiveAll: "Yes, receive all",
  yesReceiveSSCC: "Yes, receive SSCC",
  allCartonsHaveAlreadyBeenMarkedAsReceived: "All cartons have already been marked as received",
  bookingSummary: "Booking Summary",
  downloadBookingData: "Download booking data",
  downloadReport: "Download report",
  manageSSCC: "Manage SSCC",
  closeSSCCs: "Close SSCCs",
  areYouSureYouWantToClosethese: "Are you sure you want to close these",
  thisActionCannotBeUndoneAndIfYouWantToModifyTheseSSCCsYouMustDeleteItAndCreateNewOnes:
    "This action cannot be undone and if you want to modify these SSCCs, you must delete them and create new ones",
  allSSCCsMustBeReceived: "All SSCCs must be received",
  planned: "Planned",
  allCartonsShouldBeClosedToCarryOutTheBooking:
    "All cartons should be closed to carry out the booking",
  unavailableNotification: "Unavailable notification",
  shipeeziPredicts: "Shipeezi Predicts",
  carrierShipeeziPredicts: "Carrier Shipeezi Predicts",
  allSSCCMustHaveProductsInsideThemToBeClosed:
    "All SSCC must have products inside them to be closed",
  photosOf: "Photos of ",
  generalComments: "General Comments",
  valueMustBeEqualToTheSupplierValue: "Value must be equal to the supplier value",
  beCode: "BE Code",
  pleaseEnteraValidBecode: "Please enter a valid be code",
  sendTaskToSistrs: "Send task to SISTRS",
  beCodeSupplierExample: "AUDASHING3 VDR",
  beCodeCustomerExample: " AUTHECOTT4 HQ",
  totalSSCC: "Total SSCC",
  markBookingAs: "Mark booking as",
  selectATriggerFirst: "Select a trigger first",
  default: "Default",
  commercialInvoice: "Commercial invoice",
  beneficiaryName: "Beneficiary Name",
  beneficiaryAddress: "Beneficiary Address",
  vatNumber: "VAT Number",
  eori: "EORI -",
  fiscalAgentDetails: "Fiscal Agent Details",
  salesContractNumber: "Sales Contract Number",
  salesContractDate: "Sales Contract Date",
  expNumber: "EXP Number",
  bankName: "Bank Name",
  bankAddress: "Bank Address",
  swiftCode: "Swift Code",
  paymentTerms: "Payment Terms",
  termsOfDelivery: "Terms of Delivery",
  udNumber: "UD Number",
  ercNumber: "ERC Number",
  rexNumber: "REX Number",
  commercialInvoiceDetails: "Commercial Invoice Details",
  cfsReview: "CFS Review",
  receivedByCFS: "Received by CFS",
  lining: "Lining",
  construction: "Construction",
  category: "Category",
  fabric: "Fabric",
  styleCode: "Style Code",
  brand: "Brand",
  manufacturerDetails: "Manufacturer Details",
  composition: "Composition",
  downloadAllFiles: "Download all files",
  areYouSureYouWantToRemoveThe: "Are you sure you want to remove the",
  fromThisBooking: "from this booking",
  removePurchaseOrder: "Remove purchase order",
  allSSCCsInsideThePurchaseOrderWillAlsoBeRemoved:
    "All SSCCs inside the purchase order will also be removed",
  yesRemoveIt: "Yes, remove it",
  markAndNumbers: "Mark and Numbers",
  limited: "Limited",
  characters: "characters",
  saveEdit: "Save edit",
  cancelEdit: "Cancel edit",
  purchaseOrderNumber: "PurchaseOrder Number",
  cartonName: "Carton Name",
  quotesStatus: "Quotes Status",
  someInformationOfThisSkuAreMissing: "Some information of this SKU are missing",
  writeHere: "Write here",
  createNewRow: "Create new row",
  noRowsCreatedYet: "No rows created yet",
  noData: "No data",
  estimatedQuote: "Estimated quote",
  yourEstimateQuoteInformationIsLoading: "Your estimate quote information is loading...",
  youAreAboutToApproveThisEstimateAreYouSure:
    "You are about to approve this estimate. Are you sure?",
  reasonForDeclining: "Reason for declining",
  reasonForReview: "Reason for review",
  estimateQuoteHasBeenApproved: "Estimate quote has been approved",
  thankYouSoMuchForApprovingTheEstimateWithUs:
    "Thank you so much for approving the estimate with us",
  cantDeliverOrderWithBookedStatus: "Can't deliver orders with Booked status",
  selectedPrice: "Selected price: ",
  estimateQuoteHasBeenDeclined: "Estimate quote has been declined",
  thisEstimateQuoteHasBeenSentToReview: "This estimate quote has been sent to review",
  weAreVerySorryThatTheQuoteWasNotAsExpectedWeHopeYouCanTryAgainAndEverythingGoesWell:
    "We are verry sorry that the estimate was not as expected. We hope you can try again and everything goes well.",
  shipeeziWillAlwaysBeHereWithYou: "Shipeezi will always be here with you",
  weHaveAlreadyNotifiedTheResponsibleCompanyThatThereAreRevisionsToBeMadeAndIfEverythingGoesCorrectlyYouWillReceiveAReturnShortly:
    "We have already notified the responsible company that there are revisions to be made and if everything goes correctly, you will receive a return shortly.",
  saveAndSendToCustomer: "Save and send to customer",
  youHaveToChooseAPriceInTheQuoteTab: "You have to choose a price in the Quote tab",
  youHaveToChooseAPaymentMethodInTheQuoteTab:
    "You have to choose a payment method in the Quote tab",
  noItems: "No items",
  theFieldIsEmpty: "The field is empty",
  addNewMaterial: "Add new material",
  destinations: "Destinations",
  show: "Show",
  taskAdded: "Task Added",
  documentCreatedSuccessfully: "Document created successfully",
  documentsUploadedSuccessfully: "Documents uploaded successfully",
  noCommunicationOptionSelected: "No communication option selected",
  notificationSent: "Notification sent",
  searchForLocation: "Search for location",
  noNotificationsForNow: "No notifications for now",
  notificationsWillAppearHereWhenThereAreAnyUpdatesToTheTasksYouAreInvolvedIn:
    "Notifications will appear here when there are any updates to the tasks you are involved in.",
  markAndNumbersShouldHaveAtLeastOneFilledLine:
    "Mark and Numbers should have at least one filled line",
  theEstimatedQuoteWasSuccessfullyShared: "The estimated quote was successfully shared",
  noItemsInQuotedInventory: "No items in quoted inventory",
  of: "of",
  reportsTo: "Reports to",
  changeStatusesTo: "Change statuses to",
  onlyBookingsWithReceivedByCFSCanChangeToReceivedStatus:
    "Only bookings with “Received by CFS” can change to “Received” status",
  theLinkHasExpired: "The link has expired",
  theEstimatedQuoteLinkHasExpired: "The estimated quote link has expired.",
  youCanRequestANewOneByClickingOnTheButtonBellow:
    "You can request a new one by clicking on the button bellow.",
  requestNewLink: "Request new link",
  requestedNewLinkSuccessfully: "Requested new link successfully",
  whatDoYouWantToSendToCustomer: "What do you want to send to customer?",
  shareViaVideoSurveyInvite: "Share via Video Survey invite",
  sendANewInvitationToTheScheduledVideoSurvey:
    "Send a new invitation to the scheduled video survey",
  shareViaEstimatedQuoteLink: "Share via Estimated quote link",
  sendTheExternalLinkOfEstimatedQuote: "Send the external link of estimated quote",
  thisQuoteDoesNotHaveAValidVideoSurveyTask: "This quote does not have a valid video survey task",
  thisQuoteDoesNotHaveAnEstimate: "This quote does not have an estimate",
  createNewOffice: "Create new office",
  editOffice: "Edit Office",
  officeStatus: "Office status",
  selectAtLeastOnePort: "Select at least one port",
  city: "City",
  viewPort: "View Port",
  siteCode: "Site Code",
  locationName: "Location name",
  portStatus: "Port Status",
  site: "Site",
  cityCode: "City Code",
  bookings: "Bookings",
  theInvitationWasSuccessfullySent: "The invitation was successfully sent",
  youMustBeLoggedInToSeeTheInvitation: "You must be logged in to see the invitation!",
  youHaveReachedTheEndOfNotifications: "You have reached the end of notifications",
  youHaventAddedAnyPriceYet: "You haven't added any price yet.",
  automaticallyApprove: "Automatically Approve",
  addSignatureForEveryPage: "Add signature for every page",
  addSignatureForOwnerAndLeaderForEveryPageOfReportsInsteadOfTheLastOne:
    "Add signature for owner and leader for every page of reports, instead of the last one",
  whenTheUserApprovesHisQuoteThisWillAutomaticallyUpdateTheQuoteOnTheSystem:
    "When the user approves his quote, this will automatically update the quote on the system.",
  salesAndOPS: "Sales and OPS",
  sales: "Sales",
  ops: "OPS",
  onFieldStaff: "On-Field Staff",
  theCartonCanOnlyContainProductsOfTheSameTypeAndColor:
    "The carton can only contain products of the same type and color",
  yourCompanyLogoAndIconRepresentYourBrandIdentityAndValuesThisWillBeUsedInAllCommunicationsAndDocumentsSoItWouldBeGoodToUpload:
    "Your company logo and icon represent your brand identity and values. This will be used in all communications and documents so it would be good to upload.",
  downloadOurCsvTemplate: "Download our CSV template",
  csvActions: "CSV Actions",
  leavingOnboarding: "Leaving onboarding",
  youAreAboutToExitTheOnboardingProcessAreYouSureYouWantToDoThis:
    "You are about to exit the onboarding process. Are you sure you want to do this?",
  rememberThatYouWillOnlyBeAbleToUseTheSystemAfterCompletingThisProcess:
    "Remember that you will only be able to use the system after completing this process.",
  branchName: "Branch name",
  branchAddedSuccessfully: "Branch added successfully!",
  viewBranches: "View Branches",
  inShipeeziYouCanManageBranchesPhysicalLocationsOfYourBusinessAMinimumOf:
    "In shipeezi you can manage branches (physical locations of your business). A minimum of",
  oneBranch: "1 branch",
  mustBeRecorded: "must be recorded.",
  resubmitToMODS: "Re-submit to MODS",
  cantSubmitCancelledBookings: "Can't submit cancelled bookings",
  cantDownloadCancelledBookings: "Can't download cancelled bookings",
  bookingsSubmittedSuccessfully: "Booking(s) submitted successfully",
  areYouSureYouWantToReSubmitTheSelectedBookings:
    "Are you sure you want to re-submit the selected booking(s)?",
  theBookingFileWillBeSentWithAUpdateStatus: "The booking file will be sent with a Update status",
  submit: "Submit",
  addShipment: "Add shipment",
  noShipmentAssociatedYet: "No shipment associated yet",
  addShipmentToOrder: "Add shipment to order",
  removed: "Removed",
  thisProductWasRemovedFromTheOrder: "This product was removed from the order",
  networkVisible: "Network visible",
  partner: "Partner",
  uploadImage: "Upload image",
  thisImageWillBeUsedWhenGeneratingCommercialInvoiceAndPackingListDocumentsBeingUsedAsAnEsignature:
    "This image will be used when generating “Commercial Invoice” and “Packing List documents”, being used as an e-signature.",
  hereYouCanChooseWheterToSeeTheNetworkAndHaveTheOptionToSelectAndAgent:
    "Here you can choose whether to see the Network and have the option to select an agent as a partner on a shipment. If an agent is selected, we will not send any communications to the customer.",
  doYouHaveAgentShipeeziNetworkKey: "Do you have agent’s Shipeezi network key?",
  agentShipeeziNetworkToken: "Agent’s Shipeezi network token",
  thisShipmentHasAPartner: "This shipment has a partner",
  myAccount: "My account",
  orderCancelledSuccessfully: "Order cancelled successfully",
  prime: "Prime",
  managePlan: "Manage plan",
  lastInvoice: "Last invoice",
  seeInvoiceHistory: "See invoice history",
  invoiceAmount: "Invoice Amount",
  amountOwing: "Amount Owing",
  billingDate: "Billing Date",
  manage: "Manage",
  userType: "User type",
  deductibleQty: "Deductible Qty",
  extraQty: "Extra Qty",
  quantityUsed: "Quantity used",
  costPerExtraUnit: "Cost per extra unit",
  totalValue: "Total value",
  addons: "Add-ons",
  addOn: "Add-on",
  dueDate: "Due date",
  amount: "Amount",
  currentAccountAmountOwing: "Current Account Amount Owing",
  nextBillingDate: "Next billing date",
  billingCountry: "Billing country",
  needToCancelYourSubscription: "Need to cancel your subscription",
  cancelSubscription: "Cancel subscription",
  pleaseNotThatOurPricesAreGSTExclusiveGSTWillBeBilledToAustraliaCustomers:
    "Please note that our prices are GST exclusive. GST will be billed to Australia customers unless a valid GST registered Australian Business Number (ABN) is provided",
  weKnowCircumstancesCanStometimesChange: "We know circumstances can sometimes change",
  butBeforeYouGoHaveYouTriedOur: "But before you go, have you tried our",
  forTechnicalFAQ: "for technical FAQs",
  knowledgeBase: "Knowledge Base",
  invoiceHistory: "Invoice history",
  invoiceID: "Invoice ID",
  seeInvoice: "See invoice",
  noKeepSubscription: "No, keep subscription",
  areYouSureYouWantToCancelYourSubscription: "Are you sure you want to cancel your subscription",
  ifYouAreInDoubtWeOfferOtherPlansAsWell:
    "If you are in doubt, we offer other plans as well, explore plans to see our features.",
  byChoosingToCancelARequestWillBeSentToTeamAndThe:
    "By choosing to cancel, a request will be sent to the team and the off-boarding process will start.",
  weAreSorryToSeeYouGo: "We’re sorry to see you go!",
  aCancellationRequestHasBeenSentToTheTeamAndWeWillContactYouShortlyToContinueTheOffBoardProcedure:
    "A cancellation request has been sent to the team and we will contact you shortly to continue the offboard procedure.",
  youCanLogoutNow: "You can logout now",
  paid: "Paid",
  uncollectible: "Uncollectible",
  waitingForPayment: "Waiting for payment",
  planSummary: "Plan summary",
  wantToChangeYourPlan: "Want to change your plan",
  contactSales: "contact sales",
  contactSupport: "Contact Support",
  ifYouWantToUpgradeOrDowngradeYourPlanPlease:
    "If you want to upgrade or downgrade your plan, please",
  youDontHaveAnyInvoicesYetWhenAnInvoiceIsGeneratedYoullSeeItHere:
    "You don't have any invoices yet. When an invoice is generated, you'll see it here.",
  thisShipmentHasAnAgent: "This shipment has an agent",
  containerSizeType: "Container size & type",
  addOrderToShipment: "Add order to shipment",
  associateShipmentToOrder: "Associate shipment to order",
  uploadYourFile: "Upload your file",
  maxImageSize: "Max image size",
  changePicture: "Change picture",
  ExporterInformationIsDifferentFromTheVendor: "Exporter information is different from the vendor",
  exporterName: "Exporter name",
  exporterContactDetails: "Exporter contact details",
  canBeJust: "can be just ",
  or: "or",
  companies: "Companies",
  ThisProcessIsRecommendedForCompaniesThatHave10OrMoreUsersButOnlyAdminAndGeneralRolesAreAvailableInThisStep:
    "This process is recommended for companies that have 10 or more users, but only admin and general roles are available in this step.",
  introduction: "Introduction",
  welcomeToShipeezi: "Welcome to Shipeezi!",
  unleashThePowerOfYourNewSoftware: "Unleash the power of your new software - Just steps away!",
  wereConfidentThatYoullFindOurPlatformToBeAnInvaluableTool:
    "We're confident that you'll find our platform to be an invaluable tool to end fragmentation and provide end-to-end visibility across your operations. Let’s get started.",
  firstlyLetsAddYourCompanyDetailsToYourAccountIncludingBusinessAddress:
    "Firstly, let’s add your company details to your account including business address, phone number, main contact and email address information.",
  nextWellSetUpYourCompanyUsersAndDefineTheirPermissionsAndAccessLevels:
    "Next, we’ll set up your company users and define their permissions and access levels.",
  finallyWellAskYouToUploadPreliminaryInformationToAssistOurTeamWithConnectingYourDataStreams:
    "Finally, we’ll ask you to upload preliminary information to assist our team with connecting your data streams.",
  deleteComment: "Delete comment",
  areYouSureYouWantToDeleteThisComment: "Are you sure you want to delete this comment?",
  itLooksLikeTheresNoCommentsYet: "It looks like there's no comments yet",
  feelFreeToAddAnyCommentsYouFeelNecessary: "Feel free to add any comments you feel necessary",
  typeHereYourNote: "Type here your note...",
  notifyPartyStatus: "Notify Party status",
  editNotifyParty: "Edit Notify Party",
  viewNotifyParty: "View Notify Party",
  createNotifyParty: "Create Notify Party",
  searchForAgent: "Search for agent",
  bodyOfEmail: "Body of email",
  bodyOfSMS: "Body of SMS",
  cartons: "Cartons",
  custom: "Custom",
  customTime: "Custom time",
  shipeeziBilling: "Shipeezi Billing",
  theExtraQuantityIsTheDifferenceBetweenTheQuantityUsedAndDeductibleQty:
    'The extra quantity is the difference between the "Quantity used" and "Deductible qty”',
  templateDetails: "Template details",
  youCannotCreateATemplateWithABrokenTag: "You cannot create a template with a broken tag",
  receiveUsingCSV: "Receive using CSV",
  couldNotFoundSSCC: "Could not found SSCC",
  searchForAContact: "Search for a contact",
  setTemplateAsDefault: "Set template as default",
  ssccNotFound: "SSCC not found",
  ssccFound: "SSCC found",
  setAsDefault: "Set as default",
  yesChangeIt: "Yes, change it",
  changeDefault: "Change default",
  doYouWantToMakeTheSelectedTemplateTheDefault:
    "Do you want to make the selected template the default?",
  theCurrentDefaultForThisTypeWillBeReplaced: "The current default for this type will be replaced.",
  youCanChangeItBackLaterIfYouWant: "You can change it back later if you want.",
  cartonStatus: "Carton status",
  weightAndCBMOfThisBookingMustBeConfirmedBeforeThisCanBeDone:
    "Weight and CBM of this booking must be confirmed before this can be done, you can adjust the values at CBM & Weight tab",
  allSSCCMustBeReceived: "All SSCC must be received",
  confirmAndReceive: "Confirm and receive",
  allSSCCsFromCsvWereMarkedAsReceived: "All SSCCs from csv were marked as received",
  boxesCouldntBeMarkedAsReceivedPleaseCheckAllErrorsOnWarehouseScanDataDocumentAndTryAgain:
    "boxes couldn't be marked as received. Please, check all errors on Warehouse Scan Data document and try again",
  NoneSSCCsCouldBeMarkedAsReceivedPleaseCheckAllErrorsOnWarehouseScanDataDocumentAndTryAgain:
    "None SSCCs could be marked as received. Please, check all errors on Warehouse Scan Data document and try again",
  attention: "Attention",
  containerNumberIsRequired: "Container number is required",
  youShouldAddAtLeastOneOrderToTheShipment: "You should add at least one order to the shipment",
  thisFieldMustBeGreaterThanOrEqualTo0: "*This field must be greater than or equal to 0",
  dcCode: "DC code",
  thisIsADeliveryLocation: "This is a delivery location",
  stayLoggedIn: "Stay logged in",
  aSubscribedShipmentWasUnselectedAndCannotBeRemoved:
    "A subscribed shipment was unselected and cannot be removed!",
  saveAsDraft: "Save as draft",
  shipmentSavedAsDraft: "Shipment saved as draft",
  shipmentCreationFailedAtIndex:
    "Could not create shipment {{current}} of {{total}}. Earlier shipments may have been saved. Please review the order or add remaining shipments manually.",
  tracking: "Tracking",
  thereWasAProblemTryingToImportTheFilePleaseRefreshThePage:
    "There was a problem trying to import the file. Please refresh the page and try again.",
  theFileWasSentToImport: "The file was sent to import",
  vesselPositionUpdateDailyAt5pmUTC: "Vessel positions update daily at 5pm UTC",
  locationIndicatedAboveIsMoreAccurateIfItDiffersFromMapDisplay:
    "Location indicated above is more accurate if it differs from map display",
  unableToExportCSVFile: "Unable to export CSV file",
  analytics: "Analytics",
  uploadDateAndTime: "Upload date and time",
  exporter: "Exporter",
  shipmentNumber: "Shipment Number",
  postCode: "Post Code",
  itemType: "Item type",
  consignmentNumber: "Consignment number",
  pieces: "Pieces",
  stocksToDespatch: "Stocks to despatch",
  palletsToDespatch: "Pallets to despatch",
  deliveryWindowOpen: "Delivery Window Open",
  deliveryWindowClose: "Delivery Window Close",
  shippingItems: "Shipping Items",
  truck: "Truck",
  addExistingAddress: "Add Existing Address",
  newAddress: "New Address",
  noDeliveryAddressAddedYet: "No delivery address added yet",
  noPickupAddressAddedYet: "No pickup address added yet",
  addresses: "Addresses",
  createDespatch: "Create Despatch",
  editDespatch: "Edit Despatch",
  staged: "Staged",
  inTransit: "In transit",
  newPickUpAddress: "New Pick up Address",
  newDeliveryAddress: "New Delivery Address",
  editPickUpAddress: "Edit Pick up Address",
  editDeliveryAddress: "Edit Delivery Address",
  labelAddress: "Label address",
  pickUpAddress: "Pick up Address",
  addAddresses: "Add addresses",
  palletsPerTrucks: "Pallets per Truck",
  newShippingItem: "New Shipping Item",
  editShippingItem: "Edit Shipping Item",
  itLooksLikeThereSNoDataYet: "It looks like there's no data yet",
  youWillBeAbleToSeeAllTheInformationAboutThe:
    "You will be able to see all the information about the",
  associatedWithTheDespatchWhenYouAddThem: "associated with the despatch when you add them",
  addShippingItems: "Add Shipping Items",
  editTruck: "Edit Truck",
  newTruck: "New Truck",
  quantityOnHand: "Quantity On Hand",
  allDespatched: "All Despatched",
  available: "Available",
  youCanStartByCreatingANew: "You can start by creating a new",
  passwordsDoNotMatch: "Passwords do not match.",
  theresNoEstimatesAvailableToView: "There’s no estimates available to view",
  userHasAccessTo: "User has access to...",
  poConfirmedVsPOReceived: "PO Confirmed vs PO Received",
  poPastShipByDate: "PO Past Ship by Date",
  pastShipByDate: "Past Ship by Date",
  pendingPurchaseOrders: "Pending Purchase Orders",
  printReport: "Print report",
  addTruck: "Add Truck",
  maxValueAccepted: "Max value accepted",
  averageMonthlyCost: "Average Monthly Cost",
  averageOverTheLast12MonthsExcludingTaxes: "Average over the last 12 months excluding taxes",
  templates: "Templates",
  youShouldAddAtLeastOnePickUpAddress: "You should add at least one pickup address",
  youShouldAddAtLeastOneDeliveryAddress: "You should add at least one delivery address",
  youShouldAddAtLeastOneProduct: "You should add at least one product",
  ayrtonSenna: "Ayrton Senna",
  positionInManufacturingCompany: "Position in manufacturing company",
  nameOfManufacturingCompany: "Name of manufacturing company",
  egSupplier: "E.g supplier",
  egShipeezi: "E.g shipeezi",
  searchByCountry: "Search by country",
  vendorId: "Vendor ID",
  countryOfOrigin: "Country of Origin",
  accessIntructions: "Access Instructions",
  generateInvoice: "Generate invoice",
  schedule: "Schedule",
  associatedWithTheInvoicesWhenYouAddThem: "associated with the invoices when you add them",
  loadingInvoices: "Loading Invoices",
  consol: "Consol",
  etaMonth: "ETA Month",
  actualDelivery: "Actual Delivery",
  commInvNo: "Comm Inv No",
  commInvDate: "Comm Inv Date",
  partNumber: "Part Number",
  receivedLinePrice: "Received Line sPrice",
  invoiceExchangeRate: "Invoice Exchange Rate",
  audValue: "AUD Value",
  duty: "duty",
  lineDutyAmount: "Line Duty Amount",
  kewill: "Kewill",
  cblNo: "CBL No.",
  mawbNo: "MAWB No.",
  originCharges: "Origin Charges",
  internationalFreight: "International Freight",
  destinationCharges: "Destination Charges",
  totalFreightAUD: "Total Freight AUD",
  unitFob: "Unit FOB",
  freightCPU: "Freight CPU",
  freightasFOB: "Freight as FOB",
  deleteInvoice: "Delete Invoice",
  areYouSureYouWantToDeleteTheInvoice: "Are you sure you want to delete the invoice",
  invoiceQuantity: "Invoice Quantity",
  houseBill: "House Bill",
  masterBill: "Master Bill",
  hblCountMode: "HBL Count Mode",
  chargeCode: "Charge Code",
  overseasAmount: "Overseas Amount",
  exchangeRateCurrency: "Exchange Rate Currency",
  exchangeRate: "Exchange Rate",
  invoicedLocalAmount: "Invoiced Local Amount",
  gstAmount: "GST Amount",
  invoiceDate: "Invoice Date",
  invoiceDueDate: "Invoice Due Date",
  autoRate: "Auto Rate",
  cottonOnAdultsApportionment: "Cotton On Adults Apportionment",
  cottonOnAdultsLocalAmount: "Cotton On Adults Local Amount",
  ceresLifeApportionment: "Ceres Life Apportionment",
  ceresLifeLocalAmount: "Ceres Life Local Amount",
  bodyApportionment: "Body Apportionment",
  bodyLocalAmount: "Body Local Amount",
  factorieApportionment: "Factorie Apportionment",
  factorieLocalAmount: "Factorie Local Amount",
  kidsApportionment: "Kids Apportionment",
  kidsLocalAmount: "Kids Local Amount",
  rubiApportionment: "Rubi Apportionment",
  rubiLocalAmount: "Rubi Local Amount",
  foundationApportionment: "Foundation Apportionment",
  foundationLocalAmount: "Foundation Local Amount",
  typoApportionment: "Typo Apportionment",
  typoLocalAmount: "Typo Local Amount",
  gamedayApportionment: "Gameday Apportionment",
  gamedayLocalAmount: "Gameday Local Amount",
  supreApportionment: "Supre Apportionment",
  supreLocalAmount: "Supre Local Amount",
  fixturesApportionment: "Fixtures Apportionment",
  fixturesLocalAmount: "Fixtures Local Amount",
  consumablesApportionment: "Consumables Apportionment",
  consumablesLocalAmount: "Consumables Local Amount",
  otherApportionment: "Other Apportionment",
  otherLocalAmount: "Other Local Amount",
  dateType: "Date type",
  searchBy: "Search by",
  sendReportByEmail: "Send report by email",
  originCountry: "Origin Country",
  part: "Part",
  id: "Id",
  createSendRecurrence: "Create send recurrence",
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
  frequency: "Frequency",
  isNotAValidEmail: "is not a valid email",
  emailScheduled: "Email scheduled",
  emailSent: "Email sent",
  storageStatus: "Storage Status",
  newStorageBox: "New Storage Box",
  editStorageBox: "Edit Storage Box",
  newStorageBoxType: "New Storage Box Type",
  editStorageBoxType: "Edit Storage Box Type",
  typeNumber: "Type number",
  depth: "Depth",
  deleteStorageBox: "Delete Storage Box",
  deleteStorageBoxType: "Delete Storage Box Type",
  areYouSureYouWantToDeleteThisStorageBox: "Are you sure you want to delete this storage box",
  areYouSureYouWantToDeleteThisStorageBoxType:
    "Are you sure you want to delete this storage box type",
  createSmsTemplate: "Create SMS template",
  notBeingUsed: "Not being used",
  inUse: "In use",
  template: "Template",
  hideCc: "Hide CC",
  hideBcc: "Hide BCC",
  showCc: "Show CC",
  showBcc: "Show BCC",
  sendEstimateToCustomer: "Send estimate to customer",
  writeYourOwnOrChooseFromPreSetTemplates: "White your own or choose from pre-set templates",
  storageBoxesAndUnits: "Storage Boxes & Units",
  writeYourOwnOrChooseFromTemplates: "Write your own or choose from templates",
  movement: "Movement",
  movements: "Movements",
  objectToMove: "Object to move",
  storageBox: "Storage box",
  looseItem: "Loose item",
  typeOfObject: "Type of Object",
  seeObjectActivity: "See object activity",
  moveTo: "Move to",
  object: "Object",
  moveToLocation: "Move to location",
  move: "Move",
  someObjectDetailsWillBeDisplayedWhenYouSelectIt:
    "Some object details will be displayed here when you select it",
  noObjectSelected: "No object selected",
  insideAStorageBox: "Inside a storage box",
  seeFullDetails: "See full details",
  section: "Section",
  storageBoxDetails: "Storage box details",
  dateIntoStorage: "Date into storage",
  lastMoved: "Last moved",
  isLocatedInTheCellYouAreGoingToMoveDoYouWantToContinue:
    "is located in the cell you are going to move, do you want to continue?",
  isPlacedInThisLocationRightNowWouldYouLikeToMoveItToAnUnknowLocationForNow:
    "is placed in this location right now, would you like to move it to an 'unknown' location for now?",
  the: "The",
  locationIsFull: "Location is full",
  accessTo: "Access to",
  rows: "Rows",
  columns: "Columns",
  levels: "Levels",
  createMap: "Create Map",
  editMap: "Edit Map",
  input: "Input",
  columnsQuantity: "Columns quantity",
  characterUsed: "Character used",
  initial: "Initial",
  suffix: "Suffix",
  rowsQuantity: "Rows quantity",
  levelsQuantity: "Levels quantity",
  buildMap: "Build Map",
  numbers: "Numbers",
  alphabetical: "Alphabetical",
  ascendant: "Ascendant",
  descendant: "Descendant",
  deleteMap: "Delete Map",
  viewMap: "View Map",
  areYouSureYouWantToDeleteThisMap: "Are you sure you want to delete this map",
  thisFieldMustBeGreaterThanZero: "This field must be greater than zero",
  mapGenerated: "Map generated",
  topView: "Top view",
  applySearch: "Apply search",
  cartonCondition: "Carton Condition",
  eventDate: "Event Date",
  deliveryStore: "Delivery Store",
  storeNumber: "Store Number",
  estimateArriveWH: "Estimate Arrive WH",
  arrivalFinalPort: "Arrival Final Port",
  meChecklist: "M&E Checklist",
  haveYouDoneTheMEChecklistOnThisItem: "Have you done the M&E on this item?",
  meChecklistDone: "M&E checklist done",
  unsetAsDefault: "Unset as default",
  storageAccounts: "Storage accounts",
  period: "Period",
  nextBilling: "Next billing",
  createNew: "Create new",
  settlement: "Settlement",
  createNewStorageAccount: "Create new storage account",
  storageAccountOrder: "Storage Account Order",
  pickedUp: "Picked up",
  assignLocation: "Assign location",
  assignStorageBox: "Assign storage box",
  storageSpace: "Storage space",
  unit: "Unit",
  assignStorageBoxLocation: "Assign storage box location",
  typeStorage: "Type storage",
  storageFrom: "Storage from",
  gracePeriodEnd: "Grace period end",
  storageEnd: "Storage End",
  selectAPaymentMethod: "Select a payment method",
  plan: "Plan",
  totalGSTIncluded: "Total (GST Included)",
  extraServices: "Extra services",
  grandTotal: "Grand total",
  etaUnpackDate: "Eta Unpack Date",
  finalPortArrival: "Final Port Arrival",
  all: "All",
  estimateArrivalWH: "Estimate Arrival WH",
  selectAtLeastOneProject: "Select at least one project",
  expectedQty: "Expected Qty",
  quantityReceived: "Quantity Received",
  dateReceived: "Date Received",
  selectBranch: "Select branch",
  selectGroup: "Select group",
  sections: "Sections",
  createNewSection: "Create new section",
  contains: "contains",
  storageBoxType: "Storage Box Type",
  selectAtLeastOneWarehouseOrSku: "Select at least one Warehouse or SKU",
  locationPreviewStatus: "Location preview status",
  selectNewLocation: "Select new location",
  noMapSelected: "No map selected",
  aLittleMapPreviewWillAppearHereWhenYouSelectTheSectionInTheObjectThatShouldBeMoved:
    "A little map preview will appear here when you select the section in the object that should be moved",
  unload: "Unload",
  uploadDate: "Upload date",
  viewInWarehouseMap: "View in warehouse map",
  changeLocation: "Change location",
  funcionalityUnderDevelopment: "Functionality under development",
  selectWhichOrderToUnload: "Select which order to unload",
  pleasePayAttention: "Please, pay attention!",
  onceTheOrderIsUnloadedItCannotChangeStatusAgain:
    "Once the order is unloaded, it cannot change status again.",
  full: "Full",
  unusable: "Unusable",
  couldNotFound: "Could not found",
  selectAtLeastOneContainer: "Select at least one container",
  receivedExpected: "Received - Expected",
  receivedUnexpected: "Received - Unexpected",
  notReceivedExpected: "Not Received - Expected",
  clear: "Clear",
  clearFields: "Clear fields",
  palletDimensions: "Palette dimensions",
  cartonDimensions: "Carton dimensions",
  minimumValue: "Minimum value",
  newMap: "New map",
  theFollowingStorageBoxesAreLoadedAndCanNotChangeStatus:
    "The following storage boxes are loaded and can not change status:",
  theFollowingMapsHaveLoadedLocationsAndCanNotChangeStatus:
    "The following maps have loaded locations and can not change status:",
  theFollowingWarehousesHaveSectionsWithMapsInUseAndCanNotChangeStatus:
    "The following warehouses have sections with maps in use and can not change status:",
  selectAStartDate: "Select a start date",
  enterAtLeast: "Enter at least",
  ordersHaveDifferent: "Orders have different",
  jobNumber: "Job Number",
  commercialInvoiceNumber: "Commercial Invoice Number",
  commercialInvoiceDate: "Commercial Invoice Date",
  lineDutyPercent: "Line Duty Percent",
  nonAUEntryFees: "Non AU Entry Fees",
  totalUnitCosts: "Total Unit Costs",
  freightAUD: "Freight AUD",
  freightFob: "Freight FOB",
  new: "New",
  shareable: "Shareable",
  routePlanner: "Route planner",
  mapSettings: "Map settings",
  clearLocation: "Clear Location",
  routing: "Routing",
  sharedWith: "Shared with",
  belongsTo: "Belongs to",
  hasNoWarehouses: "has no warehouses",
  belongsToWarehouse: "Belongs to warehouse",
  sharedWarehouses: "Shared Warehouses",
  isNotShareable: "Is not shareable",
  cartonsPerPallet: "Cartons per Pallet",
  allIncluded: "all included",
  exampleOfTiHi: "Example of Ti-Hi",
  manufacture: "Manufacture",
  deleteProduct: "Delete product",
  unitsInTransit: "Units in transit",
  originShipments: "Origin shipments",
  cartonsToDespatch: "Cartons to despatch",
  companyCurrentStock: "Company current stock",
  mainSupplier: "Main supplier",
  stock: "Stock",
  cartonWeight: "Carton weight",
  createProduct: "Create product",
  byWho: "By who",
  objectNumber: "Object number",
  newMovement: "New movement",
  none: "None",
  ordersQuantity: "Orders quantity",
  itemsInsideThisStorageBox: "Items inside this storage box",
  bookingNumber: "Booking number",
  noLocation: "No location",
  typeInLocation: "Type in location",
  startWarehouse: "Start Warehouse",
  endWarehouse: "End Warehouse",
  rta: "RTA",
  addToRoutePlanner: "Add to Route Planner",
  removingFromRoutePlanner: "Removing from Route Planner",
  removeFromRoutePlanner: "Remove from Route Planner",
  removedFromRoutePlanner: "Removed from Route Planner",
  addingToRoutePlanner: "Adding to Route Planner",
  addedToRoutePlanner: "Added to Route Planner",
  couldNotAddToRoutePlanner: "Could not add to Route Planner",
  couldNotRemoveFromRoutePlanner: "Could not remove from Route Planner",
  updatingInRoutePlanner: "Updating in Route Planner",
  updatedInRoutePlanner: "Updated in Route Planner",
  couldNotUpdateInRoutePlanner: "Updated in Route Planner",
  addToRoutePlannerQuestionMark: "Add to Route Planner ?",
  addAShift: "Add a shift",
  shiftTime: "Shift time",
  shiftTimes: "Shift times",
  addASecondShiftDuration: "Add a second shift duration",
  scacCode: "SCAC Code",
  scacCodePlaceholder: "Search or enter SCAC code",
  grade: "Grade",
  gradePlaceholder: "e.g. A, B, C",
  scacInformation: "SCAC Information",
  scacDescription: "SCAC Description",
  claimsPhone: "Claims Phone",
  claimsEmail: "Claims Email",
  carrierName: "Carrier Name",
  carrierNameAbbreviation: "Carrier Name (Abbr.)",
  editCarrier: "Edit Carrier",
  createNewCarrier: "Create New Carrier",
  trackableBy: "Trackable by",
  areYouSureYouWantToDeleteThisCarrier: "Are you sure you want to delete this Carrier",
  deleteCarrier: "Delete Carrier",
  transshipment: "Transshipment",
  dueDateBy: "Due Date by",
  requestedBy: "Requested by",
  assignedTo: "Assigned to",
  newTransshipment: "New transshipment",
  showTodaysTransshipments: "Show today’s transshipments",
  generalDetails: "General details",
  whatToDo: "What to do",
  team: "Team",
  saveAndPublish: "Save and Publish",
  markItemsYouWantToMove: "Mark items you want to move",
  perItem: "Per item",
  bingoSheet: "Bingo sheet",
  transshiping: "Transshiping",
  thisFieldShouldHaveAlphaNumericCharactersOnly:
    "This field should have alpha-numeric characters only",
  bookingReference: "Booking Reference",
  showAllStorageBoxes: "Show all Storage Boxes",
  addStorageBox: "Add Storage Box",
  createASingleUseBox: "Create a single use box",
  storageBoxNumber: "Storage box number",
  volumeAvailable: "Volume available",
  theStorageBoxHasBeenAddedSuccessfully: "The Storage Box has been added successfully",
  itLooksLikeTheresNoDataYet: "It looks like there's no data yet",
  startSearchingForAStorageBoxOrCreateASingleUseBox:
    "Start searching for a Storage Box or create a single use box.",
  system: "System",
  editTransshipment: "Edit transshipment",
  any: "Any",
  pickUpTime: "Pick up Time",
  deliveryTime: "Delivery Time",
  addDespatchesToRoute: "Add despatches to route",
  removeDespatchesToRoute: "Remove despatches to route",
  added: "Added",
  searchForStorageBox: "Search for storage box",
  noItemsToAddToTransshipment: "No items to add to transshipment",
  showTodayTransshipments: "Show today transshipments",
  showing: "Showing",
  theOrderHasAlreadyBeenAdded: "The Order has already been added",
  publish: "Publish",
  editProject: "Edit Project",
  newProject: "New Project",
  fileName: "File name",
  dateUploaded: "Date uploaded",
  ofRows: "of rows",
  addFile: "Add File",
  whenYouAddThem: "when you add them",
  youWillBeAbleToSeeAllThe: "You will be able to see all the",
  detailsHereWhenYouUploadAtLeastOne: "details here when you upload at least one",
  createProject: "Create project",
  uploadAFile: "Upload a file",
  willBeRemoveAllOfTheItemsWillUnloadFromIt:
    "It will be remove. All of the items will unload from it.",
  areYouSureYouWantToContinue: "Are you sure you want to continue?",
  removeStorageBox: "Remove Storage box",
  cellInUse: "Cell in use",
  allWarehouses: "All Warehouses",
  yourStorageBoxesAreBeingUploaded: "Your storage boxes are being uploaded",
  automate: "Automate",
  sentToEmail: "Sent to e-mail",
  editAutomation: "Edit Automation",
  deletedSuccessfully: "Deleted successfully",
  deleteAutomation: "Delete automation",
  doYouReallyWantToDeleteTheAutomation: "Do you really want to delete the automation",
  createOrder: "Create Order",
  addNewproducts: "Add new products",
  manual: "Manual",
  paragraph: "Paragraph",
  options: "Options",
  addOption: "Add option",
  youNeedToLogOutAndLogBackInForSomeChangesToBeApplied:
    "You need to log out and log back in for some changes to be applied.",
  someChangesWereNotApplied: "Some changes were not applied",
  enableAsAStorageBox: "Enable as a storage box",
  enablingThisAllowsTheUserToChooseTheVehicleForStorageMovementOrTransshipmentAndIndicateWhenItemsArePlacedInsideLikeAStorageBox:
    "Enabling this allows the user to choose the vehicle for storage movement or transshipment and indicate when items are placed inside, like a storage box.",
  projectUpdatedWithSuccess: "Project updated with success",
  deleteBrandName: "Delete brand name",
  deleteBrandNames: "Delete brand names",
  areYouSureYouWantToDeleteTheBrandName: "Are you sure you want to delete the brand name",
  areYouSureYouWantToDeleteThese: "Are you sure you want to delete those",
  brandName: "Brand name",
  brandNames: "Brand names",
  brandCode: "Brand code",
  addNewBrandName: "Add new brand name",
  youCanStartByAddingANewBrandName: "You can start by adding a new brand name",
  loadingBrands: "Loading Brands",
  newBrand: "New brand",
  logo: "Logo",
  editBrand: "Edit brand",
  viewBrand: "View brand",
  deleteBrands: "Delete Brands",
  previewOnSSCCLabel: "Preview on SSCC label",
  noPdfFileSpecified: "No PDF file specified",
  loadType: "Load Type",
  groupageVanline: "Groupage/Vanline",
  otherEnterDims: "Other (enter dims)",
  parties: "Parties",
  rail: "Rail",
  itemIsAHardwareBox: "Item is a hardware box",
  itemIsTv: "Item is a TV",
  screenSize: "Screen size",
  screenType: "Screen type",
  remoteControl: "Remote control",
  powerCord: "Power cord",
  tvBaseStand: "TV base/stand",
  baseStandHardware: "Base/stand hardware",
  tv: "TV",
  vehicle: "Vehicle",
  serialNumberVin: "Serial number / VIN",
  odometerMiles: "Odometer miles",
  km: "KM",
  accessoriesIncluded: "Accessories included",
  gasTankEmpty: "Gas tank empty",
  fuelSystemPurged: "Fuel system purged",
  batteryDisconnected: "Battery disconnected",
  youCanSeeTheReportsAfterSelectingTheFollowingFilters:
    "You can see the reports after selecting the following filters",
  selectAProject: "Select a project",
  selectAWarehouse: "Select a warehouse",
  selectASKU: "Select a SKU",
  selectAContainer: "Select a Container",
  brands: "Brands",
  repeat: "Repeat",
  weAreCheckingIfALinkIsAvailable: "We are checking if a link is available",
  pleaseSelectAOrderType: "Please, select a Order type",
  etaDestination: "ETA destination",
  etaDespatch: "ETA Despatch",
  trackable: "Trackable",
  downloadShipmentInformations: "Download Shipment Informations",
  boxContents: "Box contents",
  packedInto: "Packed into",
  indicateLiftvanOrSectionTheItemCanBeFound: "Indicate liftvan or section the item can be found",
  values: "Values",
  automaticallyCreateOneHardwareBoxInEveryInventory:
    "Automatically create one hardware box in every inventory",
  needsAtLeastOneActiveHardwareBoxItemToBeEnabled:
    "Needs at least one active hardware box item to be enabled.",
  carrierScac: "Carrier scac",
  fieldsAreRequired: "Container number, Booking Reference or Bill of Lading are required.",
  theFleetNameIsUsedAsTheSystemDefault: "The Fleet name is used as the system default",
  isBox: "Is box",
  isBoxInterrogation: "Is box?",
  isThisTypeOfPackagingABox: "Is this type of packaging a box?",
  hardwareBox: "Hardware box",
  itemIsHighRiskOrHighValue: "Item is High Risk/High Value",
  thisCarrierAllowsShipmentTrackingBy: "This carrier allows shipment tracking by",
  meChecklistIsmandatoryForThisItemPleaseAnswerIt:
    "M&E checklist is mandatory for this item, please answer it",
  enableEstimateEditing: "Enable estimate editing",
  enable: "Enable",
  areYouSureYouWantToEnableEditingEstimateForThisQuote:
    "Are you sure you want to enable editing the estimate for this quote?",
  changesMadeToThisQuoteMayAlsoAffectOrder: "Changes to this Quote may also affect Order.",
  measurementPreview: "Measurement preview",
  me: "M&E",
  highRiskHighValue: "High Risk / High Value",
  proGear: "Pro-Gear",
  itemIsAME: "Item is a M&E",
  youCanSeeTheReportsAfterSelectingAtLeast: "You can see the reports after selecting at least",
  warehouseCodeAlreadyExistsPleaseAssignANewCode:
    "Warehouse Code already exists. Please assign a new code.",
  enterTheBoxNumberToSearch: "Enter the box number to search.",
  enterTheOrderToSearch: "Enter the order to search.",
  noResults: "No results",
  etdOrigin: "ETD origin",
  etaPlanned: "ETA planned",
  addNewShipment: "Add new shipment",
  basedOnABooking: "Based on a booking",
  box: "Box",
  case: "Case",
  pallet: "Pallet",
  ftl: "FTL",
  ltl: "LTL",
  fcl: "FCL",
  lcl: "LCL",
  groupage: "Groupage",
  roro: "RORO",
  bulk: "Bulk",
  commodityHSCode: "Commodity HS Code",
  enterTheLocationToSearch: "Enter the location to search.",
  productPhoto: "Product Photo",
  masterbillOfLanding: "Master Bill of Lading",
  housebillOfLanding: "House Bill of Lading",
  shipmentDetails: "Shipment details",
  placeOfOrigin: "Place of origin",
  shipperCode: "Shipper code",
  addAnotherContainer: "Add another Container",
  volumetricWeight: "Volumetric weight",
  grossVolume: "Gross volume",
  tareWeight: "Tare weight",
  netWeight: "Net weight",
  verifiedGrossWeight: "Verified Gross Weight",
  selectABooking: "Select a booking",
  noSubscriberAdded: "No subscriber added",
  selectABookingBellowToStartAShipmentBasedOnIt:
    "Select a booking below to start a shipment based on it",
  selectJustOneBookingPerShipment: "Select just one booking per shipment",
  startByAddingASubscribertoShipment: "Start by adding an Subscriber to shipment",
  youMustSelectAShipmentLoadingPortFirst: "You must select a shipment loading port first",
  youMustSelectAShipmentDestinationFirst: "You must select a shipment destination  first",
  youMustSelectAShipmentOriginFirst: "You must select a shipment origin  first",
  youMustSelectAShipmentDischargePortFirst: "You must select a shipment discharge port first",
  youMustSelectAShipmentModeFirst: "You must select a shipment mode first",
  youMustSelectAShipmentIncotermFirst: "You must select a shipment incoterm first",
  variance: "Variance",
  youCanStartByAddingAnOrder: "You can start by adding an order",
  editSubscriber: "Edit subscriber",
  fromThisShipment: "from this shipment",
  regularCargo: "Regular cargo",
  hazardousCargo: "Hazardous cargo",
  foodGradeCargo: "Food grade cargo",
  rareCargo: "Rare cargo",
  reeferCargoRefrigerated: "Reefer cargo (Refrigerated)",
  addInAContainer: "Add in a container",
  chooseAContainerToAddTheSsccInto: "Choose a container to add the SSCC into",
  choose: "Choose",
  distanceTravelled: "Distance Travelled",
  distanceToGo: "Distance to Go",
  route: "Route",
  shipeeziPredictsETA: "Shipeezi Predicts ETA",
  plannedETA: "Planned ETA",
  theCarrierProvidesDateTimesBelowAndMayNotMatchObservationsAndPredictionsInOtherSections:
    "The Carrier provides date-times below and may not match observations and predictions in other sections.",
  events: "Events",
  notEventsToShowAtTheMoment: "No events to show at the moment",
  dayDelay: "Day delay",
  daysDelay: "Days delay",
  invalidNumber: "Invalid number",
  trackingNotFound: "Tracking not found",
  shipmentCreated: "Shipment created",
  checkTheInformationYouHaveFilledInUpdateItAndSaveItWellValidateItAgainInAFewMinutes:
    "Check the information you have filled in, update it and save it. We'll validate it again in a few minutes.",
  weReStillValidatingInformationToSeeIfThisShipmentIsTrackableRefreshThisPageInAFewMinutes:
    "We’re still validating information to see if this shipment is trackable. Refresh this page in a few minutes.",
  thereIsNoTrackingAvailableForThisShipment: "There is no tracking available for this shipment.",
  yourShipmentWasSuccesfullyCreatedAndWereNowValidatingTheInformationToSeeIfItsTrackable:
    "Your shipment was succesfully created and we’re now validating the information to see if it’s trackable.",
  inAFewMinutesYouCanConsultTheTrackingInfoByClickingTheViewOrEditIconButtonInTheActionsColumnOnTheGrid:
    "In a few minutes you can consult the tracking info by clicking the View or Edit icon button in the actions column on the grid.",
  whatDoYouWantToSend: "What do you want to send?",
  sendTrackingViaSMSOrEmail: "Send tracking via SMS or Email",
  sendShipmentTrackingViaSMSOrEmailToTheCustomerOrSomeoneElse:
    "Send shipment tracking via SMS or email to the customer or someone else",
  writeAnEmailOrUseATemplate: "Write an email or use a template",
  writeASMSOrUseATemplate: "Write a SMS or use a template",
  writeAPushNotificationOrUseATemplate: "Write a push notification or use a template",
  sendJSONFile: "Send JSON file",
  sendOnlyTheJSONFileToCustomer: "Send only the JSON file to customer",
  trackingNotAvailable: "Tracking not available",
  doYouAlsoWantToCancelTheLinkedOrder: "Do you also want to cancel the linked order",
  areYouSureYouWantToDeleteThisProduct: "Are you sure you want to delete this product",
  createSingleUseBox: "Create a single use box",
  newSingleUseBox: "New single-use storage box",
  createAnotherSingleUseBox: "Create another single use box",
  searchByContactNameMobilePhoneOrEmailAddress:
    "Search by contact name, mobile phone or email address",
  searchOrAddAContact: "Search or add a contact",
  howMany: "How many?",
  autoNumberThem: "Auto number them",
  typePrefix: "Type prefix",
  singleUse: "Single-use",
  noWarehouses: "No warehouses",
  byWhom: "By whom",
  enterTheObjectToSearch: "Enter the object to search.",
  orderOrCustomer: "Order or Customer",
  salutation: "Salutation",
  allowance: "Allowance",
  secondReference: "2nd Reference",
  editLiftvans: "Edit Liftvans",
  addLiftvans: "Add Liftvans",
  areYouSureYouWantToCancelTheTransshipment: "Are you sure you want to cancel the transshipment",
  yesCancelTransshipment: "Yes, cancel transshipment",
  cancelTransshipment: "Cancel transshipment",
  sendTheShipmentTrackingViaSMSToTheCustomerOrAnotherPerson:
    "Send the shipment tracking via SMS to the customer or another person",
  sendTrackingViaSMS: "Send tracking via SMS",
  createdOn: "Created on",
  sendTheShipmentTrackingViaSMSOrEmailToTheCustomerOrSomeoneElse:
    "Send the shipment tracking via SMS or email to the customer or someone else",
  sendTrackingViaSMSorEmail: "Send tracking via SMS or Email",
  weightAndMeasurements: "Weight and measurements",
  preApprovals: "Pre-approvals",
  noPreApprovals: "No pre-approvals",
  agentName: "Agent name",
  approvalItem: "Approval Item",
  goShareId: "Go share ID",
  count: "Count",
  storageInTransitOriginSit: "Storage in Transit (Origin SIT)",
  sitInDate: "SIT in date",
  sitOutDate: "SIT out date",
  sitOutDateMustBeAfterSitInDate: "SIT out date must be after SIT in date.",
  sitNumber: "SIT number",
  baseCode: "Base code",
  baseDescription: "Base description",
  areaCode: "Area code",
  areaDescription: "Area description",
  zipCode: "Zip code",
  storageBoxAdded: "Storage box added",
  storageBoxRemoved: "Storage box removed",
  generateCsv: "Generate CSV",
  revokeInvite: "Revoke Invite",
  yesRevoke: "Yes, revoke",
  revokeInvitation: "Revoke invitation",
  doYouWantToRevokeTheInvitationSentTheUserWillNoLonge:
    "Do you want to revoke the invitation sent? The user will no longer be able to accept the invitation",
  youCanAlwaysInviteThemAgain: "You can always invite them again.",
  cancelInvite: "Cancel invite",
  thisInviteWasRevoked: "This invite was revoked",
  oopsItLooksLikeThisInvitationHasBeenRevoked:
    "Oops, it looks like this invitation has been revoked and is no longer available.",
  ifYouThinkThisIsAnErrorPleaseContactTheCompanyResponsibleToBetter:
    "If you think this is an error, please contact the company responsible to better understand what happened.",
  unlinkInventory: "Unlink Inventory",
  yesUnlink: "Yes, unlink",
  doYouWantToUnlinkTheInventory: "Do you want to unlink the inventory",
  inventoryLinked: "Inventory linked",
  inventoryUnlinked: "Inventory unlinked",
  inventoryLinkedSuccessfully: "Inventory linked successfully",
  inventoryUnlinkedSuccessfully: "Inventory unlinked successfully",
  relinkInventory: "Relink Inventory",
  yesRelink: "Yes, relink",
  doYouWantToRelink: "Do you want to relink",
  thisActionWillReplaceTheValuesYouveSetWithTheValuesFromYourActualInventory:
    "This action will replace the values you've set with the values from your actual inventory.",
  whenYouUnlinkTheInventoryYouCanEditTheTotalValuesThisMeansThatAnyFutureChangesYouMakeToTheInventoryWillNotBeReflectedInTheseMeasurements:
    "When you unlink the inventory, you can edit the total values. This means that any future changes you make to the inventory will not be reflected in these measurements.",
  inventoriesSummary: "Inventories summary",
  itemIsProGear: "Item is Pro-Gear",
  itemIsVehicle: "Item is a Vehicle",
  vehicleType: "Vehicle Type",
  motorcycle: "Motorcycle",
  car: "Car",
  boat: "Boat",
  apps: "Apps",
  thisStorageBoxTypeIsCurrentlyInUseAndItsStatusCantBeChanged:
    "This storage box type is currently in use and its status can't be changed",
  allowItemPhotosToBeUploadedFromTheDevicesImageGallery:
    "Allow item photos to be up-loaded from the device’s image gallery",
  thisSettingsEnablesMobileAppUsersToUploadImagesFromTheirDevicesGallery:
    "This setting enables mobile app users to upload images from their device's gallery",
  thisMayCauseADataSecurityRiskAsItCanEncourageTheStoringOfCustomerItemPhotosOnPersonalDevices:
    "This may cause a data security risk, as it can encourage the storing of customer item photos on personal devices",
  allowUseOfDeviceGallery: "Allow use of device gallery",
  galleryUsePermission: "Gallery use permission",
  enablesUsersToUploadItemImagesFromTheirDevicesGallery:
    "Enabled users to upload items images from their device's gallery",
  note: "Note",
  thisMayCauseAPersonalInformationSecurityRisksAsItCanEncourageTheStoringOfCustomerItemPhotosOnPersonalDevices:
    "This may cause a personal information security risks as it can encourage the storing of customer item photos on personal devices",
  typeHere: "Type here...",
  hideCC: "Hide CC",
  hideBCC: "Hide BCC",
  cc: "Cc",
  linkedTo: "Linked to",
  linkedMaterials: "Linked Materials",
  selectAMaterial: "Select a material",
  addAnExistingGroup: "Add an existing group",
  newBlankGroup: "New blank group",
  selectOneOrMoreGroups: "Select one or more groups",
  addGroup: "Add group",
  showCC: "Show CC",
  showBCC: "Show BCC",
  asTheShipmentIdentificationIsUniqueYouCannotChangeItAfterCreation:
    "As the shipment identification is unique, you cannot change it after creation",
  generatePDFReport: "Generate PDF report",
  reportLanguage: "Report language",
  taskReportType: "Task report type",
  addedToContainer: "Added to Container",
  ssccs: "SSCCs",
  typeAComment: "Type a comment",
  addAComment: "Add a comment",
  commentsHistory: "Comments history",
  addedOn: "Added on",
  youCanStartByCreatingASscc: "You can start by creating a SSCC",
  hereIsYourShipmentInfo: "Here is your shipment info",
  yourShipmentHasArrivedAt: "Your shipment has arrived at",
  commentSpecialInstruction: "Comment/Special instruction",
  hsCode: "HS Code",
  typeInAConsignee: "Type in a consignee",
  typeInACustomer: "Type in a customer",
  typeInOtherParty: "Type in other party",
  otherAdditionalParty: "Other/Additional party",
  byFillingInOneOrMoreOfTheseFieldsYourShipmentWillBeTracked:
    "By filling in one or more of these fields your shipment will be tracked.",
  moreContainerType: "More Container Type",
  sendCustomerPortalLink: "Send Customer Portal Link",
  typeInToSearch: "Type in to search",
  flight: "Flight",
  generatedBySystem: "Generated by system",
  mandatory: "Mandatory",
  newDocument: "New document",
  clearFile: "Clear file",
  areYouSureYouWantToDelete: "Are you sure you want to delete",
  deleteDocument: "Delete document",
  notAvailableYet: "Not available yet",
  documentsForThisShipment: "Documents for this shipment",
  shipmentMustBeConfirmed: "Shipment must be confirmed",
  clearingFile: "Clearing file",
  generatingFile: "Generating file",
  openingFile: "Opening file",
  shareCustomerPortalLink: "Share Customer Portal Link",
  sendTheCustomerPortalLinkWithAccessToTheOrderOnline:
    "Send the customer portal link with access to the order online",
  loading: "Loading",
  escalation: "Escalation",
  escalationContactRaised: "Escalation/Contact raised",
  removeEscalationRequest: "Remove escalation request",
  noKeepIt: "No, keep it",
  ohNoSomethingWentWrongPleaseTryAgain: "Oh no! Something went wrong. Please try again.",
  escalationRequestHasBeenRemoved: "Escalation request has been removed",
  removingThisEscalationChangeRequestWillClearAnyPendingRequests:
    "Removing this escalation/change request will clear any pending requests",
  areYouSureYouWishToProceed: "Are you sure you wish to proceed",
  yourEscalationRequestHasBeenSentSuccessfully:
    "Your escalation request has been sent successfully",
  inputComment: "Input comment",
  sendTo: "Send to",
  selectedPerson: "Selected person",
  selectWhoToNotify: "Select who to notify",
  theFollowingEmail: "The following email",
  notify: "Notify",
  contactUs: "Contact us",
  packingItems: "Packing items",
  closingTheBoxes: "Closing the boxes",
  listeningToBubbleWrapConfessions: "Listening to bubble wrap confessions",
  parkingTheShip: "Parking the ship",
  talkingToTheFish: "Talking to the fish",
  cartonContents: "Carton contents",
  ata: "ATA",
  thereIsNoTrackingInformationAvailableForThisShipment:
    "There is no tracking information available for this shipment",
  thisTabWillShowSomeTrackingInformationIfAvailableAfterYouCreateTheShipment:
    "This tab will show some tracking information, if available, after you create the shipment",
  theresNoTrackingInformationYet: "There's no tracking information yet",
  livePosition: "Live position",
  containerCase: "Container / Case",
  containerCaseSize: "Container / Case size",
  sealMarkings: "Sea # / Markings",
  selectALoadType: "Select a load type",
  selectAContainerCaseSize: "Select a container or case size",
  typeAContainerCaseSize: "Type a container or case size",
  dContainer: "D-Container",
  eContainer: "E-Container",
  ldnContainer: "LDN Container",
  liftvan: "Liftvan",
  liftvans: "Liftvans",
  eur1Iso1Pallet: "EUR1/ISO1 pallet",
  eur2Iso2Pallet: "EUR2/ISO2 pallet",
  itLooksLikeThereNoDataYet: "It looks like there's no data yet",
  startByAddingAnOrderToShipment: "Start by adding an Order to Shipment",
  thisValueShouldBeAPositiveNumber: "This value should be a positive number",
  selectTheLoadTypeFirst: "Select the Load type first",
  hsCommodityCode: "HS / Commodity code",
  searchForAnAgent: "Search for an agent",
  enterAValueGraterThanNetWeight: "Enter a value grater than net weight",
  enterAValueLowerThanGrossWeight: "Enter a value lower than gross weight",
  youShouldAddAtLeastOneContainerToTheShipment:
    "You should add at least one container to the shipment",
  thisRepresentsTheInitialEstimatedTimeOfArrivalProvidedByTheCarrier:
    "This represents the initial Estimated Time of Arrival provided by the carrier",
  thisIsYourShipmentInformation: "This is your shipment information",
  today: "Today",
  configure: "Configure",
  last15Days: "Last 15 days",
  lastMonth: "Last month",
  monthToDate: "Month to date",
  lastYear: "Last year",
  customDate: "Custom date",
  customPeriod: "Custom period",
  configureOverview: "Configure overview",
  adjustWidgetsAndViewAsYouWish: "Adjust widgets and view as you wish",
  purchaseOrdersWidgets: "Purchase Orders Widgets",
  poStatuses: "PO Statuses",
  lastReceivedOrders: "Last Received Orders",
  poConfirmedVSPoReceived: "PO Confirmed vs PO Received",
  productsOrigin: "Products Origin",
  mostRequestedProducts: "Most Requested Products",
  productsRunningOutOfStock: "Products Running Out of Stock",
  containersByArrivalDate: "Containers by Arrival Date",
  shipmentsPerTime: "Shipments Per Time",
  shipmentStatuses: "Shipment Statuses",
  resetToDefault: "Reset to default",
  ofTotal: "Of total",
  inboundAtPortAtDC: "In bound, At port and At dc",
  containersStatuses: "Containers Statuses",
  amountOfSSCC: "Amount of SSCC",
  apply: "Apply",
  searchForAConsultant: "Search for a consultant",
  enableQuoteEditing: "Enable quote editing",
  areYouSureYouWantToEnableEditingForThisQuote:
    "Are you sure you want to enable editing for this quote?",
  trackYourShipmentByFillingInEitherOrBothFields:
    " Track your shipment by entering the Bill of Lading (BOL), Booking id, or both.",
  pleaseFillInAtLeastOnField: "Please fill in at least one field.",
  dimensionalWeight: "Dimensional Weight",
  airportOfOrigin: "Port of Discharge (PoD)",
  airportOfDestination: "Destination Airport",
  arrivalAOfDestination: "Date of delivery",
  accounts: "Accounts",
  ofUsers: "of users",
  newAccount: "New account",
  companyAddress: "Company address",
  accountLogo: "Account logo",
  notEnoughData: "Not enough data",
  thereIsInsufficientDataToGenerateGraphicsForTheSelectedPeriod:
    "There is insufficient data to generate graphics for the selected period.",
  atDC: "At dc",
  incoterms: "Incoterms",
  uldContainers: "ULD Containers",
  uldPallets: "ULD Pallets",
  thisActionWillAlsoRemoveAnyFilesYouHaveUploadedInIt:
    "This action will also remove any files you have uploaded in it.",
  actualInventory: "Actual inventory",
  checkAllSteps: "Check all steps",
  milestones: "Milestones",
  checkYourMoveFileOnline: "Check your move file online",
  logedInAs: "Logged in as",
  english: "English",
  yourOrder: "Your Order",
  theTokenProvidedIsIncorrect: "The token provided is incorrect",
  nextStep: "Next Step",
  survey: "Survey",
  typeYourCommentsHere: "Type your comments here",
  agentContactDetails: "Agent Contact Details",
  distanceToNextPort: "Distance to next port",
  kg: "Kg",
  eventsUnavailable: "Events unavailable",
  routeUnavailable: "Route unavailable",
  trackingInformationUnavailable: "Tracking information unavailable at this time.",
  nauticalMiles: "Nautical Miles",
  closeAllSSCCs: "Close all SSCCs",
  areYouSureYouWantToCloseAllSSCCs: "Are you sure you want to close all SSCCs",
  isItByDefaultAMilestone: "Is it, by default, a milestone?",
  newTask: "New task",
  addTask: "Add task",
  tasksAndMilestones: "Tasks and milestones",
  milestonesFunctionallity: "Milestones functionallity",
  aMilestoneIsAKeyDateThatShowsOnTheCustomerPortalMilestonesAreDisplayedAsAMoveFlowInAscendingOrderTasksAreSetByDefaultToBeConsideredAMilestoneOrNot:
    "A milestone is a key date that shows on the customer portal. Milestones are displayed as a move flow in Ascending order. Tasks are set by default to be considered a milestone or not.",
  youCanEditTheseDefaultsInSystemSettings: "You can edit these defaults in system Settings.",
  youCanAlsoChooseToChangeThemAsNeededForThisFileOnly:
    "You can also choose to change them as needed for this file only.",
  setAsMilestone: "Set as milestone",
  removeAsMilestone: "Remove as milestone",
  youCanChooseFromTheListBelowWhichItemsYouWantToUpload:
    "You can choose from the list below which items you want to upload",
  downloadCSVTemplate: "Download CSV template",
  theFilesWereUploadedAndUpdatedSuccesfully: "The files were uploaded and updated successfully",
  anErrorOccurredLoadingUploadCentreTryAgain: "An error occurred loading Upload Centre, try again",
  weHaveFoundSomeErros: "we have found some errors",
  branchCode: "Branch code",
  warehouseCode: "Warehouse code",
  branchCodeNotFound: "Branch code not found",
  warehouseCodeNotFound: "Warehouse code not found",
  thisBranchIsNotRelatedToInformedWarehouse: "This branch is not related to informed warehouse",
  serviceCodeAlreadyExistsPleaseAssignANewCode:
    "Service code already exists. Please assign a new code.",
  materialCodeAlreadyExistsPleaseAssignANewCode:
    "Material code already exists. Please assign a new code.",
  codeAlreadyExistsPleaseAssignANewCode: "Code already exists. Please assign a new code.",
  codeIsDuplicated: "Code is duplicated",
  codeNotFound: "Code not found",
  anErrorOccurredOnTryAgain: "An error occurred on try again",
  looseItems: "Loose Items",
  thisFieldMustHaveAtLeastOneItem: "This field must have at least one item",
  theOrderAlreadyIsInATransshipment: "The order is already in a transshipment",
  publishTask: "Publish task",
  unpublishTask: "Unpublish task",
  noCommentsAdded: "No comments added",
  actualAtDepartureDock: "Arrival at PoD",
  actualArrivalOfDestination: "Date of Delivery",
  noRecord: "No record",
  hwab: "HWAB",
  selectAPeriod: "Select a period",
  storageBoxSingleUseSelected: "Storage box single-use selected",
  youCanAddOnlyOneOrderToAStorageBoxSingleUse:
    "You can add only one order to a storage box single-use",
  createsANomenclatureBasedOnTheTransshipmentNumberAndTheQuantityOfLiftvans:
    "Creates a nomenclature based on the transshipment number and the quantity of liftvans.",
  result: "Result",
  results: "Results",
  youCanOnlyUseOneStorageBoxSingleUsePerOrder:
    "You can only use one storage box single-use per order",
  youCanOnlyUseStorageBoxSingleUseForJustOneOrder:
    "You can only use storage box single-use for just one order.",
  completed: "Completed",
  initialRequest: "Initial request",
  noStepsInformed: "No steps informed",
  noTrackingAvailable: "No tracking available",
  dateNotInformed: "Date not informed",
  invoiceTotal: "Invoice Total",
  receivedDate: "Received Date",
  error: "Error",
  waitingUpdate: "Waiting update",
  shipeeziDefault: "Shipeezi’s default",
  theFileToUploadMustBeInCSVFormat: "The file to upload must be in .csv format",
  pleaseFillInTheRequiredFieldsBeforeSaving: "Please fill in the required fields before saving.",
  changeAssignee: "Change assignee",
  selectAPerson: "Select a person",
  theAssignedPersonHasBeenChangedSuccessfully: "The assigned person has been changed successfully",
  shipmentsPerDate: "Shipments Per Date",
  for: "for",
  chapter: "Chapter",
  heading: "Heading",
  subHeading: "Subheading",
  statisticalClassification: "Statistical classification",
  applicableTo: "Applicable to",
  inactivatingASectionChapterOrHeadingAllHSCommodityCodesRelatedWillBeInactivatedAsWell:
    "Inactivating a Section, Chapter or Heading, all HS / Commodity codes related to them will be inactivated as well.",
  doYouWantToInactivateAllOfThemAsWell: "Do you want to inactivate all of them as well?",
  activatingASectionChapterOrHeadingAllHSCommodityCodesRelatedWillBeActivatedAsWell:
    "Activating a Section, Chapter or Heading, all HS / Commodity codes related to them will be activated as well.",
  doYouWantToActivateAllOfThemAsWell: "Do you want to activate all of them as well?",
  inactivateCode: "Inactivate code",
  activateCode: "Activate code",
  typeInTheFirst6Digits: "Type in the first 6 digits",
  typeInTheLast2To4Digits: "Type in the last 2 to 4 digits",
  typeInTheCommodityCodeDescription: "Type in the commodity code description",
  typeInCountryOrRegion: "Type in country or region",
  commodityCode: "Commodity code",
  doYouReallyWantToDeleteThisCommodityCode: "Do you really want to delete this Commodity Code",
  deleteCommodityCode: "Delete Commodity Code",
  clone: "Clone",
  adjustTheDataAsDesiredToCreateTheNewCode: "Adjust the data as desired to create the new code.",
  insertAValidCode: "*Insert a valid code",
  youMustFillInTheFieldsInRed: "You must fill in the fields in red",
  importCSV: "Import CSV",
  importCSVFile: "Import CSV file",
  weHaveFoundSomeErrors: "we have found some errors",
  regions: "Regions",
  defineWheterTheStorageBoxTypeCanApperInAllWarehouses:
    "Define whether the storage box type can appear in all warehouses",
  defineIfTheStorageBoxTypeCanBeUsedInTransitInsideTheWarehouseOrBoth:
    "Define if the storage box type can be used in transit, inside the warehouse or both",
  pleaseSelectAtLeastOne: "Please select at least one",
  originAirport: "Origin Airport",
  finalDestinationAirport: "Final Destination Airport",
  plannedETD: "Planned ETD",
  departureFrom: "Departure from",
  departedFrom: "Departed from",
  theAirplanePositionIsUpdatedFrom15To15Minutes:
    "The airplane position is updated from 15 to 15 minutes.",
  inviteCustomer: "Invite customer",
  inviteCustomers: "Invite customers",
  supplyChain: "Supply Chain",
  allSelectedCustomersMustHaveNameEmailAndNotYetBelongToShipeezi:
    "All selected customers must have name, email and not yet belong to shipeezi",
  theBranch: "The branch",
  warehouseNotFound: "Warehouse not found",
  isNotRelatedToInformedWarehouse: "is not related to informed warehouse",
  writeACommentInSKU: "Write a comment in SKU",
  loadMore: "Load more",
  commentHistory: "Comment history",
  readMore: "Read more",
  return: "Return",
  toAdd: "to add",
  shiftReturn: "Shift + Return",
  toBreakLine: "to break line",
  now: "Now",
  inMoment: "In a moment",
  justNow: "Just now",
  in: "in",
  years: "years",
  yearAgo: "year ago",
  yearsAgo: "years ago",
  months: "months",
  monthAgo: "month ago",
  monthsAgo: "months ago",
  weeks: "weeks",
  weekAgo: "week ago",
  weeksAgo: "weeks ago",
  tomorrow: "Tomorrow",
  yesterday: "Yesterday",
  daysAgo: "days ago",
  hour: "hour",
  hours: "hours",
  hourAgo: "hour ago",
  hoursAgo: "hours ago",
  minute: "minute",
  minutes: "minutes",
  minuteAgo: "minute ago",
  minutesAgo: "minutes ago",
  pleaseTypeLessThanCharacters: "Please type less than {{maxLength}} characters",
  emailConfiguration: "Email Configuration",
  selectAll: "Select All",
  "common.clearAll": "Clear All",
  youCantRemoveColumsTheMinimumIs: "You can't remove columns. The minimum is",
  allTime: "All time",
  lastWeek: "Last week",
  allTypes: "All types",
  editions: "Editions",
  loads: "Loads",
  unloads: "Unloads",
  member: "Member",
  spouse: "Spouse",
  whoDoesThisItemBelongTo: "Who does this item belong to?",
  searchOrAddAnItem: "Search or add an item",
  writeYourMessageHere: "Write your message here",
  message: "Message",
  youAreNotifying: "You are notifying",
  perDestination: "Per Destination",
  asQuoted: "As Quoted",
  noItemsHaveBeenRegisteredYet: "No items have been registered yet",
  onceItemsAreAddedToInventoryYouWillBeAbleToSeeTheirDetails:
    "Once items are added to inventory you will be able to see their details",
  goodMorning: "Good Morning",
  goodAfternoon: "Good Afternoon",
  goodNight: "Good Night",
  youDontHaveAnyMovesWithUsYet: "You don't have any moves with us yet.",
  youHaveNotYetRequestedAQuoteFromUs: "You have not yet requested a quote from us.",
  itSeemsLikeEverythingIsFineAroudHere: "It seems like everything is fine around here",
  weAreHereToHelpYourMoveToBeAsSmoothlyAsPossible:
    "We are here to help your move to be as smoothly as possible",
  weAreHereToHelpYourQuoteToBeAsSmoothlyAsPossible:
    "We are here to help your quote to be as smoothly as possible",
  yourMoves: "Your moves",
  yourQuotes: "Your quotes",
  scheduled: "Scheduled",
  needsYourAttention: "Needs your attention",
  yourScheduleIsSqueakyCleanNoUpcomingAppointmentsToWorryAbout:
    "Your schedule is squeaky clean! No upcoming appointments to worry about.",
  ifWeNeedYouForAnythingHereItIsThePlaceToTakeAction:
    "If we need you for anything, here it is the place to take action.",
  actualMilestone: "Actual milestone",
  trackingAvailable: "Tracking available",
  howAboutHavingACoffe: "How about having a coffee?",
  everythingIsUpToDate: "Everything is up to date",
  youWillSeeAllTheCommunicationBetweenYourselfAndUsHere:
    "You will see all the communication between yourself and us here.",
  transshipped: "Transshipped",
  weDidNotFindAnyMovesRelatedTo: "We did not find any moves related to",
  noResultsFound: "No results found",
  nothingScheduledForNow: "Nothing scheduled for now",
  timeline: "Timeline",
  home: "Home",
  checkAllMilestones: "Check all milestones",
  yourMoveProgress: "Your Move Progress",
  showMore: "Show more",
  transport: "Transport",
  originContacts: "Origin contacts",
  destinationContacts: "Destination contacts",
  checkMyInventories: "Check my inventories",
  messageSentThankYouForContactingUsWellGetBackToYouSoon:
    "Message sent! Thank you for contacting us. We'll get back to you soon.",
  contactHistory: "Contact history",
  youContacted: "You contacted",
  yourMoveDocumentStatus: "Your move document status",
  pleaseFillInEitherTheMobileNumberOrPhoneNumberField:
    "Please fill in either the mobile number or the phone number field",
  pleaseFillAtLeastOne: "Please fill at least one",
  allItemsPacked: "All items packed",
  allYourItemsHaveBeenPackedAndEverythingIsFine:
    "All your items have been packed and everything is fine.",
  couldNotFoundWithUsernamePassword:
    "We didn't find an account with those credentials. For security reasons, after <strong>{{numberOfAttempts}} failed</strong> login attempts you have to wait <strong>{{lockoutDuration}}</strong> before trying again. <HiddenText> Do you need to <Link>reset your password</Link>? </HiddenText>",
  members: "Members",
  teams: "Teams",
  newTeam: "New team",
  equipments: "Equipments",
  leaderUser: "Leader (User)",
  inviteMember: "Invite member",
  newMember: "New member",
  chooseTheTypeOfMember: "Choose the type of member",
  theMemberCanHaveAccessToSystemOrNot: "The member can have access to system or not",
  personalDetails: "Personal Details",
  generalInformationAboutTheMember: "General information about the member",
  howThePersonAccessesAndInteractsWithTheSystem:
    "How the person accesses and interacts with the system",
  additional: "Additional",
  hasAccessToShipeeziSystemWithALoginAndPassword:
    "Has access to Shipeezi’s system, with a login and a password",
  thisMemberBelongsToASubcontractor: "This member belongs to a subcontractor",
  subcontractor: "Subcontractor",
  nickname: "Nickname",
  startEmploymentDate: "Start employment date",
  endEmploymentDate: "End employment date",
  citizenship: "Citizenship",
  license: "License",
  jobTitle: "Job title",
  editPhoto: "Edit photo",
  specificDetailsAboutTheStaffPerson: "Specific details about the staff person",
  staffInformation: "Staff information",
  typerOfUser: "Type of user",
  notApproved: "Not approved",
  review: "Review",
  expiry: "Expiry",
  certification: "Certification",
  certifications: "Certifications",
  newCertification: "New certification",
  uploadANewFile: "Upload a new file",
  confirmThisCertificationIsValidated: "Confirm this certification is validated",
  expire: "Expire",
  preferNotToSay: "Prefer not to say",
  nonBinary: "Non-binary",
  searchForCitizenship: "Search for citizenship",
  serchForCountry: "Search for country",
  thisUserIsAlsoALeader: "This user is also a leader",
  pleaseCompleteAllRequiredFields: "Please complete all required fields",
  createMember: "Create member",
  associatedWithThisMemberWhenYouAddThem: "associated with this member when you add them",
  associatedWithThisEquipmentWhenTheyAreAdded: "associated with this equipment when they are added",
  newAbsence: "New absence",
  absences: "Absence",
  absence: "Absence",
  allDayAbsence: "All day absence",
  availability: "Availability",
  convertStaffIntoUser: "Convert staff into user",
  convertUserIntoStaff: "Convert user into staff",
  configureAsSubcontractor: "Configure as subcontractor",
  doYouWantToConvertThisUserIntoStaff: "Do you want to convert this user into a staff?",
  doYouWantToConvertThisStaffIntoUser: "Do you want to convert this staff into an user?",
  youWillNeedToFillInTheMissigInformation: "You will need to fill in the missing information",
  thisMemberIsA: "This member is a",
  andIsDefinedAsA: "and is defined as",
  subconttractorFor: "subcontractor for",
  own: "Own",
  convertInto: "Convert into",
  subcontractorFor: "subcontractor for",
  timesheet: "Timesheet",
  timesheets: "Timesheets",
  typeOfMember: "Type of member",
  ifTheTeamAlreadyHasALeaderTheMemberWillBeAddedAsStaff:
    "If the team already has a leader, the member will be added as staff",
  emergencyEmail: "Emergency Email",
  newTime: "New time",
  editTeam: "Edit team",
  addMember: "Add member",
  addTeam: "Add team",
  nameL: "Name",
  equipmentPhoto: "Equipment photo",
  maxSize2mb: "Max size 2MB",
  formatsJpgGifPng: "Formats: JPG, GIF, PNG",
  equipmentIcon: "Equipment icon",
  rental: "Rental",
  leased: "Leased",
  noMembersAssociatedToThisEquipment: "No members associated to this equipment",
  youCanStartByAddingAMember: "You can start by adding a member",
  newUnavailabilityTime: "New unavailability time",
  allDayUnavailable: "All day unavailable",
  rolesecurity: "Role (security)",
  loaction: "Location",
  addMembers: "Add members",
  youwillbeabletoseealltheinformationabouttheavailabilityofthismemberwhenyouaddthem:
    " You will be able to see all the information about the availability of this member when you add them",
  addUnavailability: "  Add unavailability",
  addTeams: "Add Teams",
  enableThisFleetAsAStrorageBox: "Enable this fleet as a storage box",
  dates: "Dates",
  selectAnOptionToSeeTheForm: "Select an option to see the form",
  typeInToSearchAMebmer: "Type in to search a member",
  pantech: "Pantech",
  nickName: "Nickname",
  EuroNorm: "EUROnorm",
  driverLicense: "Driver License",
  manufacturer: "Manufacturer",
  branch1: "Branch 1",
  warehouse1: "Warehouse 1",
  enableThisFleetAsAStorageBox: "Enable this fleet as a storage box",
  writeADescription: "Write a description",
  chooseAvehicleTypeOfEquipmentLikeAForkliftOrATruck:
    "Choose a vehicle type of equipment, like a forklift or a truck",
  chooseAVehicleTypeOfEquipmentLikeAForkliftOrATruck:
    "Choose a vehicle type of equipment, like a forklift or a truck",
  createMoreGeneralizedEquipmentWithAFewDetails:
    "Create more generalized equipment, with a few details",
  whoOwnsThisEquipment: "Who owns this equipment?",
  businessphone: "Business phone",
  vatcode: "VAT Code",
  iban: "IBAN",
  bic: "BIC",
  usesameasgeneraladdress: "Use same as general address",
  addaequipment: "Add a equipment",
  quickcreationequipment: "Quick creation equipment",
  addequipment: "Add equipment",
  addAMember: "Add a member",
  addATeam: "Add a team",
  createnew: "Create New",
  businessdetails: "Business details",
  businessinformationaboutthesubcontractor: "Business information about the subcontractor",
  generalinformationabouttheowner: "General information about the owner",
  bankingdetails: "Banking details",
  nomembersassociatedtothisequipment: "No members associated to this equipment",
  youcanstartbyaddingamember: "You can start by adding a member",
  createnewmember: "Create new member",
  addanexistentmember: "Add an existent member",
  quickcreation: "Quick creation",
  equipment: "Equipment",
  quicklycreateanewequipmentwithessentialdetailsaddmoreinformationanytimeinsettings:
    "Quickly create a new equipment with essential details. Add more information anytime in settings.",
  createmoregeneralizedequipmentwithafewdetails:
    "Create more generalized equipment, with a few details",
  personaldetails: "Personal details",
  platenumber: "Plate Number",
  subcontractors: "Subcontractors",
  newSubcontractor: "New subcontractor",
  qtyMembers: "Qty members",
  qtyEquipments: "Qty equipments",
  businessDetails: "Business details",
  businessInformationAboutTheSubcontractor: "Business information about the subcontractor",
  businessPhone: "Business phone",
  generalInformationAboutTheOwner: "General information about the owner",
  addNumberHere: "Add number here",
  bankingDetails: "Banking details",
  vatCode: "VAT Code",
  useSameAsGeneralAddress: "Use same as general address",
  contactEmail: "Contact email",
  noMembersAssociatedToThisSubcontractor: "No members associated to this subcontractor",
  createNewMember: "Create new member",
  addAnExistentMember: "Add an existent member",
  noMembersToShow: "No members to show",
  noTeamsToShow: "No teams to show",
  typeInToSearchAMember: "Type in to search a member",
  addWorkTimeToMember: "Add work time to member",
  howDoYouWantToAddAnewTime: "How do you want to add a new time",
  createMockTask: "Create mock task",
  createAMimicTaskToRecordHoursForThisMember:
    "Create a mimic task to record hours for this member.",
  selectExistentTask: "Select existent task",
  selectAnExistingTaskInTHeOrderToLogWorkTime:
    "Select an existing task in the order to log work time",
  addTime: "Add time",
  backFromBreak: "Back from break",
  itLooksLikeNoOrderWasSelectYet: "It looks like no order was selected yet",
  startSearchingForAnOrderToBeAbleToCreateANewTask:
    "Start searching for an order to be able to create a new task",
  searchOrderBy: "Search order by",
  cancelAvailability: "Cancel availability",
  doYouReallyWantToCancelThisAbsence: "Do you really want to cancel this absence for",
  yesCancel: "Yes, cancel",
  thisActionCannotBeUndone: "This action cannot be undone",
  viewTime: "View Time",
  editTime: "Edit time",
  noLeaderAvailable: "No leader available",
  noStaffAvailable: "No staff available",
  noTasks: "No tasks",
  m3: "m³",
  unavailableUntil: "Unavailable until",
  lv: "LV",
  noEquipmentToShow: "No equipment to show",
  addEquipment: "Add equipment",
  addAnExistentEquipment: "Add an existent equipment",
  addEquipments: "Add equipment",
  addAEquipment: "Add a equipment",
  newEquipment: "New equipment",
  chooseTheTypeOfEquipment: "Choose the type of equipment",
  purchaseDate: "Purchase date",
  soldDate: "Sold date",
  euronorm: "EUROnorm",
  lastInspectionDate: "Last inspection date",
  nextInspectionDate: "Next inspection date",
  pleaseSelectAnLaterDate: "Please select an later date",
  pleaseSelectAnEarlierDate: "Please select an earlier date",
  workedTime: "Worked time",
  breaks: "Breaks",
  waitingApproval: "Waiting approval",
  noSubcontractorAvailable: "No subcontractor available",
  noLeaderAdded: "No leader added",
  noStaffAdded: "No staff added",
  noEquipmentAdded: "No equipment added",
  noStorageBoxAdded: "No storage box added",
  noOrders: "No orders added",
  openOrder: "Open order",
  accessDetails: "Access details",
  membersAndTeams: "Members & teams",
  membersAndEquipments: "Members & equipments",
  extraMembersAndTeams: "Extra Members & Teams",
  addTeamToBoard: "Add team to board",
  timeMustBeAfter: "Time must be after",
  addALeader: "Add a leader",
  addStaffs: "Add staffs",
  addStorageBoxes: "Add storage boxes",
  timeClock: "Time clock",
  removeTaskFromTeam: "Remove task from team",
  youCannotPublishATaskWithoutALeader: "You cannot publish a task wihout a leader",
  thisChangeWillBeProcessedShortly: "This change will be processed shortly",
  noLanguageAvailable: "No language available",
  noJobTitleAvailable: "No job title available",
  equipmentDetails: "Equipment details",
  removeThisTeamFromTheBoard: "Remove this team from the board",
  areYouSureyouWantToCancelTheTask: "Are you sure you want to cancel the task",
  forOrder: "For order",
  createCrew: "Create crew",
  noTeamsAddedYet: "No teams added yet",
  allCaughtUpWhatAboutACoffee: "All caught up! What about a coffee?",
  weAreDoingOneLastSearchWhatAboutACoffee: "We are doing one last search.. What about a coffee?",
  viewOptions: "View options",
  showItemsUnavailable: "Show items unavailable",
  showEmptyOrdersTasks: "Show empty orders tasks",
  showEmptyTeams: "Show empty teams",
  collapseOrdersTasks: "Collapse orders tasks",
  collapseTeams: "Collapse teams",
  expandOrdersTasks: "Expand orders tasks",
  expandTeams: "Expand teams",
  organization: "Organization",
  organiseByTask: "Organise by task",
  organiseByOrder: "Organise by order",
  organiseByTeam: "Organise by team",
  youCannotPublishThisTask: "You cannot publish this task",
  typeHereAndPressEnter: "Type here and press enter",
  noMemberFound: "No member found",
  noTeamFound: "No team found",
  noOrderFound: "No order found",
  noInformationToShow: "No information to show",
  noEquipmentFound: "No equipment found",
  noStorageBoxFound: "No storage box found",
  pressToSearch: "Press to search",
  noOrderAvailable: "No order available",
  youHaveToUnpublishFirst: "You have to unpublish first",
  thisTaskAlreadyStartedByTheLeader: "This task already started by the leader",
  thisTaskAlreadyFinished: "This task already finished",
  thisTaskAlreadyCancelled: "This taslk already cancelled",
  youHaveToAddATaskBeforeCreateASingleUse: "You have to add a task before create a single use",
  youCannotAddASingleUseForDifferentOrders: "You cannot add a single use for different orders",
  createAStorageBoxSingleUse: "Create a storage box single use",
  thisTaskCannotBeCancelled: "This task cannot be cancelled",
  thereIsNoNeed: "There is no need",
  vipMode: "VIP mode",
  bluebarkMove: "Bluebark move",
  satefyMove: "Safety move",
  dispatch: "Dispatch",
  youHaveUnpublishedTasks: "You have unpublished tasks!",
  thisTeamHasTasksAlreadyPublishedForThisLeader:
    "This team has tasks already published for this leader",
  anOperationalMemberUsedJustForRegisterPurposes:
    "An operational member, used just for register purposes",
  boardDisplay: "Board display",
  createATemporaryTeamoForTodaysTasks: "Create a temporary team for today's tasks",
  registredAddress: "Registered address",
  noResultMatchYourSearch: "No results match your search",
  searchAndSelectOrder: "Search and select order",
  itLooksLikeNoOrderWasSelectedYet: " It looks like no order was selected yet",
  startSearchingForAnOrderYoBeAbleToCreateANewTask:
    "Start searching for an order to be able to create a new task",
  newTaskFor: "New task for",
  timeFor: "Time for",
  notifyTheClientAboutTheStartOfTheTask30MinutesInAdvance:
    "Notify the client about the start of the task 30 minutes in advance",
  breakFromBreak: "Back from break",
  albertFloresMarvinMcKinneyJeromeBell: " Albert Flores, Marvin McKinney, Jerome Bell",
  extraMembers: "Extra Members & Teams",
  devonLane: "Devon Lane",
  readLess: "Read less",
  writeACommentIn: "Write a comment in",
  shift: "shift",
  teamRemovalIsBlockedDueToThePresenceOfTasks:
    "Team removal is blocked due to the presence of tasks.",
  vipTreatment: "VIP treatment",
  personalAddress: "Personal address",
  pleaseSelectAStartDate: "Please, select a start date",
  morning: "Morning",
  afternoon: "Afternoon",
  evening: "Evening",
  night: "Night",
  registeredAddress: "Registered address",
  noTaskYest: "No task yest",
  writeAComment: "Write a comment",
  allowBookingSearch: "Allow booking search",
  securityLoginAttempts:
    "For security reasons, after <strong>{{numberOfAttempts}} failed</strong> login attempts you have to wait <strong>{{lockoutDuration}}</strong> before trying again.",
  weakPassword: "Weak password",
  avaragePassword: "Avarage password",
  goodPassword: "Good password",
  strongPassword: "Strong password",
  passwordMustHave: "Your password must have:",
  UpperAndLowercaseLetters: "Upper and lowercase letters",
  aSpecialCharacter: "A special character (#$&@)",
  atLeastOneNumber: "At least one number",
  minLength: "12 or more characters",
  pleaseEnterANewPassword: "Please enter a new password",
  pleaseConfirmPassword: "Please confirm password",
  autoTerminateSessionExpire:
    "For security reasons, your connection expires after 8 hours of activity. Please, save your work and logout. If you prefer to remain logged in, in <strong> 15 minutes</strong> we will ask you to re-enter your credentials.",
  yourSessionIsAboutToExpire: "Your session is about to expire",
  terminatedSession: "This session has been terminated.",
  reEnterCreds: "Please <strong> re-enter </strong> your credentials.",
  weWillSendALinkToResetYourPasswordToTheEmailAddressAssociatedWithYourAccount:
    "We will send a link to reset your password to the email address associated with your account.",
  sortReportBy: "Sort report by",
  sortedByInventory: "Sorted by inventory",
  sortedAndGroupedByStorageBox: "Sorted and grouped by storage box",
  loadOrder: "Load order",
  areYouSureYouWantToLoadThisOrder: "Are you sure you want to load this order?",
  changeOrderStatusModalDescription: "The new order status will be '{{status}}'.",
  noKeepItAsItIs: "No, keep it as it is",
  noKeepItAsStatus: "No, keep it as {{status}}",
  yesLoad: "Yes, load",
  yesDeliver: "Yes, deliver",
  noPhotosHaveBeenAddedYet: "No photos have been added yet",
  transportationType: "Transportation type",
  assistance: "Assistance",
  doorToDoor: "Door to Door",
  doorToPort: "Door to Port",
  doorToWarehouse: "Door to Warehouse",
  fotWarehouse: "FOT Warehouse",
  portToDoor: "Port to Door",
  portToPort: "Port to Port",
  portToWarehouse: "Port to Warehouse",
  warehouseToDoor: "Warehouse to Door",
  warehouseToPort: "Warehouse to Port",
  warehouseToWarehouse: "Warehouse to Warehouse",
  accountType: "Account type",
  accountContact: "Account contact",
  bookingAgent: "Booking agent",
  personalPropertyProgram: "Personal Property Program",
  searchForAnOption: "Search for an option",
  memberWillChangeFromSubcontractorToOwnAfterSaving:
    'Member will change from "subcontractor" to "own" after saving',
  memberWillChangeFromOwnToSubcontractorAfterSaving:
    'Member will change from "own" to "subcontractor" after saving',
  memberWillChangeFromUserToStaffAfterSaving:
    'Member will change from "user" to "staff" after saving',
  memberWillChangeFromStaffToUserAfterSaving:
    'Member will change from "staff" to "user" after saving',
  noTaskYet: "No task yet",
  workHours: "Work hours",
  breakHours: "Break hours",
  mostCommonTask: "Most common task",
  theCompanyDoesNotHaveARegisteredAddress: "The company does not have a registered address",
  noPhotoAdded: "No photo added",
  exampleAyrton: "Example: Ayrton",
  exampleSenna: "Example: Senna",
  mailmailcom: "mail@mail.com",
  newUnavailability: "New Unavailability",
  editTask: "Edit task",
  notAllocated: "Not allocated",
  vipTasksWithAssign: "VIP tasks with assign",
  tasksWithNoAssign: "Tasks with no assign",
  normalTasksWithAssign: "Normal tasks with assign",
  noCrewAssigned: "No crew assigned",
  certificationType: "Certification Type",
  defineWheterTheStorageBoxTypeRequiresPhotosSealNumberOrBoth:
    "Define if the storage box type requires photos, seal number or both",
  checklist: "Checklist",
  sealsNumber: "Seals number",
  ifNoRuleIsAddedToAnOrderTypeTheRequiredSealNumberWillBeEqualTo1:
    "If no rule is added to an order type, the required seal number will be equal to 1",
  checklistRules: "Checklist rules",
  itLooksLikeThereIsNoRulesAdded: "It looks like there's no rules added",
  youCanStartByAddingANewRuleByClickingTheButtonBellow:
    "You can start by adding a new rule by clicking the button below",
  addARule: "Add a rule",
  sealNumbersNeeded: "Seal numbers needed",
  numberOfSealsRequired: "Number of seals required",
  whenOrderTypeIs: "When order type is",
  addAnotherRule: "Add another rule",
  sealsValueMustBeGreaterThan0: "Seals value must be greater than 0",
  pleaseFillInTheCustomerInformationFirst: "Please fill in the customer information first.",
  isAllocated: "Is allocated",
  clearSelection: "Clear selection",
  typeIn: "Type in",
  newPlaceholderTask: "New placeholder task",
  taskName: "Task name",
  typeHereAComment: "Type here a comment",
  deleteTask: "Delete task",
  yesDelete: "Yes, delete",
  areYouSureyouWantToDeleteTheTask: "Are you sure you want to delete the task",
  placeholder: "Placeholder",
  taskDescription: "Task description",
  describeTaskHere: "Describe task here",
  sealNumbers: "Seal numbers",
  sealNumber: "Seal number",
  photosOfSpecialItemsInside: "Photos of special items inside",
  photosOfCaulked: "Photos of caulked",
  photosOfPackedAndSealed: "Photos of packed and sealed",
  itLooksLikeThereIsNoPhotosYet: "It looks like there's no photos yet",
  youCanStartByAddingANewPhotoOnTheButtonBelow:
    "You can start by adding a new photo on the button below",
  addAnotherPhoto: "Add another photo",
  checklistDone: "Checklist done",
  noTaskAdded: "No task added",
  createAnInternalTaskOrARegisterForADraftTask:
    "Create an internal task or a register for a ‘draft’ task",
  selectAReport: "Select a report",
  crew_schedule_report: "Crew Schedule Report",
  warehouse_schedule_report: "Warehouse Schedule Report",
  atLeastOneBranchMustBeSelected: "At least one branch must be selected",
  reportTypeIsRequired: "Report type is required",
  noReportGenerated: "No report generated",
  reportGeneratedSuccessfully: "report generated successfully",
  reportsGeneratedSuccessfully: "reports generated successfully",
  youMustSelectAtLeast1BranchToPrint: "You must select at least 1 branch to print",
  leaderName: "Leader Name",
  memberName: "Member Name",
  equipmentName: "Equipment Name",
  multiDay: "Multi day",
  theTaskIsFinishedSoItCannotBeRemoved: "The task is finished, so it cannot be removed.",
  showSupplierNameOnTheSSCCLabel: "Show supplier name on the SSCC Label",
  dateFor: "Date for",
  isThisAMultiDayTask: "Is this a multi-day task?",
  endDateCantBeBeforeStartDate: "End date can't be before start date",
  quickSearch: "Quick Search",
  newSubscriber: "New Subscriber",
  searchForAnUserByTyping: "Search for an user by typing",
  enterContactType: "Enter contact type",
  unselectAll: "Unselect All",
  thereAreNoOrderBelongingToTheSelectedBranchesFor:
    "There are no orders belonging to the selected branch(es) for",
  thereAreNoOrderBelongingToTheSelectedBranchesForToday:
    "There are no orders belonging to the selected branch(es) for today",
  multi_day: "Multi-Day",
  fullDay: "Full day",
  between: "between",
  unavailableOn: "Unavailable on",
  h: "h",
  m: "m",
  withPhotos: "With photos",
  withoutPhotos: "Without photos",
  manageEmailSubscriptions: "Manage email subscriptions",
  reportName: "Report name",
  subscribers: "Subscribers",
  editActivities: "Edit Activities",
  emailActivities: "Email Activities",
  activities: "Activities",
  timestamp: "timestamp",
  changes: "Changes",
  modifiedBy: "Modified By",
  selectedFilters: "Selected Filters",
  deactivate: "Deactivate",
  areYouSureYouWantToDeactivateThisReportEmailSubscription:
    "Are you sure you want to deactivate this report email subscription?",
  youWillNoLongerReceiveEmailsForTheSelectedReport:
    "You will no longer receive emails for the selected report.",
  deactivateEmailScheduleForThisReport: "Deactivate email schedule for this report?",
  yesDeactivate: "Yes, Deactivate",
  cancelGoBack: "Cancel & Go Back",
  noEmailSubscriptionsRegistered: "No email subscriptions registered",
  addAdminUser: "Add admin user",
  oneTime: "One time",
  emailFrequency: "Email frequency",
  noOfTasks: "No. of tasks",
  orderCreated: "Order created",
  totalOrders: "Total orders",
  ordersCompleted: "Orders completed",
  totalTasks: "Total tasks",
  tasksCompleted: "Tasks completed",
  exportingCSV: "Exporting CSV",
  taskBooked: "Task booked",
  hideTasks: "Hide tasks",
  showTasks: "Show tasks",
  lifetime: "Lifetime",
  reportLifetimeData: "Report lifetime data",
  originBranch: "Origin branch",
  destinationBranch: "Destination branch",
  teamBranches: "Team branches",
  receiveOnlyOnce: "Receive only once",
  receiveEveryWeek: "Receive every week",
  receiveOnceAMonth: "Receive once a month",
  sendOn: "Send on",
  sendEvery: "Send every...",
  onceYouClickOn: "Once you click on",
  youWillReceiveThisReportWithAllTheSelectedFiltersAndSetFrequency:
    "you will receive this report with all the selected filters (listed above) and set frequency.",
  emailDeliveryMayBeDelayedDueFactorsBeyondOurControl:
    "Email delivery may be delayed due to factors beyond our control.",
  pleaseWhitelistToAvoidEmailsGoingToSpam:
    "Please whitelist shipeezi.com to avoid emails going to spam.",
  subscriberMustBeRegisteredOnShipeezi: "Subscriber must be registered on shipeezi",
  enterADayOfTheMonthBetween1and28: "Enter a day of the month between 1 and 28",
  selectReportType: "Select report type",
  allReports: "All reports",
  selectTaskReportType: "Select task report type",
  generateAndDownload: "Generate & Download",
  workOrder: "Work order",
  applicableOnlyOnInventoryConditionReport: "Applicable only on Inventory condition report",
  applicableOnlyOnLoadAndTransshipmentReport: "Applicable only on Load & Transshipment report",
  applicableOnInventoryConditionReportMechanicalAndEletricalChecklistHightValuePropertyDemange:
    "Applicable on Inventory condition report, Mechanical & electrical checklist, High risk/high value inventory, Property damage report, Load & transshipment report, checklist report (if selected)",
  listOfReports: "List of reports",
  allAvailableReportsForThisOrderWillBeGeneratedInOneBatchWhichMayTakeLongerThanUsual:
    "All available reports for this order will be generated in one batch, which may take longer than usual.",
  pleaseNoteThatGrayedOutReportsAreCurrentlyUnavailbaleForThisOrder:
    "Please note that grayed-out reports are currently unavailable for this order.",
  youCanChooseTheSpecificReportsYouNeedAndEachSelectedReportWillBeGeneratedAsAnIndividualFileWhichMayTakeLongerThanUsual:
    "You can choose the specific reports you need, and each selected report will be generated as an individual file, which may take longer than usual.",
  security: "Security",
  enableTwoFactorAuthenticationToLogin: "Enable two-factor authentication to login",
  enableAnExternalMethodToAuthenticateLogin: "Enable an external method to authenticate login.",
  limitUnsuccessfulLogonAttempts: "Limit unsuccessful logon attempts",
  anThe4thFailedAttemptTheAccountWillBeLockedFor30Seconds:
    "On the 4th failed attempt, the account will be locked for 30 seconds;",
  onThe5thFailedAttemptTheAccountWillBeLockedFor60Seconds:
    "On the 5th failed attempt, the account will be locked for 60 seconds;",
  anyFailedAttemptsAfterThe5thTheAccountWillBeLockedFor120Seconds:
    "Any failed attempts after the 5th, the account will be locked for 120 seconds.",
  onThe6thFailedAttemptTheAccountWillBeLockedFor120Seconds:
    "On the 6th failed attempt, the account will be locked for 120 seconds;",
  anyFailedAttemptsAfterThe6thTheAccountWillBeLockedFor120Seconds:
    "Any failed attempts after the 6th, the account will be locked for 120 seconds.",
  autoTerminateSessionsAfter8HoursFromLogin: "Auto-terminate sessions after 8 hours from login",
  thePlatformCalculates8HoursFromTheMostRecentLoginAndTerminatesTheSessionRequiringTheUserToLogInAgain:
    "The platform calculates 8 hours from the most recent login and terminates the session, requiring the user to log in again.",
  aWarningAppears15MinutesBeforeTheSessionTeminates:
    "A warning appears 15 minutes before the session teminates.",
  minimumPasswordComplexityPolicy: "Minimum password complexity policy",
  passwordsMustFulfilMinimumRequirementsForAComplexPasswordWhenCreatingOrResettingAPassword:
    "Passwords must fulfil minimum requirements for a complex password when creating or resetting a password.",
  prohibitPasswordReuse: "Prohibit password reuse",
  prohibitUsersFromReusingAPreviousPasswordWhenCreatingOrResettingAPassword:
    "Prohibit users from reusing a previous password when creating or resetting a password.",
  automatedPasswordResetPolicy: "Automated password reset policy",
  passwordsMustBeChangedEvery90Days: "Passwords must be changed every 90 days.",
  operationsApp: "Operations app",
  inventoryNumberingIsTheStartingInventoryNumberEditable:
    "Inventory numbering: Is the starting inventory number editable?",
  enforceAppLockScreen: "Enforce app lock screen",
  usingTheAppForMilitaryPurpose: "Using the app for military purpose?",
  ifAUserIsInactiveForASetPeriodTheAppLocksAutomaticallyForSecurityUsersChooseAPinAtFirstLoginAndCanResetItUsingTheirUsernameAndPasswordThisPreventsUnauthorizedAccessToSensitiveData:
    "If a user is inactive for a set period, the app locks automatically for security. Users choose a PIN at first login and can reset it using their username and password. This prevents unauthorized access to sensitive data.",
  enterInactivityTime: "Enter inactivity time",
  fieldRelatedSettings: "Field related settings",
  loadIntoStorageBoxIsMandatoryInUpliftTask: "Load into Storage Box is Mandatory in Uplift Task",
  systemConfigurationIsNotAvailablePleaseContactTheAdministratorForAssistance:
    "System configuration is not available. Please contact the administrator for assistance.",
  updatedSuccessfully: "Updated Successfully",
  ifVolumeConfirmationIsMandatoryThenStorageBoxMandatoryOptionMustBeSetToFalse:
    "If Volume Confirmation is mandatory, then the Storage Box mandatory option must be set to false.",
  volumeConfirmation: "Volume Confirmation",
  autofillBasedOnTheTask: "Autofill based on the task",
  allowMultipleSelection: "Allow multiple selection",
  inventoryFields: "Inventory fields",
  expanseManagement: "Expense management",
  others: "Others",
  cost: "Cost",
  onceDeletedThisEntryWillBePermanentlyRemoved:
    "Once deleted, this entry will be permanently removed.",
  loadingTaskInformation: "Loading task information...",
  taskNotFound: "Task not found",
  couldNotLoadRequestedTaskDetails: "Could not load the requested task details.",
  recalculateExpenses: "Recalculate Expenses",
  isTimeSlotRequiredForMultiDayTask: "Is time slot required for multi-day task?",
  fixedTimeSlot: "Fixed time slot",
  variableTimeSlot: "Variable time slot",
  addAnotherDate: "Add another date",
  itShouldBeAtLeastTwoDates: "It should be at least two dates.",
  endTimeMustBeGreaterThanStartTime: "`To` time must be greater than `From` time.",
  generatingYourReportMightTakeLongerThanUsual:
    "Generating your report might take longer than usual.",
  weWillNotifyYouAsSoonAsItsReadyForDownload:
    "We'll notify you as soon as it's ready for download. You can safely close this window in the meantime.",
  categorizeItemsInOperationsApp: "Categorize items in operations app",
  checkedFieldsWillBeMarkedAsAMandatory: "Checked fields will be marked as a mandatory.",
  selectCategories: "Select categories",
  mandatoryFields: "Mandatory Fields",
  mandatoryFieldsByCategory: "Mandatory fields by category",
  noAccess: "No access",
  fullAccess: "Full access",
  partialAccess: "Partial access",
  newAccessRuleAdded: "New Access Rule '{{accessRuleName}}' added",
  newAccessRuleAddedAndSetAsInactive:
    "New Access Rule '{{accessRuleName}}' added & set as inactive",
  accessRuleUpdatedSuccessfully: "Access Rule '{{accessRuleName}}' updated successfully",
  accessRuleDeletedSuccessfully: "Access Rule '{{accessRuleName}}' deleted successfully",
  thisIsASystemDefaultAccessRuleAndCannotBeModifiedYouAreWelcomeToCreateANewAccessRuleOrDuplicateAsNeeded:
    "This is a system default access rule and cannot be modified. You are welcome to create a new access rule or duplicate as needed.",
  thisAccessRuleIsUtilizedBy: "This access rule is utilized by {{group}}",
  returnToPermissions: "Return to permissions",
  thisRuleIsCurrentlyUtilizedByGroupsAndCannotBeDeactivated:
    "This rule is currently utilized by groups and cannot be deactivated.",
  thisRuleIsCurrentlyUtilizedByGroupsAndCannotBeDeleted:
    "This rule is currently utilized by groups and cannot be deleted.",
  pleaseUseOnlyLettersNumbersAndSpacesSpecialCharactersAreNotAllowed:
    "Please use only letters, numbers, and spaces. Special characters are not allowed.",
  enterNameForThisAccessRule: "Enter name for this access rule",
  describeThisAccessRuleInFewWords: "Describe this access rule in few words",
  failedToAssignPermissionsToAccessRulePleaseTryAgain:
    "Failed to assign permissions to access rule. Please try again.",
  yourPermissionsHaveBeenUpdatedPleaseLogInAgainToApplyTheNewChanges:
    "An administrator has updated your group’s access permissions. To apply the changes, you need to log out and sign back in.",
  signBackIn: "Sign back-in",
  groupAccessRuleUpdated: "Group access rule updated",
  theAccessRuleNameAlreadyExistsPleaseChooseADifferentName:
    "The access rule name '{{accessRuleName}}' already exists. Please choose a different name.",
  enterNickname: "Enter Nickname",
  nicknameIsForYourOwnReference: "Nickname is for your own reference",
  dateOfDeparture: "Date of Departure",
  arrivalAtAod: "Arrival at AoD",
  enterOrder: "Enter order",
  enterEmail: "Enter Email",
  enterMobileNumber: "Enter mobile number",
  realTimeTrackingUnavailable: "Real-Time Tracking Unavailable",
  liveTrackingIsUnavailableOnYourCurrentPlanUnlockThisFeatureByUpgradingYourPlanOrContactingOurSupportTeamForAssistance:
    "Live Tracking is unavailable on your current plan. Unlock this feature by upgrading\nyour plan or contacting our support team for assistance.",
  typeOfContact: "Type of Contact",
  notifyVia: "Notify Via",
  refineByOrder: "Refine by Order",
  bolBooking: "BoL/Booking",
  pol: "PoL",
  utilization: "Utilization",
  destinationAirport: "Destination Airport",
  display: "Display",
  items2: "items",
  exportCSV: "Export CSV",
  numberOfRowsPerPage: "Number of rows per page",
  errorField: "Error",
  showHideColumn: "Show/Hide columns",
  typeAndClickEnterToAdd: "Type and click enter to add",
  communicationSentSuccessfully: "Communication sent successfully!",
  deSelectAll: "Unselect All",
  selectOrders: "Select orders",
  addSelectedOption: "Add Selected Orders",
  volumeAdded: "Volume Added",
  noLinkNotYet: "No linked orders yet!",
  notifyUsers: "Notify Users",
  notificationSentSuccessfully: "Notification sent successfully!",
  continueBooking: "Continue Booking",
  saveADraft: "Save a Draft",
  grossWeightKg: "Gross weight (Kg)",
  saveThisSearch: "Save this search",
  serial: "Serial",
  groupManagementCreatedSuccessfully: "Group '{{groupName}}' created successfully",
  groupManagementUpdatedSuccessfully: "Group '{{groupName}}' updated successfully",
  errorUpdateGroupManagement:
    "An error occurred while updating group '{{groupName}}'. Please contact Shipeezi support for assistance",
  groupInfoViewOnly:
    "This is a default system group that cannot be modified, but you can or remove members from it",
  groupNameAlreadyExists:
    "The group name '{{groupName}}' already exists. Please choose a different name.",
  departure: "Departure",
  arrival: "Arrival",
  itLooksLikeYoureAboutToLeaveTheBookingProcessIfYouExitNowYourBookingWillNotBeCompletedAndAllTheInformationYouveEnteredSoFarWillBeLost:
    "It looks like you’re about to leave the booking process. If you exit now, your booking will not be completed, and all the information you’ve entered so far will be lost.",
  importantOnceYouLeaveTheresNoGuaranteeThatTheSameAvailabilityAndRatesWillStillApplyIfYouStartTheBookingAgain:
    "Important: Once you leave, there’s no guarantee that the same availability and rates will still apply if you start the booking again.",
  areYouSureYouWantToCancel: "Are you sure you want to cancel?",
  connectionTimeout: "Connection Timeout: Please Try Again",
  timeoutDetail:
    "It is taking longer than expected. This might be a temporary issue. Please refres the page or try again shortly.",
  retry: "Retry",
  nothingToDisplayHere: "Nothing to display here!",
  toGetStartedFillOutTheSearchFormWithYourFreightDetailsAndHitTheSearchButtonToSeeTheBestAvailableOptions:
    'To get started, fill out the search form with your freight details and hit the "Search" button to see the best available options.',
  averagePassword: "Average password",
  tariff: "Tariff",
  roadFreightPickUp: "Road freight\n(pick up)",
  thcO: "THC-O",
  exportService: "Export service",
  thcD: "THC-D",
  importService: "Import service",
  roadFreightDelivery: "Road freight (delivery)",
  carbonOffset: "Carbon offset",
  transportMode: "Transport mode",
  rateValidity: "Rate validity",
  totalCargoWeight: "Total cargo weight",
  inspectionServices: "Inspection Services",
  customClearance: "Custom Clearance",
  etaAtWarehouse: "ETA at warehouse",
  edd: "EDD",
  etaUnpack: "ETA unpack",
  supplierPortalBannerMessagePaymentPending:
    "Based on <strong>{{incoterm}} Incoterm</strong> the costs must be paid by the buyer. The booking will be confirmed after payment.",
  supplyChainBannerMessagePaymentPending:
    "Based on <strong>{{incoterm}} Incoterm</strong>, the costs must be paid to confirm the booking.",
  originTerminalHandlingCharge: "Origin Terminal Handling Charge",
  destinationTerminalHandlingCharge: "Destination Terminal Handling Charge",
  portOfLoadingPoL: "Port of Loading (PoL)",
  portOfDischargePoD: "Port of Discharge (PoD)",
  movementType: "Movement type",
  freightCharges: "Freight charges",
  payWithCard: "Pay with card",
  notRequired: "Not required",
  paymentWillBeAvailableToTheBuyerSoon: "Payment will be available to the buyer soon.",
  theBuyerHasPaidSuccessfully: "The buyer has paid successfully.",
  thisBookingHasExpiredAndBeenCancelled: "This booking has expired and been cancelled.",
  onceConfirmedThisWillBeSentToTheCarrierYouAreNotAbleToMakeAnyAdditionalChanges:
    "Once confirmed this will be sent to the carrier, you are not able to make any additional changes.",
  payBooking: "Pay booking",
  paidOn: "Paid on",
  noAllocated: "No allocated",
  thisFieldDoesntAllowSpecialCharacters: "This field doesn't allow special characters",
  anErrorOccurredWhileProcessingYourRequestPleaseTryAgainOrContactSupport:
    "An error occurred while processing your request. Please try again or contact support.",
  anErrorOccurredWhileProcessingYourRejectionPleaseTryAgainOrContactSupport:
    "An error occurred while processing your rejection. Please try again or contact support.",
  errorProcessingRejection: "Error processing rejection",
  errorProcessingRequest: "Error processing request",
  areYouAnExistingShipeeziUser: "Are you an existing Shipeezi user?",
  yesGoToLoginPage: "Yes, go to login page",
  noRegisterAsAnAgent: "No, register as an agent",
  selectCompany: "Select Company",
  enterName: "Enter name",
  connect: "Connect",
  anErrorOccurredWhileTryingToConnectTheCompaniesPleaseTryAgainLater:
    "An error occurred while trying to connect the companies. Please try again later.",
  invalidOrExpiredLink: "Invalid or expired link",
  thisInvitationLinkIsInvalidOrHasAlreadyExpiredPleaseContactUsToReceiveANewInvitation:
    "This invitation link is invalid or has already expired. Please contact us to receive a new invitation.",
  paymentPending: "Payment pending",
  processing: "Processing",
  searchFreight: "Search Freight",
  freightBooking: "Freight Booking",
  YourShipeeziID: "Your Shipeezi ID",
  noOfOrders: "No. of orders",
  carriersFound: "Carriers found",
  LowToHigh: "Low to High",
  HighToLow: "High to Low",
  directRoutes: "Direct Routes",
  alternateRoutes: "Alternate Routes",
  alternate: "Alternate",
  direct: "Direct",
  Shipmentno: "Shipment No",
  passwordResetSuccesfully: "Password reset successful",
  frieghtid: "Freight ID",
  passwordRestLinkExpired: "Password reset link has expired",
  valid: "Valid",
  customerIsNotAllowedToReceiveNotification: "Customer is not allowed to receive notifications",
  carbonFootprint: "Carbon Footprint",
  PlaceOfDestination: "Place of Destination",
  advanceShippingNoticeIsRequired: "Advance shipping notice is required",
  weightCantBe0: "Weight can’t be 0",
  shipTermsIsRequired: "Ship terms is required",
  selectOfficeFromTheDropdown: "Select office from the dropdown",
  marksAndNumber: "Marks and Number",
  requiredDocument: "Required Documents",
  supportingDocuments: "Supporting Documents",
  optionalShipmentData: "Optional Shipment Data",
  requiredVolumeConfirmation: "Volume Confirmation is mandatory",
  shipmentsSettings: "Shipments",
  seaTrackingEnabled: "Sea tracking enabled",
  airTrackingEnabled: "Air tracking enabled",
  accessRuleCreatedSuccessfully: "New Access Rule '{{accessRuleName}}' added",
  accessRuleDuplicatedSuccessfully: "New Access Rule '{{accessRuleName}}' added & set as inactive",
  accessRuleInfoViewOnly:
    "This is a system default access rule and cannot be modified. You are welcome to create a new access rule or duplicate as needed.",
  viewGroupAccessRuleTitle: "This access rule is utilized by {{groupCount}} groups",
  accessRuleNameHaveSpecialCharacter:
    "Please use only letters, numbers, and spaces. Special characters are not allowed.",
  updatedPreference: "Data table preference updated!",
  subscriberThatLinkedToOrdersIsNotAllowedToBeDelete:
    "Subscribers linked to orders cannot be deleted!",
  minimumPageSizeGreaterThanTen: "Minimum page size is 10",
  subscriberSuccessfullyAdded: "Subscriber successfully added",
  defaultTeam: "Default Team",
  customTeam: "Custom Team",
  created: "Created",
  noMatchingRecordsFound: "No matching records found",
  tryAdjustingYourFilters: "Try adjusting your filters.",
  noRecordFound: "No record found",
  haveTask: "Have task",
  dontHaveTask: "Don’t have task",
  forContainerOnRow: "For container on row",
  column: "column",
  storeName: "Store Name",
  loadedStatus: "Loaded Status",
  markAsDefault: "Mark as default",
  enterTemplateName: "Enter template name",
  enterSubject: "Enter subject",
  enterFromName: "Enter from name",
  enterStatus: "Enter status",
  enterAvailableIn: "Enter available in",
  enterAutomation: "Enter automation",
  enterLastUpdate: "Enter last update",
  addBusinessIcon: "Add Business Icon",
  addBusinessLogo: "Add Business Logo",
  addIcon: "Add Icon",
  fromName: "From Name",
  formatsJPG_GIF_PNG: "Formats: JPG, GIF, PNG",
  maxSize2MB: "Max size: 2MB",
  attachments: "Attachments",
  pushNotification: "Push Notification",
  salesApp: "Sales App",
  linkedAutomation: "Linked Automation",
  noAutomationsLinked: "No automations linked",
  signup: {
    left: {
      title: "One platform, every move",
      subtitle:
        "Start your free trial and experience how Shipeezi unifies every part of your workflow, from sales to operations to warehousing.",
      card1Title: "Simplicity at scale",
      card1Desc:
        "Shipeezi brings all your processes together in one place, helping your team work smarter and faster across the globe.",
      card2Title: "More control, less cost",
      card2Desc:
        "With everything connected, you'll save time, reduce errors, and cut costs — while giving your customers a seamless experience.",
      trusted: "Trusted by industry leaders worldwide",
    },
    right: {
      createAccount: "Create your account",
      subtitle:
        "You are just moments away of having full visibility and control over your shipments!",
      haveAccount: "Have an account?",
      signIn: "Sign in",
      thankYou: "Thank you for requesting an account with Shipeezi",
      pendingApproval: "Our team will be in contact with you prior to activating your account",

      // Step 2
      step2Title: "Tell us about your business",
      step2Subtitle: "We'll tailor Shipeezi to fit your company's needs",
      companyName: "Company name",
      companyType: "Company type",
      selectYourPlatform: "Select your platform",

      // Step 3
      step3Title: "What would you like to improve with Shipeezi?",
      step3Subtitle: "Choose the areas of your business you want to simplify and scale",
      sales: "Sales",
      operations: "Operations",
      warehousing: "Warehousing",

      // botões genéricos
      next: "Next",
      back: "Back",

      // (para etapas futuras, mas já deixo pronto)
      requestAccount: "Request account",
      termsOfUse: "Terms of Use",
      privacyPolicy: "Privacy Policy",
      and: "and",
      byContinuingYouReAgreeingToShipeeziS: "By continuing, you're agreeing to Shipeezi’s",
      getEmailsFromShipeeziAboutProductUpdatesIndustryNewsAndEventsIfYouChangeYourMindYouCanUnsubscribeAtAnyTime:
        "Get emails from Shipeezi about product updates, industry news, and events. If you change your mind, you can unsubscribe at any time.",
      captchaExpired: "Captcha expired",

      step4Title: "Help us understand your sales process",
      step4Subtitle: "Your answers will help us configure Shipeezi for your team",

      // Questions
      videoSurveysQuestion: "Do you offer video surveys to your customers?",
      salesRepsQuestion: "How many sales representatives does your company have?",
      yes: "Yes",
      no: "No",
      range_1_10: "1-10",
      range_11_20: "11-20",
      range_above_30: "Above 30",

      // Titles/subtitles por área (Step 4)
      salesStepTitle: "Help us understand your sales process",
      salesStepSubtitle: "Your answers will help us configure Shipeezi for your team",

      operationsStepTitle: "Tell us about your operations",
      operationsStepSubtitle: "We’ll set up Shipeezi based on how your company moves today",

      warehousingStepTitle: "Tell us about your warehousing",
      warehousingStepSubtitle:
        "We’ll optimise your warehousing and inventory setup inside Shipeezi",

      // Warehousing
      storageQuestion: "Do you offer storage to your customers?",
      warehousesCountQuestion: "How many warehouses do you manage?",

      // Operations
      shipmentType: "Shipment Type",
      local: "Local",
      international: "International",
      interstate: "Interstate",
      military: "Military",
      annualShipmentVolume: "Annual shipment volume",
      v_1_4: "1-4",
      v_5_600: "5-600",
      v_601_10000: "601 - 10,000",
      v_10001_20000: "10,001 - 20,000",
      v_20001_plus: "20,001 +",

      step5Title: "Awesome! We’re almost done!",
      step5Subtitle: "We’d love to know how you discovered Shipeezi!",

      thankYouV2Title: "Thank you for signing up!",
      thankYouV2Description:
        "Our team will be in touch shortly to activate your account. You’ll then be ready to experience Shipeezi — one platform, every move.",
      returnToWebsite: "Return to our website",

      // Discovery options
      discover: {
        website: "Our Website",
        email: "Email Marketing",
        google: "Google",
        newsletter: "Newsletter",
        aiTools: "AI Tools",
        referral: "Referral",
        whereLabel: "Where?",
        whoReferredLabel: "Who referred you?",
        other: "Other",
      },
      wh_1_10: "1-10",
      wh_11_30: "11-30",
      wh_above_30: "Above 30",
      trustedBy: "Trusted by industry leaders worldwide",
      paymentTerms: "Payment Terms",
      privacyAndCompliance: "Privacy & Compliance Policy",
      saasAgreement: "SAAS Agreement and SLA",
      termsOfSale: "Terms of Sale",
      termsPrefix: "By continuing, you're agreeing to Shipeezi's",
      ownWords: {
        questionLabel: "What are your challenges or obstacles right now?",
        placeholder: "Type something...",
        characters: "characters",
        helperShort: "Your message should be at least 50 characters.",
        helperLong: "Please keep your message under 500 characters.",
      },
    },
  },
  common: {
    close: "Close",
    save: "Save",
    saving: "Saving",
  },
  onboarding: {
    pageTitle: "Onboarding",
    left: {
      title: "Welcome to Shipeezi!\nOne platform, every move",
      subtitle:
        "You're just a few quick steps away from setting up your account. Shipeezi will help you simplify processes, connect your team, and give you full control over every move. Let's get started.",
    },
    steps: {
      introduction: "Introduction",
      companyDetails: "Company Details",
      myBilling: "My Billing",
      members: "Members",
      uploadCentre: "Upload Centre",
      complete: "Complete",
    },
    uploadCentre: {
      title: "Upload Centre",
      description:
        "Here you can upload your own files (like inventory, staff, or service lists) or start with Shipeezi's default list. You can always update this later.",
      uploadOwnList: "Upload my own list",
      uploadOwnListDescription: "Bring in your own data to customise Shipeezi from the start.",
      useDefaultList: "Use Shipeezi's default list (ISO17451-1:2016)",
      useDefaultListDescription:
        "Start quickly with our pre-configured list, built on the global ISO17451-1:2016 standard. You can update or expand it anytime.",
      downloadTemplate: "Download our CSV template here",
      complete: "Complete",
    },
    complete: {
      title: "Welcome to Shipeezi — where visibility, control, and simplicity come together.",
      subtitle: "",
      button: "Get started",
      leftTitle: "Setup complete!",
      leftSubtitle: "You're all set to start managing every move in one platform.",
    },
    buttons: {
      goBackToLogin: "Go back to login",
      skip: "Skip for now",
      downloadCsvTemplate: "Download our CSV template here",
      next: "Next",
      back: "Back",
    },
    introduction: {
      companyDetails:
        "Add your company information, business address, main contact, and email details, so we can set up your account properly.",
      members:
        "Invite your team members and assign the right permissions to give them access where they need it.",
      uploadCentre:
        "Upload your initial information and data so Shipeezi can connect everything seamlessly for you.",
    },
    members: {
      title: "Members",
      description:     "Invite the people who will be using Shipeezi with you. Assign their role and branch so they have the right access from the start. You can always update or add more members later.",
      registeredMembers: "Registered members",
      firstName: "First name",
      lastName: "Last Name",
      email: "Email",
      memberCode: "Member code",
      branch: "Branch",
      mobile: "Mobile",
      accessGroup: "Access group",
      memberType: "Member Type",
      additionalMembers: "Additional members",
      uploadMembers: "Upload members",
      addMembers: "Add members",
      name: "Name",
      group: "Group",
      type: "Type",
      noAdditionalMembers: "No additional members",
      downloadTemplate: "Download template",
      uploadCSV: "Upload CSV",
      addMember: "Add Member",
      userCode: "User code",
    },
    billing: {
      useSameAdmin: 'Use the same “administrator user" details',
      contactName: "Billing Contact Name",
      email: "Email",
      phone: "Phone number",
      address: "Address",
      paymentMethod: "Payment method",
      noPaymentMethod: "No payment method registered",
      addPaymentMethod: "Add a payment method",
      creditCard: "Credit Card",
      nameOnCard: "Name on card",
    },
  },
  notShared: "Not shared",
  partiallyShared: "Partially shared",
  fullyShared: "Fully shared",
  scac: "SCAC",
  inventorySummary: "Inventory summary",
  networkDetails: "DETAILS",
  networkRoles: "ROLES",
  networkWeightAndMeasurements: "WEIGHT AND MEASUREMENTS",
  networkPickup: "PICKUP",
  networkDelivery: "DELIVERY",
  networkGeneralComments: "GENERAL COMMENTS",
  networkActualInventory: "ACTUAL INVENTORY",
  networkQuotedInventory: "QUOTED INVENTORY",
  networkPhotosAndVideos: "PHOTOS & VIDEOS",
  networkDocuments: "DOCUMENTS",
  networkSettingsBannerMessage:
    "Choose the data fields from the section below that you wish to be displayed to the network agent upon task acceptance.",
  failedToSaveNetworkSettings: "Failed to save network settings. Please try again.",
  assignToAnAgent: "Assign to an agent?",
  selectAnAgent: "Select an agent",
  additionalInstructions: "Additional instructions",
  enterAdditionalInstructions: "Enter additional instructions",
  agentName: "Agent name",
  started: "Started",
  taskAddedSuccessfully: "Task added successfully!",
  thisInstructionWillBeVisibleInTheEmailAndTaskView:
    "This instruction will be visible in the Email and Task view.",
  moreJobTypes: "More job types",
  moreTaskTypes: "More task types",
  moreTriggers: "More triggers",
  selectTaskTypes: "Select task types",
  selectOrderTypes: "Select order types",
  selectTriggers: "Select triggers",
  typeCode: "Type code",
  newChecklist: "New checklist",
  enterQuestionHere: "Enter question here",
  responseType: "Response type",
  addLogic: "Add logic",
  shortDescription: "Short description",
  enterDescriptionHere: "Enter description here",
  singleChoiceQuestion: "Single choice question",
  multipleChoiceQuestion: "Multiple choice question",
  inputText: "Input text",
  inputNumber: "Input number",
  selectDate: "Select date",
  addSignature: "Add signature",
  checklistItem: "Checklist item",
  enterOptions: "Enter options",
  option: "Option",
  addQuestion: "Add question",
  defaultState: "Default state",
  taskTypes: "Task Types",
  jobTypes: "Job Types",
  ifAnswer: "If answer",
  is: "is",
  isNot: "is not",
  then: "then",
  enterText: "Enter text",
  enterNumber: "Enter number",
  selectOption: "Select option",
  isLesserThan: "is lesser than",
  isGreaterThan: "is greater than",
  selected: "selected",
  notSelected: "not selected",
  if: "If",
  requireEvidence: "Require evidence",
  askQuestion: "Ask question",
  chooseTheEvidenceThatllBeRequiredWhenThisAnswerIsSelected:
    "Choose the evidence that’ll be required when this answer is selected.",
  youShouldAddAtLeastOneOption: "You should add at least one option.",
  youShouldAddAtLeastTwoOptions: "You should add at least two options.",
  allOptionsShouldHaveAName: "All options should have a name.",
  methodOfPreparation: "Method of Preparation",
  itemCharacteristics: "Item Characteristics",
  highRiskHighValueChecklist: "High Risk/High Value Checklist",
  proGearChecklist: "Pro-Gear Checklist",
  isHighRisk: "Is High Risk",
  notHighRisk: "Not High Risk",
  isProGear: "Is Pro-Gear",
  notProGear: "Not Pro-Gear",
  meChecklistNotDone: "M&E checklist not done",
  unsavedItem: "Unsaved item, save to apply all filters correctly",
  youHaveUnsavedChanges: "You have unsaved changes.",
  doYouWantToSaveBeforeLeaving: "Do you want to save before leaving",
  timezoneIssue: "Timezone issue",
  allQuestionsMustHaveATitleAndAllLogicsFieldsMustBeFilled:
    "All questions must have a title and all logics fields must be filled.",
  areYouSureYouWantToDeleteThisLogic: "Are you sure you want to delete this logic",
  deleteLogic: "Delete Logic",
  atLeastOneOptionIsRequired: "At least one option is required",
  atLeastTwoOptionsAreRequired: "At least two options are required",
  startingNumber: "Starting Number",
  decreaseStartingNumber: "Decrease starting number",
  increaseStartingNumber: "Increase starting number",
  editDescriptionForItem: "Edit description for item",
  itemDescriptionDefaultPlaceholder: "Applies to all items in this inventory",
  defaultManualInventoryItemDescription: "Vide Inventory",
  customerSignature: "Customer signature",
  removalistName: "Removalist name",
  removalistSignature: "Removalist signature",
  removeFile: "Remove file",
  removeInventoryPdf: "Remove inventory PDF",
  removeInventoryPdfConfirmation:
    "The inventory PDF will be removed from this order. Items you already added are not deleted. Continue?",
  viewInventory: "View Inventory",
  noDocumentsHaveBeenAddedYet: "No documents have been added yet",
  templateNameAlreadyExists: "Template name already exists!",
  invalidSystemReportForAvailableIn:
    "One or more system reports are not valid for the selected Available in options.",
  userUploaded: "User uploads",
  systemGenerated: "System uploads",
  uploadFiles: "Upload files",
  orDragAndDropHere: "or drag and drop files here",
  maxFileSizeLimit: "Max file size limit is 25 MB. Accepted formats:",
  quickOrder: "Quick Order",
  createQuickOrder: "Create Quick Order",
  automaticSequenceUnavailableEnterReferenceManually:
    "Automatic sequence is not available. Please enter the reference manually.",
  enableQuickOrder: "Enable Quick Order",
  showOrderReportInManagement: "Show Order Report in Management",
  reportsAvailableForSharingViaOpsApp: "Reports available for sharing via Ops App",
  noReportsAvailableForSharingViaOpsApp: "No reports available for sharing via Ops App",
  opsAppReportsSharingEligibilityHint:
    "Each option only appears in the Ops App when the current task matches the task type and data requirements below.",
  opsAppReportsSharingEligibleTaskTypes: "Eligible task types",
  opsAppReportsSharingRequirement: "Requirement",
  opsAppReportsSharingAnyFinishedTaskType: "Any finished task type",
  opsAppReportsSharingTaskTypePack: "Pack",
  opsAppReportsSharingRequirementFinishedTask: "Task must be finished",
  opsAppReportsSharingRequirementChecklistAnswersOnTask:
    "Checklist must be answered on the current task",
  opsAppReportsSharingRequirementMandatoryMeItems: "Order must include mandatory M&E items",
  opsAppReportsSharingRequirementHighRiskItems: "Order must include high-risk/high-value items",
  opsAppReportsSharingRequirementProGearItems: "Order must include pro-gear items",
  opsAppReportsSharingRequirementPropertyDamage: "Task must have property damage records",
  opsAppReportsSharingRequirementTransshipment:
    "Uplift task must be finished with completed transshipment",
  opsAppReportsSharingRequirementVolumeCalculations: "Task must have volume determination data",
  opsAppReportsSharingRequirementVideoSurveyTask: "Video Survey task must exist on the order",
  opsAppReportsSharingRequirementMotorcycleItems: "Order must include motorcycle/vehicle items",
  opsAppReportsSharingRequirementTvItems: "Order must include TV items",
  orderReport: "Order Report",
  orderAlreadyExists: "Order already exists",
  searchOrAddCustomer: "Search or add customer",
  aCustomerWithSameIdAlreadyExists: "A customer with the same ID already added",
  addANoteAsEvidence: "Add a note as evidence",
  addAPhotoAsEvidence: "Add a photo as evidence",
  displayInDispatchModule: "Display in Dispatch Module",
  leavingTheWarehouse: "Leaving the warehouse",
  leads: "Leads",
  estimates: "Estimates",
  proposal: "Proposal",
  invoicing: "Invoicing",
  creditNotes: "Credit notes",
  expenses: "Expenses",
  claims: "Claims",
  storageBoxUnit: "Storage Box & Unit",
  storageAccount: "Storage Account",
  finance: "Finance",
  packageType: "Package type",
  methodType: "Method type",
  itemInstruction: "Item instruction",
  communicationCentre: "Communication Centre",
  leadSoure: "Lead Soure",
  help: "Help",
  askDumont: "Ask Dumont",
  askEnzo: "Ask Enzo",
  dumontHelpDocumentation: "Help & Documentation",
  dumontSendFeedback: "Send Feedback",
  dumontContactSupport: "Contact Support",
  dumontLearnHowToUseDumont: "Learn how to use Dumont",
  dumontHelpUsImproveDumont: "Help us improve Dumont",
  dumontGetHelpFromTeam: "Get help from our team",
  dumontQuickActions: "Quick Actions",
  dumontContactOurSupport: "Contact our Support",
  dumontGetHelpWithIssues: "Get help with issues and questions",
  dumontSendUsYourFeedback: "Send us your feedback",
  dumontShareThoughtsAndSuggestions: "Share your thoughts and suggestions",
  dumontCommonQuestions: "Common Questions",
  dumontHowToCreateCustomAgent: "How do I create a custom agent?",
  dumontHowToCreateCustomAgentAnswer: "You can create custom agents from the Agents tab in Dumont.",
  dumontWhatCanDumontHelp: "What can Dumont help with?",
  dumontWhatCanDumontHelpAnswer:
    "Dumont can help with quotes, operations, warehousing, and general logistics questions.",
  dumontHowToAccessChatHistory: "How do I access my chat history?",
  dumontHowToAccessChatHistoryAnswer:
    "Open the History tab in the sidebar to see and search past conversations.",
  dumontCanCustomizeAgentCapabilities: "Can I customize agent capabilities?",
  dumontResources: "Resources",
  dumontKnowledgeBase: "Knowledge Base",
  dumontCompleteGuidesAndTutorials: "Complete guides and tutorials",
  dumontSelectAnOption: "Select an option",
  dumontFeedbackHelpsImprove: "Your feedback helps us improve Dumont",
  dumontIssueType: "Issue type",
  dumontSubject: "Subject",
  dumontBriefDescriptionOfIssue: "Brief description of the issue",
  dumontMessage: "Message",
  dumontPleaseDescribeIssueDetail: "Please describe your issue in detail",
  dumontIncludeErrorMessages: "Include any error messages if applicable",
  dumontGotIt: "Got it",
  dumontCancel: "Cancel",
  dumontSendFeedbackButton: "Send feedback",
  dumontSendMessage: "Send message",
  dumontSupportRequestSentSuccessfully: "Your support request was sent successfully",
  dumontFeedbackSentSuccessfully: "Your feedback was sent successfully",
  dumontSearchPlaceholder: "Search...",
  dumontNavigation: "Navigation",
  dumontNewChat: "New chat",
  dumontChats: "Chats",
  dumontNoChatsFound: "No chats found",
  dumontNoRecentChats: "No recent chats",
  dumontAgents: "Agents",
  dumontNoAgentsFound: "No agents found",
  dumontReturnToShipeezi: "Return to Shipeezi",
  dumontHelp: "Help",
  dumontWelcomeMessage:
    "Hi, {{userName}}! I'm Dumont, your AI assistant. How can I help you today?",
  dumontWelcomeMessageBusiness:
    "Hi, {{userName}}! I'm Dumont Business Assistant. I specialize in sales and quotes. How can I assist you?",
  dumontWelcomeMessageOperations:
    "Hi, {{userName}}! I'm Dumont Operations Assistant. I can help with shipments, deliveries, and operations. What do you need?",
  dumontWelcomeMessageWarehousing:
    "Hi, {{userName}}! I'm Dumont Warehousing Assistant. I can help with inventory and warehouse operations. How can I help?",
  dumontDispatchQuickActions: "Quick actions",
  dumontHistory: "History",
  dumontConversationHistory: "Conversation history",
  dumontNoConversationsFound: "No conversations found",
  dumontNoConversationHistory: "No conversation history yet",
  dumontTryDifferentSearchTerm: "Try a different search term",
  dumontStartNewConversation: "Start a new conversation",
  dumontFileTooLarge: "File is too large. Maximum size is 10MB.",
  dumontUnsupportedFileType: "Unsupported file type. Please select TXT, PDF, or DOC/DOCX files.",
  dumontDocumentProcessing:
    "PDF/DOC processing will be available soon. Please use TXT files for now.",
  dumontFileProcessingError: "Error processing file. Please try again.",
  dumontAskDumont: "Ask Dumont",
  dumontAskDumontAnything: "Ask Dumont anything",
  dumontUpload: "Upload",
  dumontUsesAI: "Dumont uses AI. Responses may not always be accurate.",
  dumontCopyConversation: "Copy conversation",
  dumontExportChat: "Export chat",
  dumontClearConversation: "Clear conversation",
  dumontLoadingAgents: "Loading agents...",
  dumontAgentsTitle: "Agents",
  dumontCreateAgent: "Create agent",
  dumontSearchAgents: "Search agents",
  dumontNoAgentsAvailable: "No agents available",
  dumontAgentsAvailableSoon: "Agents will be available soon",
  featureLocked: "Feature locked",
  accountNotHaveAccess: "Your account does not have access to this feature at the moment.",
  reachSupportTeam: "Reach out to our Support team",
  forDetails: " for details.",
  titleFeatureRequestSupport: "Request access to this feature",
  sendRequestSupport: "Send request to Support",
  itLooksLikeYouDontHaveAcessThisFeatureYet:
    "It looks like you don’t have access to this feature yet. If you’d like to use it, please send a request to our Support team.",
  feature: "Feature",
  pleaseDescribeYouIntendUseFeature: "Please describe how you intend to use this feature",
  yourMessageShouldLeast50Characters: "Your message should be at least 50 characters.",
  minCharacters: "Your message must be at least {{count}} characters.",
  maxCharacters: "Your message must not exceed {{count}} characters",
  yourRequestHasBeenSentOurSupportTeam: "Your request has been sent to our Support team",
  TermsConditions: "Terms & Conditions",
  Iso14451: "ISO14451-1:2016",
  // Enzo AI assistant (parity with other locales)
  enzoAgents: "Agents",
  enzoAgentsAvailableSoon: "Agents will be available soon",
  enzoAgentsTitle: "Enzo Agents",
  enzoAskEnzo: "Ask Enzo...",
  enzoAskEnzoAnything: "Ask Enzo anything",
  enzoBriefDescriptionOfIssue: "Brief description of your issue",
  enzoBusinessAssistant: "Business Assistant",
  enzoBusinessAssistantDesc: "Specialized in sales and quotes",
  enzoCalculateShippingCosts: "Calculate shipping costs",
  enzoCalculateShippingCostsDesc:
    "Estimate costs for different shipping methods and destinations",
  enzoCanCustomizeAgentCapabilities: "Can I customize agent capabilities?",
  enzoCanCustomizeAgentCapabilitiesAnswer:
    "Yes! Each agent can be customized to fit your specific workflow. You can adjust their capabilities, set specific parameters, and configure which data sources they have access to.",
  enzoCancel: "Cancel",
  enzoChats: "Chats",
  enzoClearConversation: "Clear conversation",
  enzoComingSoon: "Coming soon...",
  enzoCommonQuestions: "Common Questions",
  enzoCompleteGuidesAndTutorials: "Complete guides and tutorials",
  enzoContactOurSupport: "Contact our support",
  enzoContactSupport: "Contact Support",
  enzoConversationHistory: "Conversation History",
  enzoCopyConversation: "Copy conversation",
  enzoCreateAgent: "Create Agent",
  enzoDefaultResponse:
    "Thank you for reaching out! I'm analyzing your request and will provide the best solution.",
  enzoDispatchFindCustomer: "Find orders by customer name",
  enzoDispatchFindCustomerDesc: "Search for specific orders using customer information",
  enzoDispatchOptimizeRoutes: "Optimize delivery routes",
  enzoDispatchOptimizeRoutesDesc: "Get suggestions for the most efficient delivery routes",
  enzoDispatchQuickActions: "Quick actions for Dispatch",
  enzoDispatchShowTodayOrders: "Show today's dispatch orders",
  enzoDispatchShowTodayOrdersDesc: "Get a summary of all orders scheduled for dispatch today",
  enzoDispatchTrackStatus: "Track order status",
  enzoDispatchTrackStatusDesc: "Check the current status of orders in the system",
  enzoDocumentAttached: "Document attached",
  enzoDocumentProcessing:
    "PDF/DOC processing will be available soon. Please use TXT files for now.",
  enzoExportChat: "Export chat",
  enzoFeedbackHelpsImprove: "Your feedback helps us improve Enzo",
  enzoFeedbackSentSuccessfully:
    "Your feedback has been sent successfully. We appreciate your input!",
  enzoFeedbackType: "Feedback Type",
  enzoFileProcessingError: "Error processing file. Please try again.",
  enzoFileTooLarge: "File is too large. Maximum size is 10MB.",
  enzoFindWarehouseLocations: "Find warehouse locations",
  enzoFindWarehouseLocationsDesc:
    "Discover optimal warehouse locations for your distribution network",
  enzoGetHelpFromTeam: "Get help from our team",
  enzoGetHelpWithIssues: "Get help with any issues or questions",
  enzoGotIt: "Got it",
  enzoHelp: "Help",
  enzoHelpDocumentation: "Help & Documentation",
  enzoHelpUsImproveEnzo: "Help us improve Enzo",
  enzoHistory: "History",
  enzoHowCanIHelpYou: "How can I help you?",
  enzoHowToAccessChatHistory: "How do I access my chat history?",
  enzoHowToAccessChatHistoryAnswer:
    "Click on the History icon in the sidebar to view all your past conversations with Enzo. You can search through your history and resume any previous conversation.",
  enzoHowToCreateCustomAgent: "How do I create a custom agent?",
  enzoHowToCreateCustomAgentAnswer:
    "To create a custom agent, navigate to the Agents section and click on the \"Create New Agent\" button. You can then configure the agent's capabilities and settings according to your needs.",
  enzoIncludeErrorMessages: "Include any error messages or steps to reproduce the issue",
  enzoIssueType: "Issue Type",
  enzoKnowledgeBase: "Knowledge Base",
  enzoLearnHowToUseEnzo: "Learn how to use Enzo effectively",
  enzoLoadingAgents: "Loading agents...",
  enzoLogistics: "Logistics",
  enzoManageInventoryLevels: "Manage inventory levels",
  enzoManageInventoryLevelsDesc: "Get insights on inventory optimization and stock management",
  enzoMessage: "Message",
  enzoNavigation: "Navigation",
  enzoNewChat: "New Chat",
  enzoNoAgentsAvailable: "No agents available",
  enzoNoAgentsFound: "No agents found",
  enzoNoChatsFound: "No chats found",
  enzoNoConversationHistory: "No conversation history",
  enzoNoConversationsFound: "No conversations found",
  enzoNoRecentChats: "No recent chats",
  enzoOperations: "Operations",
  enzoOperationsAssistant: "Operations Assistant",
  enzoOperationsAssistantDesc: "All of your operations expert",
  enzoOptimizeLogisticsOperations: "Optimize my logistics operations",
  enzoOptimizeLogisticsOperationsDesc:
    "Get personalized recommendations to improve efficiency and reduce costs",
  enzoPleaseDescribeIssueDetail: "Please describe your issue in detail...",
  enzoPleaseSelectTextFile: "Please select a text file (.txt)",
  enzoQuickActions: "Quick Actions",
  enzoRemoveDocument: "Remove document",
  enzoResources: "Resources",
  enzoReturnToShipeezi: "Return to Shipeezi",
  enzoSales: "Sales",
  enzoScheduleDeliveries: "Schedule deliveries",
  enzoScheduleDeliveriesDesc: "Plan and optimize delivery routes for maximum efficiency",
  enzoSearchAgents: "Search agents...",
  enzoSearchPlaceholder: "Search chats, agents, history...",
  enzoSelectAnOption: "Select an option",
  enzoSendFeedback: "Send Feedback",
  enzoSendFeedbackButton: "Send Feedback",
  enzoSendMessage: "Send Message",
  enzoSendUsYourFeedback: "Send us your feedback",
  enzoShareThoughtsAndSuggestions: "Share your thoughts and suggestions",
  enzoStartNewConversation: "Start a new conversation to see it here",
  enzoSubject: "Subject",
  enzoSupportRequestSentSuccessfully:
    "Your support request has been sent successfully. Our team will respond within 24 hours.",
  enzoTellUsWhatYouThink: "Tell us what you think...",
  enzoTrackShipmentStatus: "Track shipment status",
  enzoTrackShipmentStatusDesc:
    "Get real-time updates on your shipments and delivery estimates",
  enzoTryDifferentSearchTerm: "Try a different search term",
  enzoUnsupportedFileType:
    "Unsupported file type. Please select TXT, PDF, or DOC/DOCX files.",
  enzoUpload: "Upload",
  enzoUsesAI: "Enzo uses Artificial intelligence. Review the responses.",
  enzoWarehousingAssistant: "Warehousing Assistant",
  enzoWarehousingAssistantDesc: "Inventory and warehouse operations expert",
  enzoWelcomeMessage:
    "Hi, {{userName}}, I'm Enzo, your AI assistant specialized in logistics and moving. Built to simplify complex workflows, I continuously learn to deliver faster, smarter, and more accurate support for your business.",
  enzoWelcomeMessageBusiness:
    "Hi, {{userName}}, I'm Enzo Business Assistant! 💼 I specialize in sales and quotes. I can help you create accurate freight quotes, manage customer relationships, and close deals faster. How can I assist you today?",
  enzoWelcomeMessageOperations:
    "Hi, {{userName}}, I'm Enzo Operations Assistant! 📊 I'm your operations expert. I can help you track shipments, monitor deliveries, manage jobs, and ensure smooth logistics operations. What do you need help with?",
  enzoWelcomeMessageWarehousing:
    "Hi, {{userName}}, I'm Enzo Warehousing Assistant! 🏭 I specialize in inventory and warehouse operations. I can help you manage stock levels, track inventory, coordinate storage, and optimize warehouse efficiency. How can I help?",
  enzoWhatCanEnzoHelp: "What can Enzo help me with?",
  enzoWhatCanEnzoHelpAnswer:
    "Enzo is your AI assistant specialized in logistics and moving. I can help you with dispatch planning, order management, route optimization, and answering questions about your operations.",
  enzoWhatCanIHelpYouWith: "What can I help you with?",
  enzoYourFeedback: "Your Feedback",
  Iso17451: "ISO17451 - 1:2016",
  dumontConversationHistory: "Conversation History",
  dumontNoConversationHistory: "No conversation history",
  dumontStartNewConversation: "Start a new conversation to see it here",
  dumontAgentsTitle: "Dumont Agents",
  dumontCreateAgent: "Create Agent",
  dumontSearchAgents: "Search agents...",
  dumontComingSoon: "Coming soon...",
  dumontBusinessAssistant: "Business Assistant",
  dumontBusinessAssistantDesc: "Specialized in sales and quotes",
  dumontOperationsAssistant: "Operations Assistant",
  dumontOperationsAssistantDesc: "All of your operations expert",
  dumontWarehousingAssistant: "Warehousing Assistant",
  dumontWarehousingAssistantDesc: "Inventory and warehouse operations expert",
  dumontAskDumont: "Ask Dumont...",
  dumontUsesAI: "Dumont uses Artificial intelligence. Review the responses.",
  dumontLearnHowToUseDumont: "Learn how to use Dumont effectively",
  dumontContactOurSupport: "Contact our support",
  dumontGetHelpWithIssues: "Get help with any issues or questions",
  dumontHowToCreateCustomAgentAnswer:
    'To create a custom agent, navigate to the Agents section and click on the "Create New Agent" button. You can then configure the agent\'s capabilities and settings according to your needs.',
  dumontWhatCanDumontHelp: "What can Dumont help me with?",
  dumontWhatCanDumontHelpAnswer:
    "Dumont is your AI assistant specialized in logistics and moving. I can help you with dispatch planning, order management, route optimization, and answering questions about your operations.",
  dumontHowToAccessChatHistoryAnswer:
    "Click on the History icon in the sidebar to view all your past conversations with Dumont. You can search through your history and resume any previous conversation.",
  dumontCanCustomizeAgentCapabilitiesAnswer:
    "Yes! Each agent can be customized to fit your specific workflow. You can adjust their capabilities, set specific parameters, and configure which data sources they have access to.",
  dumontFeedbackType: "Feedback Type",
  dumontYourFeedback: "Your Feedback",
  dumontTellUsWhatYouThink: "Tell us what you think...",
  dumontSendFeedbackButton: "Send Feedback",
  dumontIssueType: "Issue Type",
  dumontBriefDescriptionOfIssue: "Brief description of your issue",
  dumontPleaseDescribeIssueDetail: "Please describe your issue in detail...",
  dumontIncludeErrorMessages: "Include any error messages or steps to reproduce the issue",
  dumontSendMessage: "Send Message",
  dumontSupportRequestSentSuccessfully:
    "Your support request has been sent successfully. Our team will respond within 24 hours.",
  dumontFeedbackSentSuccessfully:
    "Your feedback has been sent successfully. We appreciate your input!",
  dumontPleaseSelectTextFile: "Please select a text file (.txt)",
  dumontDocumentAttached: "Document attached",
  dumontRemoveDocument: "Remove document",
  dumontDefaultResponse:
    "Thank you for reaching out! I'm analyzing your request and will provide the best solution.",
  dumontSales: "Sales",
  dumontOperations: "Operations",
  dumontLogistics: "Logistics",
  thisLinkIsNotValidPleaseCheckIfYouHaveAccessedTheCorrectLink:
    "This link is not valid. Please check if you have accessed the correct link.",
  youCanSafelyCloseThisWindowNowIfYouNeedAnyFurtherAssistanceFeelFreeToReachOutHaveAGreatDay:
    "You can safely close this window now. If you need any further assistance, feel free to reach out. Have a great day!",
  anErrorOccurredWhileProcessingYourRequestPleaseTryAgainOrContactSupport:
    "An error occurred while processing your request. Please try again or contact support.",
  anErrorOccurredWhileProcessingYourRejectionPleaseTryAgainOrContactSupport:
    "An error occurred while processing your rejection. Please try again or contact support.",
  anErrorOccurredWhileTryingToConnectTheCompaniesPleaseTryAgainLater:
    "An error occurred while trying to connect the companies. Please try again later.",
  thisInvitationLinkIsInvalidOrHasAlreadyExpiredPleaseContactUsToReceiveANewInvitation:
    "This invitation link is invalid or has already expired. Please contact us to receive a new invitation.",
  networkSettingsBannerMessage:
    "Choose the data fields from the section below that you wish to be displayed to the network agent upon task acceptance.",
  thisInstructionWillBeVisibleInTheEmailAndTaskView:
    "This instruction will be visible in the Email and Task view.",
  chooseTheEvidenceThatllBeRequiredWhenThisAnswerIsSelected:
    "Choose the evidence that’ll be required when this answer is selected.",
  allQuestionsMustHaveATitleAndAllLogicsFieldsMustBeFilled:
    "All questions must have a title and all logics fields must be filled.",
  // Dumont Dispatch Prompts
  dumontDispatchShowTodayOrders: "Show today's dispatch orders",
  dumontDispatchShowTodayOrdersDesc: "Get a summary of all orders scheduled for dispatch today",
  dumontDispatchFindCustomer: "Find orders by customer name",
  dumontDispatchFindCustomerDesc: "Search for specific orders using customer information",
  dumontDispatchTrackStatus: "Track order status",
  dumontDispatchTrackStatusDesc: "Check the current status of orders in the system",
  dumontDispatchOptimizeRoutes: "Optimize delivery routes",
  dumontDispatchOptimizeRoutesDesc: "Get suggestions for the most efficient delivery routes",
  dumontDispatchQuickActions: "Quick actions for Dispatch",
  dumontWelcomeMessage:
    "Hi, {{userName}}, I'm Dumont, your AI assistant specialized in logistics and moving. Built to simplify complex workflows, I continuously learn to deliver faster, smarter, and more accurate support for your business.",
  dumontWelcomeMessageBusiness:
    "Hi, {{userName}}, I'm Dumont Business Assistant! 💼 I specialize in sales and quotes. I can help you create accurate freight quotes, manage customer relationships, and close deals faster. How can I assist you today?",
  dumontWelcomeMessageOperations:
    "Hi, {{userName}}, I'm Dumont Operations Assistant! 📊 I'm your operations expert. I can help you track shipments, monitor deliveries, manage jobs, and ensure smooth logistics operations. What do you need help with?",
  dumontWelcomeMessageWarehousing:
    "Hi, {{userName}}, I'm Dumont Warehousing Assistant! 🏭 I specialize in inventory and warehouse operations. I can help you manage stock levels, track inventory, coordinate storage, and optimize warehouse efficiency. How can I help?",
  // Dumont Fullscreen Sidebar
  dumontSearchPlaceholder: "Search chats, agents, history...",
  dumontNewChat: "New Chat",
  dumontWhatCanIHelpYouWith: "What can I help you with?",
  dumontOptimizeLogisticsOperations: "Optimize my logistics operations",
  dumontOptimizeLogisticsOperationsDesc:
    "Get personalized recommendations to improve efficiency and reduce costs",
  dumontTrackShipmentStatus: "Track shipment status",
  dumontTrackShipmentStatusDesc: "Get real-time updates on your shipments and delivery estimates",
  dumontCalculateShippingCosts: "Calculate shipping costs",
  dumontCalculateShippingCostsDesc:
    "Estimate costs for different shipping methods and destinations",
  dumontFindWarehouseLocations: "Find warehouse locations",
  dumontFindWarehouseLocationsDesc:
    "Discover optimal warehouse locations for your distribution network",
  dumontManageInventoryLevels: "Manage inventory levels",
  dumontManageInventoryLevelsDesc: "Get insights on inventory optimization and stock management",
  dumontScheduleDeliveries: "Schedule deliveries",
  dumontScheduleDeliveriesDesc: "Plan and optimize delivery routes for maximum efficiency",
  dumontHowCanIHelpYou: "How can I help you?",
  invalidFileType: "Invalid file type",
  uploadFailed: "Upload failed",
  tooManyFiles: "Too many files",
  filesExceedSizeLimit: "Files exceed size limit",
  allFilesUploadedSuccessfully: "All files uploaded successfully",
  moreBranches: "More branches",
  fileSizeIsTooLarge: "File is bigger than 2MB",
  maximum10FilesPerUpload: "Maximum 10 files per upload.",
  generate: "Generate",
  onCSVWeHaveFoundSomeErrors:
    "On <strong>{{csvFileName}}</strong> csv, we have found some errors. You should adjust those lines to proceed:",
  weReSecurelyLoadingYourDataIntoShipeeziSCertifiedFramework:
    "We’re securely loading your data into Shipeezi’s certified framework.",
  weFoundSomeIssuesInYourCSV:
    "We found some issues in your “{{csvFileName}}”. Please fix these lines before continuing:",
  needHelp: "Need help?",
  forTheCorrectFormat: "for the correct format.",
  noScreenshotsCaptured: "No screenshots captured",
  noParticipantsAvailable: "No participants available",
  companySlug: "Company slug",
  aUniqueIDUsedToIdentifyThisOrganization: "A unique ID used to identify this organization",
  propertyDamageReport: "Property damage report",
  optional: "Optional",
  photoRequiredAtUpliftCompletion: "Photo required at Uplift completion",
  customerPhoneNumber: "Customer phone number",
  alternativePhone: "Alternative phone",
  alternativeEmail: "Alternative email",
  mailingAddress: "Mailing address",
  customerFields: "Customer fields",
  requireCustomerInformationFields: "Require customer information fields",
  customerFieldsWillBeRequired: "Customer fields will be required",
  selectMadatory: "Select mandatory",
  military: "Military",
  templateType: "Template type",
  assignedTemplate: "Assigned template",
  packingList: "Packing list",
  billOfLading: "Bill of lading",
  inventoryReport: "Inventory report",
  shippingManifest: "Shipping manifest",
  deliveryReceipt: "Delivery receipt",
  customsDeclaration: "Customs declaration",
  saveTemplates: "Save templates",
  shipeeziDefault2: "Shipeezi Default",
  clientCustomTemplate: "Client Custom Template",
  customTemplate: "Custom Template",
  reportTemplates: "Report Templates",
  defineWhichTemplateEachReportUses:
    "Define which template each report uses. Templates are saved per company and only visible to Military accounts. Identify whether each report uses the Shipeezi default template or a client-provided custom template.",
  accessToThisSectionIsRestrictedByPermissionLevel:
    "Access to this section is restricted by permission level. Changes are saved per company and hidden from Commercial accounts.",
  customerPortalAddress: "Customer Portal Address",
  definesLinkYourCustomerWillUse: "Defines the link your customers will use to track orders and view shipment details",
  thisSubdomainIsNotAvailablePleaseChooseADifferentOne:
    "This subdomain is not available. Please choose a different one.",
  maximum10FilesPerUpload: "Maximum 10 files per upload.",
  fileIsTooBig: "File is too big. Maximum file size is 25 MB",
  multiFactorAuthentication: "Multi-Factor Authentication",
  mfaMultiFactorAuthentication: "Multi-Factor Authentication",
  configureMfaSettingsPerGroup: "Configure MFA settings per group",
  mfaSettings: "MFA Settings",
  enableMfa: "Enable MFA",
  mfaEnabled: "MFA Enabled",
  mfaDisabled: "MFA Disabled",
  authenticationMethod: "Authentication Method",
  selectMethod: "Select method",
  environments: "Environments",
  enabledEnvironments: "Enabled environments",
  web: "Web",
  operationsApp: "Operations App",
  salesApp: "Sales App",
  savingMfaSettings: "Saving MFA settings...",
  mfaSettingsUpdated: "MFA settings updated successfully",
  errorUpdatingMfaSettings: "Error updating MFA settings",
  noGroupsFound: "No groups found",
  mfaVerificationTitle: "Enter verification code",
  mfaVerificationDescription: "A verification code has been sent to:",
  mfaVerificationCode: "Verification code",
  verify: "Verify",
  resendCode: "Resend code",
  resendViaEmail: "Resend via Email",
  resendViaSms: "Resend via SMS",
  mfaCodeResent: "Verification code resent successfully",
  errorResendingCode: "Error resending code. Please try again.",
  invalidCode: "Invalid code. Please try again.",
  codeExpired: "Code expired",
  expiresIn: "Expires in",
  email: "Email",
  sms: "SMS",
  smsRequiresPhoneNumber: "SMS Requires Phone Number",
  activeLoginSessions: "Active Login Sessions",
  operating_system: "Operating System",
  application: "Application",
  shipeezi_platform: "Shipeezi Platform",
  ip_address: "IP Address",
  last_active_date: "Last Active",
  maximum10FilesPerUpload: "Maximum 10 files per upload.",
  youHaveToSelectAtLeastOnePlatform: "You have to select at least one platform",
  prohibitSimultaneousLogin: "Prohibit simultaneous login",
  prohibitSimultaneousLoginDescription:
    "Prevent users from being logged in on multiple devices or platforms at the same time",
  applyToPlatforms: "Apply to platforms",
  selectEquipmentType: "Select equipment type",
  infoMessageEquipmentTypeFilterTitle: "This filter is optional.",
  infoMessageEquipmentTypeFilterNoSelection: "No selection → report includes all equipment types.",
  infoMessageEquipmentTypeFilterSpecificType:
    "Specific type selected → report includes only tasks with that type.",
  infoMessageEquipmentTypeFilterNoTasks:
    "No tasks for the selected type → report shows no results.",
  dateFormat: "Date format",
  timeFormat: "Time format",
  accountPreferences: "Account preferences",
  navigation: "NAVIGATION",
  defaultTemplate: "Default Template",
  originFile: "Origin File",
  templateContent: "Template Content",
  onboardingTrigger: "Onboarding",
  signupTrigger: "Signup",
  offboarding: "Offboarding",
  sendViaVideoSurveyLink: "Send via video survey link",
  sendANewInvitationToTheScheduleVideoSurvey: "Send a new invitation to the scheduled video survey",
  thereIsNoActiveVideoSurvey: "There is no active video survey.",
  videoSurveyLinkSentToCustomer: "Video survey link sent to customer",
  videoSurveyLinkSendFailed: "Video survey link send failed",
  plainText: "Plain Text",
  header: "Header",
  copyrightText: "Copyright Text",
  shipeeziBranding: "Shipeezi Branding",
  addPreApprovalItem: "Add pre-approval item",
  removePreApprovalItem: "Remove item",
  pleaseFillAllPreApprovalFields:
    "Fill the pre-approval description for each row.",
  scheduleSend: "Schedule send",
  sendDate: "Send date",
  sendTime: "Send time",
  selectAnUser: "Select an user",
  currentShipByDate: "Current Ship By Date",
  originalShipByDate: "Original Ship By Date",
  branding: "Branding",
  legal: "Legal",
  localization: "Localization",
  unitSystem: "Unit system",
  servicesAndTariffs: "Services and Tariffs",
  dumontYou: "You",
  dumontSending: "Sending…",
  dumontTypeAMessage: "Type a message...",
  dumontThankYou: "Thank You!",
  dumontConnectionError: "There was a problem contacting Ask Dumont. Please try again later.",
  dumontUnableToConnect: "Unable to connect to Ask Dumont.",
  dumontNoMessagesToCopy: "No messages to copy",
  dumontConversationCopied: "Conversation copied to clipboard",
  dumontFailedToCopyConversation: "Failed to copy conversation",
  dumontNoMessagesToExport: "No messages to export",
  dumontChatExportedSuccessfully: "Chat exported successfully",
  dumontFailedToExportChat: "Failed to export chat",
  dumontNoMessagesToClear: "No messages to clear",
  dumontConversationCleared: "Conversation cleared",
  dumontOpenInNewWindow: "Open Dumont AI in a new window",
  dumontCloseShortcut: "Click or press ⌘K to close Dumont AI",
  wouldYouLikeToSendAnInviteToAgentName: "Would you like to send an invite to {{agentName}} to join your Shipeezi network?",
  selectAtLeastOneItem: "Select at least one item",
  shipmentNotFound: "Shipment not found",
  expensesRecalculatedSuccessfully: "Expenses recalculated successfully",
  reconnecting: "Reconnecting",
  pleaseSelectAFile: "Please select a file!",
  commentsSavedSuccessfully: "Comments saved successfully",
  couldNotSaveComments: "Could not save comments",
  anErrorOccurred: "An error occurred",
  unknownError: "Unknown error",
  newNotification: "New Notification",
  externalAgentAssignmentInfo:
    "You are assigned to an external agent, who will receive an email invitation to accept or reject the assignment. If there is no response, the system will send reminder emails for three days. If the agent does not respond within this period, the task will be automatically canceled.",
  unitOfMeasure: "Unit of Measure (UoM)",
  pieces: "Pieces",
  boxes: "Boxes",
  pairs: "Pairs",
  sets: "Sets",
  pallets: "Pallets",
  removeShipmentFromOrder: "Remove Shipment from Order",
  thisShipmentHasNoOtherOrdersAssociated:
    "This shipment has no other orders associated. What would you like to do with it?",
  revertToDraft: "Revert to Draft",
  leaveAsDraft: "Leave as Draft",
  customerLogo: "Customer Logo",
  showLastFinishedTasks: "Show last 5 finished tasks",
  MB: "MB",
  "Search...": "Search...",
  activate: "activate",
  inactivate: "inactivate",
  cancelButton: "Cancel",
  cereLifeLocalAmount: "CereLife local amount",
  commercial: "Commercial",
  confirmDelete: "Delete",
  confirmation: "Confirmation",
  containerId: "Container ID",
  createANewPort: "Create a new port",
  customerLastName: "Customer last name",
  customerPhone: "Customer phone",
  dateCannotBeInThePast: "Date cannot be in the past",
  decimalPlaces: "Decimal places",
  deleteData: "Delete data",
  deletePlaceholderTask: "Delete placeholder task",
  editPort: "Edit port",
  emailIsInvalid: "Email is invalid",
  errorFetchingTriggers: "Error fetching triggers",
  errorLoadingTemplates: "Error loading templates",
  errorReadingFile: "Error reading file",
  errorUpdatingTemplate: "Error updating template",
  errorUploadingFile: "Error uploading file",
  errorValidatingTemplateName: "Error validating template name",
  inAMoment: "in a moment",
  invalidDateTime: "Invalid date and time",
  invalidTimeFormat: "Invalid time format",
  inviteAgent: "Invite agent",
  invoicedAmount: "Invoiced amount",
  iso174511Description:
    "Use Shipeezi's default inventory list certified to ISO17451-1:2016. You can update or expand it anytime.",
  itShouldBeAtLeastOneBranch: "There should be at least one branch",
  itShouldHaveLeastOneBranch: "You must have at least one branch",
  "label.item.packaging": "Item packaging",
  last: "Last",
  loadingLocations: "Loading locations...",
  militaryReportsDescription: "Configure report templates for military accounts.",
  noInformationToBeShwon: "No information to be shown",
  noLinkedAutomationsFound: "No linked automations found",
  noReports: "No reports",
  only: "Only",
  operationFailed: "Operation failed",
  origins: "Origins",
  picture: "Picture",
  pictures: "Pictures",
  pushCharacterLimitExceeded: "Push notification character limit exceeded",
  scheduledTimeCannotBeInThePast: "Scheduled time cannot be in the past",
  seconds: "seconds",
  selectAContainerNumber: "Select a container number",
  selectAtLeastOneTarget: "Select at least one target",
  selectOptions: "Select options",
  sending: "Sending",
  shipeeziDefaultTemplate: "Shipeezi default template",
  shipmentInformation: "Shipment information",
  smsCharacterLimitExceeded: "SMS character limit exceeded",
  someFilesFailedToUpload: "Some files failed to upload",
  taskUnpublishedCannotBeEdited: "Unpublished tasks cannot be edited",
  theLimitOfLinesIs: "The limit of lines is",
  thisCustomerDoesNotHaveAnEmailToSendInvitation: "This customer does not have an email to send the invitation",
  thisFieldIsNumber: "This field must be a number",
  uploadCategories: "Upload categories",
  uploadCategoriesDescription: "Upload your category list to get started.",
  uploadCentreDescription:
    "Here you can upload your own files (like inventory, staff, or service lists) or start with Shipeezi's default list. You can always update this later.",
  useShipeeziSDefaultListDescription:
    "Start quickly with our pre-configured list, built on the global ISO17451-1:2016 standard. You can update or expand it anytime.",
  url: "URL",
  v: "V",
  youCannotInviteInactiveCustomers: "You cannot invite inactive customers",
  youDontHavePermissionToAccessShipmentData: "You don't have permission to access shipment data",
  youHaveToAddAtLeastOneOrder: "You have to add at least one order",
  youMustEnterAAgentId: "You must enter an agent ID",
  youMustHaveAtLeastOneContact: "You must have at least one contact",
  youMustHaveAtLeastOnePrimaryContact: "You must have at least one primary contact",
  yourPasswordMustBeAtLeast6CharactersLong: "Your password must be at least 6 characters long",
  memberCode: "Member code",
  uploadOwnListDescription: "Bring in your own data to customise Shipeezi from the start.",
  downloadCsvTemplate: "Download our CSV template here",
  commentCharactersCount: '{{count}}/{{limit}} characters',
  commentLimitApproaching: 'You are approaching the maximum comment length.',
  commentLimitReached: 'The comment has reached the maximum allowed length.',
  weightOrVolume: "Weight or Volume",
  commercialInvoiceCountryOfOriginHelperText: "This field should reflect the manufacturer's country. If the Supplier, Exporter, and Manufacturer are different, please ensure the correct country is selected.",
  completeCommercialInvoiceBeforeCreateSSCC:
    "Please complete all required Commercial Invoice fields before creating an SSCC.",
};
